webpackJsonp([32],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return endpoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);





var extractPagination = function extractPagination(_ref) {
  var headers = _ref.headers;

  if (!headers['x-page']) {
    return null;
  }
  return {
    nextPage: parseInt(headers['x-next-page'], 10),
    offset: parseInt(headers['x-offset'], 10),
    page: parseInt(headers['x-page'], 10),
    perPage: parseInt(headers['x-per-page'], 10),
    total: parseInt(headers['x-total'], 10),
    totalPages: parseInt(headers['x-total-pages'], 10)
  };
};

var authorization = function authorization() {
  var token = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.getJSON('authorization') || {};
  var result = {};
  var authorization = [token.token_type, token.access_token].filter(function (e) {
    return e;
  }).join(' ');
  var platformToken = token.platform_token;
  if (authorization) {
    result.Authorization = authorization;
  }
  if (platformToken) {
    result.PlatformToken = platformToken;
  }
  return result;
};

var factory = function factory() {
  var baseURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : endpoint("api");

  var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    baseURL: baseURL,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
  instance.interceptors.request.use(function (config) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config, {
      headers: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config.headers, authorization())
    });
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
  instance.interceptors.response.use(function (response) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response, { pagination: extractPagination(response) });
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
  return instance;
};

var endpoint = function endpoint(prefix) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { protocol: 'https' },
      _ref2$protocol = _ref2.protocol,
      protocol = _ref2$protocol === undefined ? 'https' : _ref2$protocol;

  return protocol + '://' + prefix + '.' + "liveconsult.io";
};

/* harmony default export */ __webpack_exports__["a"] = (factory);

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_default__ = __webpack_require__(35);






/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  var _extends2;

  return {
    props: {
      page: {
        type: Number,
        default: 1
      }
    },
    data: function data() {
      return {
        loading: false
      };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
      collection: store + '/collection',
      pages: store + '/pages'
    }), (_extends2 = {
      pageKey: function pageKey() {
        return this.generatePageKey(this.filter);
      },
      currentPage: function currentPage() {
        return this.pages[this.pageKey] || {};
      }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, store.split('/').reverse()[0], function () {
      var _this = this;

      return (this.currentPage.list || []).map(function (id) {
        return _this.collection[id];
      });
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'pagination', function pagination() {
      return this.currentPage.pagination || {};
    }), _extends2)),
    watch: {
      filter: function filter(newValue, oldValue) {
        var codedNewValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.generatePageKey(newValue));
        var codedOldValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.generatePageKey(oldValue));
        if (codedNewValue === codedOldValue) {
          return;
        }
        this.fetchPage();
      }
    },
    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
      _fetchPage: store + '/fetchPerPage'
    }), {
      generatePageKey: function generatePageKey(filter) {
        var query = filter || { page: this.page };
        return __WEBPACK_IMPORTED_MODULE_4__utils_default__["a" /* default */].dataToUrlString(query);
      },
      fetchPage: function fetchPage() {
        var _this2 = this;

        this.loading = true;
        this._fetchPage(this.filter).then(function (_) {
          if (_this2.urlParams) {
            _this2.$router.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.$route, {
              query: __WEBPACK_IMPORTED_MODULE_4__utils_default__["a" /* default */].dataForUrl(_this2.urlParams(_this2.filter))
            }));
          }
        }).then(function (_) {
          return _this2.$emit('filterUpdated', _this2.filter);
        }).then(function (_) {
          return _this2.loading = false;
        }).catch(function (_) {
          return _this2.loading = false;
        });
      },
      changePage: function changePage(page) {
        this.filter = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.filter, { page: page });
      }
    }),
    mounted: function mounted() {
      this.fetchPage(this.filter);
    }
  };
});

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/api/service.js
var service = __webpack_require__(91);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/previews/Offer.vue




/* harmony default export */ var Offer = ({
  components: {
    Price: formatters["d" /* Price */]
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    url: function url() {
      if (!this.value.url) {
        return null;
      }
      return service["a" /* default */].isOfferType(this.value.service_type) ? this.value.url : this.value.url.replace('/o/', '/p/');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6863c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/previews/Offer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-4",attrs:{"horizontal":""}},[(_vm.value.picture && _vm.value.picture.normal)?_c('v-card-row',{attrs:{"img":_vm.value.picture.normal,"height":"200px"}}):_vm._e(),_vm._v(" "),_c('v-card-column',[_c('v-card-row',[_c('v-card-text',[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.value.subtitle || _vm.value.title))]),_vm._v(" "),(_vm.value.price)?[_vm._v("\n            -\n            "),_c('price',{attrs:{"value":_vm.value.price}})]:_vm._e()],2),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.value.description.short))])])],1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"flat":"","tag":"a","href":_vm.url,"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.$t('messenger.previews.offer.action'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var previews_Offer = (esExports);
// CONCATENATED MODULE: ./src/components/messenger/previews/Offer.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Offer,
  previews_Offer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var messenger_previews_Offer = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(40);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__(26);
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./src/utils/http.js
var http = __webpack_require__(11);

// CONCATENATED MODULE: ./src/api/upload.js



var upload_resize = function resize(path) {
  return Object(http["a" /* default */])(Object(http["b" /* endpoint */])("upload.api")).post('/resize', { key: path });
};

var parameterize = function parameterize(value) {
  return encodeURIComponent(value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''));
};

var upload_uploadUrl = function uploadUrl(file, path, platform) {
  var params = {
    path: ['platforms', platform.id, path].filter(function (e) {
      return e;
    }).join('/')
  };
  if (file) {
    params['file_name'] = parameterize(file.name);
    params['file_type'] = encodeURIComponent(file.type);
  }
  return Object(http["a" /* default */])(Object(http["b" /* endpoint */])("upload.api")).post('/', params);
};

var upload_uploadToUrl = function uploadToUrl(request, file) {
  return new promise_default.a(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.onprogress = function (xhr, progress) {
      return console.log(progress);
    };
    xhr.open('PUT', request.signed_request);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve({
            url: request.url,
            name: file.name,
            type: file.type
          });
        } else {
          reject(xhr);
        }
      }
    };
    xhr.send(file);
  });
};

var send = function send(_ref) {
  var file = _ref.file,
      platform = _ref.platform,
      _ref$path = _ref.path,
      path = _ref$path === undefined ? null : _ref$path;
  return upload_uploadUrl(file, path, platform).then(function (_ref2) {
    var data = _ref2.data;
    return upload_uploadToUrl(data, file);
  }).then(function (data) {
    return upload_resize(data.url);
  });
};

/* harmony default export */ var upload = ({
  send: send
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Attachment.vue





/* harmony default export */ var Attachment = ({
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    directory: {
      type: String,
      required: true
    }
  },
  computed: Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform'
  }),
  data: function data() {
    return {
      loading: false,
      attachments: [].concat(toConsumableArray_default()(this.value)).filter(function (x) {
        return x;
      })
    };
  },

  watch: {
    attachments: function attachments() {
      this.$emit('input', [].concat(toConsumableArray_default()(this.attachments)));
    }
  },
  methods: {
    remove: function remove(i) {
      var newArray = [].concat(toConsumableArray_default()(this.attachments));
      newArray.splice(i, 1);
      this.attachments = newArray;
    },
    handleFileChange: function handleFileChange(event) {
      var _this = this;

      var file = event.currentTarget.files[0];
      this.loading = true;
      upload.send({
        file: file,
        platform: this.platform,
        path: this.directory
      }).then(function (_ref) {
        var data = _ref.data;

        _this.attachments = [].concat(toConsumableArray_default()(_this.attachments), [{
          url: data.url,
          filename: file.name
        }]);
        _this.loading = false;
      }).catch(function (_) {
        return _this.loading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c19596","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Attachment.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',_vm._l((_vm.attachments),function(attachment,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n          "+_vm._s(attachment.filename)+"\n        ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.remove(i)}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)}),1),_vm._v(" "),(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_c('input',{attrs:{"type":"file"},on:{"change":_vm.handleFileChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var inputs_Attachment = (esExports);
// CONCATENATED MODULE: ./src/components/inputs/Attachment.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Attachment,
  inputs_Attachment,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_inputs_Attachment = (Component.exports);

// CONCATENATED MODULE: ./src/mixins/input.js
/* harmony default export */ var mixins_input = ({
  props: {
    value: {},
    config: {
      type: Object,
      default: function _default() {}
    }
  },
  methods: {
    emit: function emit(value) {
      this.$emit('input', value);
    },
    haveErrors: function haveErrors() {
      var _this = this;

      if (!this.config.errors) {
        return false;
      }
      return this.config.errors.map(function (validator) {
        return validator(_this.value);
      }).filter(function (error) {
        return error;
      }).length > 0;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/AvailabilityType.vue



/* harmony default export */ var AvailabilityType = ({
  mixins: [mixins_input],
  computed: {
    availabilities: function availabilities() {
      var _this = this;

      return ['chat'].map(function (e) {
        return { code: e, name: _this.$t('inputs.availabilitytype.types.' + e) };
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7541480","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/AvailabilityType.vue
var AvailabilityType_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.availabilities,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var AvailabilityType_staticRenderFns = []
var AvailabilityType_esExports = { render: AvailabilityType_render, staticRenderFns: AvailabilityType_staticRenderFns }
/* harmony default export */ var inputs_AvailabilityType = (AvailabilityType_esExports);
// CONCATENATED MODULE: ./src/components/inputs/AvailabilityType.vue
var AvailabilityType_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var AvailabilityType___vue_template_functional__ = false
/* styles */
var AvailabilityType___vue_styles__ = null
/* scopeId */
var AvailabilityType___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AvailabilityType___vue_module_identifier__ = null
var AvailabilityType_Component = AvailabilityType_normalizeComponent(
  AvailabilityType,
  inputs_AvailabilityType,
  AvailabilityType___vue_template_functional__,
  AvailabilityType___vue_styles__,
  AvailabilityType___vue_scopeId__,
  AvailabilityType___vue_module_identifier__
)

/* harmony default export */ var components_inputs_AvailabilityType = (AvailabilityType_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Boolean.vue



/* harmony default export */ var inputs_Boolean = ({
  mixins: [mixins_input],
  data: function data() {
    return {
      booleanValue: this.value === true
    };
  },

  watch: {
    booleanValue: function booleanValue() {
      this.emit(this.booleanValue);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-594633e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Boolean.vue
var Boolean_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config.as === 'switch')?_c('v-switch',{attrs:{"required":_vm.config.required,"label":_vm.config.label,"dark":""},model:{value:(_vm.booleanValue),callback:function ($$v) {_vm.booleanValue=$$v},expression:"booleanValue"}}):_c('v-checkbox',{attrs:{"required":_vm.config.required,"label":_vm.config.label,"dark":""},model:{value:(_vm.booleanValue),callback:function ($$v) {_vm.booleanValue=$$v},expression:"booleanValue"}})}
var Boolean_staticRenderFns = []
var Boolean_esExports = { render: Boolean_render, staticRenderFns: Boolean_staticRenderFns }
/* harmony default export */ var components_inputs_Boolean = (Boolean_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Boolean.vue
var Boolean_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Boolean___vue_template_functional__ = false
/* styles */
var Boolean___vue_styles__ = null
/* scopeId */
var Boolean___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Boolean___vue_module_identifier__ = null
var Boolean_Component = Boolean_normalizeComponent(
  inputs_Boolean,
  components_inputs_Boolean,
  Boolean___vue_template_functional__,
  Boolean___vue_styles__,
  Boolean___vue_scopeId__,
  Boolean___vue_module_identifier__
)

/* harmony default export */ var src_components_inputs_Boolean = (Boolean_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__(31);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/components/inputs/collection.js

/* harmony default export */ var collection = (function (component, scope) {
  var tr = component.$i18n.messages[component.$i18n.locale];
  scope.split('.').forEach(function (x) {
    tr = tr[x];
  });
  return keys_default()(tr).map(function (e) {
    return {
      code: e.toString(),
      name: component.$t([scope, e].join('.'))
    };
  });
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Category.vue




/* harmony default export */ var Category = ({
  mixins: [mixins_input],
  computed: {
    categories: function categories() {
      return collection(this, 'inputs.category.categories');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5735932","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Category.vue
var Category_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.categories,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":"","autocomplete":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var Category_staticRenderFns = []
var Category_esExports = { render: Category_render, staticRenderFns: Category_staticRenderFns }
/* harmony default export */ var inputs_Category = (Category_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Category.vue
var Category_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Category___vue_template_functional__ = false
/* styles */
var Category___vue_styles__ = null
/* scopeId */
var Category___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Category___vue_module_identifier__ = null
var Category_Component = Category_normalizeComponent(
  Category,
  inputs_Category,
  Category___vue_template_functional__,
  Category___vue_styles__,
  Category___vue_scopeId__,
  Category___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Category = (Category_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Country.vue




/* harmony default export */ var Country = ({
  mixins: [mixins_input],
  computed: Object(vuex_esm["c" /* mapGetters */])({
    countries: 'application/countries'
  }),
  methods: Object(vuex_esm["b" /* mapActions */])({
    fetchCountries: 'application/fetchCountries'
  }),
  beforeMount: function beforeMount() {
    this.fetchCountries();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbfd1932","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Country.vue
var Country_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.countries,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":"","autocomplete":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var Country_staticRenderFns = []
var Country_esExports = { render: Country_render, staticRenderFns: Country_staticRenderFns }
/* harmony default export */ var inputs_Country = (Country_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Country.vue
var Country_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Country___vue_template_functional__ = false
/* styles */
var Country___vue_styles__ = null
/* scopeId */
var Country___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Country___vue_module_identifier__ = null
var Country_Component = Country_normalizeComponent(
  Country,
  inputs_Country,
  Country___vue_template_functional__,
  Country___vue_styles__,
  Country___vue_scopeId__,
  Country___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Country = (Country_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Date.vue



/* harmony default export */ var inputs_Date = ({
  mixins: [mixins_input],
  data: function data() {
    return {
      modal: false
    };
  },

  methods: {
    dateFormatter: function dateFormatter(value) {
      return value ? this.$d(new Date(value), 'short') : null;
    },
    clear: function clear() {
      this.emit(null);
      this.modal = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d01f57e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Date.vue
var Date_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","lazy":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.config.label,"value":_vm.dateFormatter(_vm.value),"required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"readonly":""},on:{"focus":function($event){_vm.modal = true}},slot:"activator"}),_vm._v(" "),_c('v-date-picker',{attrs:{"value":_vm.value,"date-format":_vm.dateFormatter,"formatted-value":_vm.dateFormatter,"scrollable":""},on:{"input":function (value) { return _vm.emit(value); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var cancel = ref.cancel;
return [_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"flat":"","primary":""},nativeOn:{"click":function($event){return _vm.clear()}}},[_vm._v(_vm._s(_vm.$t('inputs.date.clear')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","primary":""},nativeOn:{"click":function($event){return cancel()}}},[_vm._v(_vm._s(_vm.$t('inputs.date.cancel')))])],1)]}}])})],1)}
var Date_staticRenderFns = []
var Date_esExports = { render: Date_render, staticRenderFns: Date_staticRenderFns }
/* harmony default export */ var components_inputs_Date = (Date_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Date.vue
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var Date_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Date___vue_template_functional__ = false
/* styles */
var Date___vue_styles__ = injectStyle
/* scopeId */
var Date___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Date___vue_module_identifier__ = null
var Date_Component = Date_normalizeComponent(
  inputs_Date,
  components_inputs_Date,
  Date___vue_template_functional__,
  Date___vue_styles__,
  Date___vue_scopeId__,
  Date___vue_module_identifier__
)

/* harmony default export */ var src_components_inputs_Date = (Date_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Delay.vue



/* harmony default export */ var Delay = ({
  mixins: [mixins_input],
  data: function data() {
    return {
      number: (this.value || '').split('.')[0],
      range: (this.value || '').split('.')[1] || 'days'
    };
  },

  computed: {
    ranges: function ranges() {
      var _this = this;

      return ['hours', 'days', 'weeks'].map(function (e) {
        return { code: e, name: _this.$t('inputs.delay.ranges.' + e) };
      });
    },
    finalValue: function finalValue() {
      return [this.number, this.range].join('.');
    }
  },
  methods: {
    updateNumber: function updateNumber(value) {
      this.number = value;
      this.emit(this.finalValue);
    },
    updateRange: function updateRange(value) {
      this.range = value;
      this.emit(this.finalValue);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9aba744","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Delay.vue
var Delay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"value":_vm.number,"type":"number","label":_vm.config.label,"name":_vm.config.key,"required":_vm.config.required,"id":_vm.config.key,"error":_vm.haveErrors(),"rules":_vm.config.errors,"min":"0","step":"1"},on:{"input":function (value) { return _vm.updateNumber(value); }}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"value":_vm.range,"items":_vm.ranges,"item-text":"name","item-value":"code","dark":""},on:{"input":function (value) { return _vm.updateRange(value); }}})],1)],1)}
var Delay_staticRenderFns = []
var Delay_esExports = { render: Delay_render, staticRenderFns: Delay_staticRenderFns }
/* harmony default export */ var inputs_Delay = (Delay_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Delay.vue
var Delay_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Delay___vue_template_functional__ = false
/* styles */
var Delay___vue_styles__ = null
/* scopeId */
var Delay___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Delay___vue_module_identifier__ = null
var Delay_Component = Delay_normalizeComponent(
  Delay,
  inputs_Delay,
  Delay___vue_template_functional__,
  Delay___vue_styles__,
  Delay___vue_scopeId__,
  Delay___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Delay = (Delay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Experts.vue




/* harmony default export */ var Experts = ({
  mixins: [mixins_input],
  computed: Object(vuex_esm["c" /* mapGetters */])({
    experts: 'skiliko/experts/experts'
  }),
  methods: Object(vuex_esm["b" /* mapActions */])({
    fetchExperts: 'skiliko/experts/fetchAll'
  }),
  beforeMount: function beforeMount() {
    this.fetchExperts();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b081f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Experts.vue
var Experts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.experts,"item-text":"nickname","item-value":"id","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"multiple":"","chips":"","dark":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var Experts_staticRenderFns = []
var Experts_esExports = { render: Experts_render, staticRenderFns: Experts_staticRenderFns }
/* harmony default export */ var inputs_Experts = (Experts_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Experts.vue
var Experts_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Experts___vue_template_functional__ = false
/* styles */
var Experts___vue_styles__ = null
/* scopeId */
var Experts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Experts___vue_module_identifier__ = null
var Experts_Component = Experts_normalizeComponent(
  Experts,
  inputs_Experts,
  Experts___vue_template_functional__,
  Experts___vue_styles__,
  Experts___vue_scopeId__,
  Experts___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Experts = (Experts_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/File.vue





/* harmony default export */ var File = ({
  mixins: [mixins_input],
  props: {
    accept: {
      type: String,
      default: '*'
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },

  computed: Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform'
  }),
  methods: {
    onClick: function onClick() {
      this.$refs.fileInput.click();
    },
    onFileChange: function onFileChange($event) {
      var _this = this;

      var files = $event.target.files || $event.dataTransfer.files;
      this.loading = true;
      upload.send({
        file: files[0],
        platform: this.platform,
        path: this.config.path
      }).then(function (_ref) {
        var data = _ref.data;

        _this.loading = false;
        _this.$emit('input', data.url);
      }).catch(function (_) {
        return _this.loading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ee8783a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/File.vue
var File_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{ref:"fileTextField",attrs:{"outline":"","primary":"","block":_vm.block,"loading":_vm.loading},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[_c('v-icon',{staticClass:"primary--text mr-2"},[_vm._v("attach_file")]),_vm._v("\n    "+_vm._s(_vm.config.label)+"\n  ")],1),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.onFileChange}})],1)}
var File_staticRenderFns = []
var File_esExports = { render: File_render, staticRenderFns: File_staticRenderFns }
/* harmony default export */ var inputs_File = (File_esExports);
// CONCATENATED MODULE: ./src/components/inputs/File.vue
function File_injectStyle (ssrContext) {
  __webpack_require__(632)
}
var File_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var File___vue_template_functional__ = false
/* styles */
var File___vue_styles__ = File_injectStyle
/* scopeId */
var File___vue_scopeId__ = "data-v-1ee8783a"
/* moduleIdentifier (server only) */
var File___vue_module_identifier__ = null
var File_Component = File_normalizeComponent(
  File,
  inputs_File,
  File___vue_template_functional__,
  File___vue_styles__,
  File___vue_scopeId__,
  File___vue_module_identifier__
)

/* harmony default export */ var components_inputs_File = (File_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Income.vue




/* harmony default export */ var Income = ({
  mixins: [mixins_input],
  computed: {
    incomes: function incomes() {
      return collection(this, 'inputs.income.income');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b5b8b7e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Income.vue
var Income_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.incomes,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var Income_staticRenderFns = []
var Income_esExports = { render: Income_render, staticRenderFns: Income_staticRenderFns }
/* harmony default export */ var inputs_Income = (Income_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Income.vue
var Income_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Income___vue_template_functional__ = false
/* styles */
var Income___vue_styles__ = null
/* scopeId */
var Income___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Income___vue_module_identifier__ = null
var Income_Component = Income_normalizeComponent(
  Income,
  inputs_Income,
  Income___vue_template_functional__,
  Income___vue_styles__,
  Income___vue_scopeId__,
  Income___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Income = (Income_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Minute.vue



/* harmony default export */ var Minute = ({
  mixins: [mixins_input]
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7133fee0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Minute.vue
var Minute_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.value,"type":"number","label":_vm.config.label,"name":_vm.config.key,"required":_vm.config.required,"id":_vm.config.key,"error":_vm.haveErrors(),"rules":_vm.config.errors,"min":0,"step":1,"suffix":_vm.$t('inputs.minute.minutes')},on:{"input":function (value) { return _vm.emit(value); }}})}
var Minute_staticRenderFns = []
var Minute_esExports = { render: Minute_render, staticRenderFns: Minute_staticRenderFns }
/* harmony default export */ var inputs_Minute = (Minute_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Minute.vue
var Minute_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Minute___vue_template_functional__ = false
/* styles */
var Minute___vue_styles__ = null
/* scopeId */
var Minute___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Minute___vue_module_identifier__ = null
var Minute_Component = Minute_normalizeComponent(
  Minute,
  inputs_Minute,
  Minute___vue_template_functional__,
  Minute___vue_styles__,
  Minute___vue_scopeId__,
  Minute___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Minute = (Minute_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Language.vue




/* harmony default export */ var Language = ({
  mixins: [mixins_input],
  computed: Object(vuex_esm["c" /* mapGetters */])({
    languages: 'application/languages'
  }),
  methods: Object(vuex_esm["b" /* mapActions */])({
    fetchLanguages: 'application/fetchLanguages'
  }),
  beforeMount: function beforeMount() {
    this.fetchLanguages();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbae36d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Language.vue
var Language_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.languages,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"multiple":"","chips":"","dark":"","autocomplete":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var Language_staticRenderFns = []
var Language_esExports = { render: Language_render, staticRenderFns: Language_staticRenderFns }
/* harmony default export */ var inputs_Language = (Language_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Language.vue
var Language_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Language___vue_template_functional__ = false
/* styles */
var Language___vue_styles__ = null
/* scopeId */
var Language___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Language___vue_module_identifier__ = null
var Language_Component = Language_normalizeComponent(
  Language,
  inputs_Language,
  Language___vue_template_functional__,
  Language___vue_styles__,
  Language___vue_scopeId__,
  Language___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Language = (Language_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/OfferType.vue



/* harmony default export */ var OfferType = ({
  mixins: [mixins_input],
  computed: {
    types: function types() {
      var _this = this;

      return ['public', 'promotion', 'private'].map(function (x) {
        return { key: x, label: _this.$t('inputs.offertype.types.' + x) };
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3193e806","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/OfferType.vue
var OfferType_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.types,"item-text":"label","item-value":"key","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var OfferType_staticRenderFns = []
var OfferType_esExports = { render: OfferType_render, staticRenderFns: OfferType_staticRenderFns }
/* harmony default export */ var inputs_OfferType = (OfferType_esExports);
// CONCATENATED MODULE: ./src/components/inputs/OfferType.vue
var OfferType_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var OfferType___vue_template_functional__ = false
/* styles */
var OfferType___vue_styles__ = null
/* scopeId */
var OfferType___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var OfferType___vue_module_identifier__ = null
var OfferType_Component = OfferType_normalizeComponent(
  OfferType,
  inputs_OfferType,
  OfferType___vue_template_functional__,
  OfferType___vue_styles__,
  OfferType___vue_scopeId__,
  OfferType___vue_module_identifier__
)

/* harmony default export */ var components_inputs_OfferType = (OfferType_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Occupation.vue




/* harmony default export */ var Occupation = ({
  mixins: [mixins_input],
  computed: {
    occupations: function occupations() {
      return collection(this, 'inputs.occupation');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aca033d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Occupation.vue
var Occupation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.occupations,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var Occupation_staticRenderFns = []
var Occupation_esExports = { render: Occupation_render, staticRenderFns: Occupation_staticRenderFns }
/* harmony default export */ var inputs_Occupation = (Occupation_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Occupation.vue
var Occupation_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Occupation___vue_template_functional__ = false
/* styles */
var Occupation___vue_styles__ = null
/* scopeId */
var Occupation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Occupation___vue_module_identifier__ = null
var Occupation_Component = Occupation_normalizeComponent(
  Occupation,
  inputs_Occupation,
  Occupation___vue_template_functional__,
  Occupation___vue_styles__,
  Occupation___vue_scopeId__,
  Occupation___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Occupation = (Occupation_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./static/vendor/intl-tel-input/intlTelInput.js
var intlTelInput = __webpack_require__(634);
var intlTelInput_default = /*#__PURE__*/__webpack_require__.n(intlTelInput);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Phone.vue





/* harmony default export */ var Phone = ({
  props: {
    checkInterval: {
      type: Number,
      default: 500
    }
  },
  mixins: [mixins_input],
  data: function data() {
    return {
      intlTelInput: null,
      model: this.value,
      utilLibLoaded: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform'
  }), {
    number: function number() {
      return this.model && this.intlTelInput && this.intlTelInput.getNumber();
    },
    valid: function valid() {
      if (!this.model) {
        return true;
      }
      if (!this.intlTelInput) {
        return true;
      }
      if (!this.utilLibLoaded) {
        return true;
      }
      if (this.platform.settings.allowedCountries.length > 0 && this.platform.settings.allowedCountries.indexOf(this.intlTelInput.getSelectedCountryData().iso2) < 0) {
        return false;
      }
      return this.intlTelInput.isValidNumber();
    }
  }),
  watch: {
    model: function model() {
      if (!this.valid) {
        return;
      }
      this.emit(this.number);
    }
  },
  methods: {
    checkForUtilLib: function checkForUtilLib() {
      var _this = this;

      if (window.intlTelInputUtils) {
        this.utilLibLoaded = true;
      } else {
        setTimeout(function () {
          return _this.checkForUtilLib();
        }, this.checkInterval);
      }
    }
  },
  mounted: function mounted() {
    this.intlTelInput = new IntlTelInput(this.$refs.phone, {
      utilsScript: '/static/vendor/intl-tel-input/utils.js',
      defaultCountry: 'fr',
      onlyCountries: this.platform.settings.allowedCountries || []
    });
    this.checkForUtilLib();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a77f035","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Phone.vue
var Phone_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone-input",class:{ invalid: !_vm.valid }},[_c('label',{attrs:{"for":_vm.config.key}},[_vm._v("\n    "+_vm._s(_vm.config.label)+"\n    "),(_vm.config.required)?_c('sup',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],ref:"phone",attrs:{"id":_vm.config.key,"required":_vm.config.required,"type":"text"},domProps:{"value":(_vm.model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.model=$event.target.value}}}),_vm._v(" "),(!_vm.valid)?_c('span',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.$t('inputs.phone.error')))]):_vm._e()])}
var Phone_staticRenderFns = []
var Phone_esExports = { render: Phone_render, staticRenderFns: Phone_staticRenderFns }
/* harmony default export */ var inputs_Phone = (Phone_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Phone.vue
function Phone_injectStyle (ssrContext) {
  __webpack_require__(633)
}
var Phone_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Phone___vue_template_functional__ = false
/* styles */
var Phone___vue_styles__ = Phone_injectStyle
/* scopeId */
var Phone___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Phone___vue_module_identifier__ = null
var Phone_Component = Phone_normalizeComponent(
  Phone,
  inputs_Phone,
  Phone___vue_template_functional__,
  Phone___vue_styles__,
  Phone___vue_scopeId__,
  Phone___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Phone = (Phone_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Portfolio.vue




/* harmony default export */ var Portfolio = ({
  components: {
    FileInput: components_inputs_File
  },
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      picture: null,
      video: null,
      videoPopup: false
    };
  },

  watch: {
    picture: function picture() {
      if (!this.picture) {
        return;
      }
      this.$emit('input', [].concat(toConsumableArray_default()(this.value), [{ type: 'picture', src: this.picture }]));
      this.picture = null;
    }
  },
  methods: {
    remove: function remove(index) {
      this.$emit('input', [].concat(toConsumableArray_default()(this.value.filter(function (x, i) {
        return i !== index;
      }))));
    },
    submitVideo: function submitVideo() {
      this.videoPopup = false;
      if (!this.video) {
        return;
      }
      this.$emit('input', [].concat(toConsumableArray_default()(this.value), [{ type: 'video', src: this.video }]));
      this.video = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cc176cc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Portfolio.vue
var Portfolio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-2"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","lg2":""}},[_c('v-card',{staticClass:"mb-3",attrs:{"flat":"","height":"200px"}},[_c('v-card-title',{staticClass:"subheader"},[_vm._v("Portfolio")]),_vm._v(" "),_c('v-card-text',{staticClass:"pb-0"},[_c('file-input',{attrs:{"block":"","config":{
              path: 'portfolio',
              label: _vm.$t('inputs.portfolio.labels.picture')
            }},model:{value:(_vm.picture),callback:function ($$v) {_vm.picture=$$v},expression:"picture"}})],1),_vm._v(" "),_c('v-card-text',[_c('v-dialog',{model:{value:(_vm.videoPopup),callback:function ($$v) {_vm.videoPopup=$$v},expression:"videoPopup"}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","block":"","primary":""},slot:"activator"},[_vm._v(_vm._s(_vm.$t('inputs.portfolio.labels.video')))]),_vm._v(" "),_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('inputs.portfolio.labels.picture')))]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.$t('inputs.portfolio.video.text')))]),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('inputs.portfolio.video.url')},model:{value:(_vm.video),callback:function ($$v) {_vm.video=$$v},expression:"video"}})],1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"outline":"","primary":""},nativeOn:{"click":function($event){return _vm.submitVideo.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('inputs.portfolio.video.button')))])],1)],1)],1)],1)],1)],1),_vm._v(" "),_vm._l((_vm.value),function(item,i){return _c('v-flex',{key:i,attrs:{"xs12":"","md4":"","lg2":""}},[(item.type === 'picture')?_c('v-card',{staticClass:"mb-3",staticStyle:{"width":"200px"},attrs:{"img":item.src,"height":"200px"}},[_c('v-btn',{staticClass:"delete",attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.remove(i)}}},[_c('v-icon',[_vm._v("close")])],1)],1):_vm._e(),_vm._v(" "),(item.type === 'video')?_c('v-card',{staticClass:"mb-3",staticStyle:{"width":"200px"},attrs:{"img":item.src,"height":"200px"}},[_c('v-btn',{staticClass:"delete",attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.remove(i)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":"","fill-height":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('a',{attrs:{"href":item.src,"target":"_blank"}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("play_arrow")])],1)])],1)],1):_vm._e()],1)})],2)],1)],1)}
var Portfolio_staticRenderFns = []
var Portfolio_esExports = { render: Portfolio_render, staticRenderFns: Portfolio_staticRenderFns }
/* harmony default export */ var inputs_Portfolio = (Portfolio_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Portfolio.vue
function Portfolio_injectStyle (ssrContext) {
  __webpack_require__(635)
}
var Portfolio_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Portfolio___vue_template_functional__ = false
/* styles */
var Portfolio___vue_styles__ = Portfolio_injectStyle
/* scopeId */
var Portfolio___vue_scopeId__ = "data-v-0cc176cc"
/* moduleIdentifier (server only) */
var Portfolio___vue_module_identifier__ = null
var Portfolio_Component = Portfolio_normalizeComponent(
  Portfolio,
  inputs_Portfolio,
  Portfolio___vue_template_functional__,
  Portfolio___vue_styles__,
  Portfolio___vue_scopeId__,
  Portfolio___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Portfolio = (Portfolio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Price.vue





/* harmony default export */ var Price = ({
  mixins: [mixins_input],
  data: function data() {
    return {
      price: typeof this.value === 'number' ? (this.value / 100).toFixed(2) : null
    };
  },

  computed: Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform'
  }),
  methods: {
    updatePrice: function updatePrice(value) {
      var cents = Math.round(parseFloat(value) * 100);
      this.price = cents / 100;
      this.emit(cents);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5543b1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Price.vue
var Price_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.price,"type":"number","label":_vm.config.label,"name":_vm.config.key,"required":_vm.config.required,"id":_vm.config.key,"error":_vm.haveErrors(),"rules":_vm.config.errors,"hint":_vm.config.hint,"suffix":_vm.platform.currency,"pattern":"[0-9]+([,\\.][0-9]+)?","min":_vm.config.min || 0,"max":_vm.config.max ? _vm.config.max / 100 : null,"step":"0.01","readonly":_vm.config.disabled},on:{"input":function (value) { return _vm.updatePrice(value); }}})}
var Price_staticRenderFns = []
var Price_esExports = { render: Price_render, staticRenderFns: Price_staticRenderFns }
/* harmony default export */ var inputs_Price = (Price_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Price.vue
var Price_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Price___vue_template_functional__ = false
/* styles */
var Price___vue_styles__ = null
/* scopeId */
var Price___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Price___vue_module_identifier__ = null
var Price_Component = Price_normalizeComponent(
  Price,
  inputs_Price,
  Price___vue_template_functional__,
  Price___vue_styles__,
  Price___vue_scopeId__,
  Price___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Price = (Price_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__(638);
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(641);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(642);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__(643);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/vue-quill-editor/index.js
var vue_quill_editor = __webpack_require__(651);
var vue_quill_editor_default = /*#__PURE__*/__webpack_require__.n(vue_quill_editor);

// EXTERNAL MODULE: ./node_modules/quill/dist/quill.js
var quill = __webpack_require__(161);
var quill_default = /*#__PURE__*/__webpack_require__.n(quill);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/RichText.vue













var BlockEmbed = quill_default.a.import('blots/block/embed');
var icons = quill_default.a.import('ui/icons');
icons['divider'] = '<svg viewBox="0 0 18 18"><line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"></line></svg>';

var RichText_DividerBlot = function (_BlockEmbed) {
  inherits_default()(DividerBlot, _BlockEmbed);

  function DividerBlot() {
    classCallCheck_default()(this, DividerBlot);

    return possibleConstructorReturn_default()(this, (DividerBlot.__proto__ || get_prototype_of_default()(DividerBlot)).apply(this, arguments));
  }

  return DividerBlot;
}(BlockEmbed);

RichText_DividerBlot.blotName = 'divider';
RichText_DividerBlot.tagName = 'hr';

quill_default.a.register(RichText_DividerBlot);

/* harmony default export */ var RichText = ({
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          modules: {
            toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }], ['clean'], ['link', 'image', 'video'], ['divider']]
          }
        };
      }
    }
  },
  components: {
    quillEditor: vue_quill_editor["quillEditor"]
  },
  mixins: [mixins_input],
  data: function data() {
    return {
      view: 'edit'
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform'
  }), {
    editor: function editor() {
      return this.$refs.editor.quill;
    }
  }),
  methods: {
    setView: function setView(view) {
      this.view = view;
    },
    onEdit: function onEdit(_ref) {
      var editor = _ref.editor,
          html = _ref.html,
          text = _ref.text;

      this.emit(html);
    },
    addUrl: function addUrl(url) {
      var range = this.editor.getSelection();
      this.editor.insertEmbed(range.index, 'image', url);
    },
    selectLocalImage: function selectLocalImage() {
      var _this2 = this;

      var input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.click();

      input.onchange = function () {
        var file = input.files[0];
        if (/^image\//.test(file.type)) {
          upload.send({
            file: file,
            platform: _this2.platform,
            path: 'content'
          }).then(function (_ref2) {
            var data = _ref2.data;
            return _this2.addUrl(data.url);
          });
        }
      };
    },
    addDivider: function addDivider() {
      var range = this.editor.getSelection(true);
      this.editor.insertText(range.index, '\n', quill_default.a.sources.USER);
      this.editor.insertEmbed(range.index + 1, 'divider', true, quill_default.a.sources.USER);
      this.editor.setSelection(range.index + 2, quill_default.a.sources.SILENT);
    }
  },
  mounted: function mounted() {
    this.editor.getModule('toolbar').addHandler('image', this.selectLocalImage);
    this.editor.getModule('toolbar').addHandler('divider', this.addDivider);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14956f32","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/RichText.vue
var RichText_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('label',{attrs:{"for":_vm.config.key}},[_vm._v("\n    "+_vm._s(_vm.config.label)+"\n    "),(_vm.config.required)?_c('sup',[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"views"},[_c('v-btn',{attrs:{"flat":"","primary":_vm.view === 'edit'},nativeOn:{"click":function($event){return _vm.setView('edit')}}},[_vm._v("Edition")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","primary":_vm.view === 'code'},nativeOn:{"click":function($event){return _vm.setView('code')}}},[_vm._v("Code")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","primary":_vm.view === 'preview'},nativeOn:{"click":function($event){return _vm.setView('preview')}}},[_vm._v("Visualisation")])],1),_vm._v(" "),(_vm.view == 'edit')?_c('quill-editor',{ref:"editor",attrs:{"id":_vm.config.key,"content":_vm.value,"options":_vm.options},on:{"change":function($event){return _vm.onEdit($event)}}}):(_vm.view === 'code')?_c('textarea',{staticClass:"code",domProps:{"value":_vm.value},on:{"change":function (e) { return _vm.emit(e.currentTarget.value); }}}):(_vm.view === 'preview')?_c('div',{staticClass:"preview",domProps:{"innerHTML":_vm._s(_vm.value)}}):_vm._e()],1)}
var RichText_staticRenderFns = []
var RichText_esExports = { render: RichText_render, staticRenderFns: RichText_staticRenderFns }
/* harmony default export */ var inputs_RichText = (RichText_esExports);
// CONCATENATED MODULE: ./src/components/inputs/RichText.vue
function RichText_injectStyle (ssrContext) {
  __webpack_require__(636)
  __webpack_require__(637)
}
var RichText_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var RichText___vue_template_functional__ = false
/* styles */
var RichText___vue_styles__ = RichText_injectStyle
/* scopeId */
var RichText___vue_scopeId__ = "data-v-14956f32"
/* moduleIdentifier (server only) */
var RichText___vue_module_identifier__ = null
var RichText_Component = RichText_normalizeComponent(
  RichText,
  inputs_RichText,
  RichText___vue_template_functional__,
  RichText___vue_styles__,
  RichText___vue_scopeId__,
  RichText___vue_module_identifier__
)

/* harmony default export */ var components_inputs_RichText = (RichText_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Services.vue




/* harmony default export */ var Services = ({
  mixins: [mixins_input],
  computed: {
    services: function services() {
      return collection(this, 'inputs.services.services');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f33bfac2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Services.vue
var Services_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.services,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var Services_staticRenderFns = []
var Services_esExports = { render: Services_render, staticRenderFns: Services_staticRenderFns }
/* harmony default export */ var inputs_Services = (Services_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Services.vue
var Services_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Services___vue_template_functional__ = false
/* styles */
var Services___vue_styles__ = null
/* scopeId */
var Services___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Services___vue_module_identifier__ = null
var Services_Component = Services_normalizeComponent(
  Services,
  inputs_Services,
  Services___vue_template_functional__,
  Services___vue_styles__,
  Services___vue_scopeId__,
  Services___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Services = (Services_Component.exports);

// EXTERNAL MODULE: ./src/api/service.js
var service = __webpack_require__(91);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/ServiceType.vue






/* harmony default export */ var ServiceType = ({
  mixins: [mixins_input],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform'
  }), {
    availableServices: function availableServices() {
      var types = service["a" /* default */].OFFER_TYPES;
      var disabledTypes = this.platform.settings.disabledOffers || [];
      return types.filter(function (x) {
        return !disabledTypes.includes(x);
      });
    },
    services: function services() {
      var _this = this;

      return this.availableServices.map(function (e) {
        return { code: e, name: _this.$t('inputs.servicetype.services.' + e) };
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dec7ec9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/ServiceType.vue
var ServiceType_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.services,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var ServiceType_staticRenderFns = []
var ServiceType_esExports = { render: ServiceType_render, staticRenderFns: ServiceType_staticRenderFns }
/* harmony default export */ var inputs_ServiceType = (ServiceType_esExports);
// CONCATENATED MODULE: ./src/components/inputs/ServiceType.vue
var ServiceType_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var ServiceType___vue_template_functional__ = false
/* styles */
var ServiceType___vue_styles__ = null
/* scopeId */
var ServiceType___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ServiceType___vue_module_identifier__ = null
var ServiceType_Component = ServiceType_normalizeComponent(
  ServiceType,
  inputs_ServiceType,
  ServiceType___vue_template_functional__,
  ServiceType___vue_styles__,
  ServiceType___vue_scopeId__,
  ServiceType___vue_module_identifier__
)

/* harmony default export */ var components_inputs_ServiceType = (ServiceType_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Text.vue



/* harmony default export */ var Text = ({
  mixins: [mixins_input]
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e3cc992","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Text.vue
var Text_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.value,"type":_vm.config.type || 'text',"label":_vm.config.label,"disabled":_vm.config.disabled,"name":_vm.config.key,"required":_vm.config.required,"id":_vm.config.key,"auto-grow":_vm.config.authoGrow,"multi-line":_vm.config.multiLine,"counter":_vm.config.counter,"error":_vm.haveErrors(),"rules":_vm.config.errors,"max":_vm.config.max,"hint":_vm.config.hint,"persistent-hint":_vm.config.persistentHint,"suffix":_vm.config.suffix},on:{"input":function (value) { return _vm.emit(value); }}})}
var Text_staticRenderFns = []
var Text_esExports = { render: Text_render, staticRenderFns: Text_staticRenderFns }
/* harmony default export */ var inputs_Text = (Text_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Text.vue
var Text_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Text___vue_template_functional__ = false
/* styles */
var Text___vue_styles__ = null
/* scopeId */
var Text___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Text___vue_module_identifier__ = null
var Text_Component = Text_normalizeComponent(
  Text,
  inputs_Text,
  Text___vue_template_functional__,
  Text___vue_styles__,
  Text___vue_scopeId__,
  Text___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Text = (Text_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Time.vue



/* harmony default export */ var Time = ({
  mixins: [mixins_input],
  computed: {
    times: function times() {
      var result = [];
      for (var hour = 0; hour < 24; hour++) {
        for (var minute = 0; minute < 60; minute += 30) {
          result.push([('0' + hour).slice(-2), ('0' + minute).slice(-2)].join(':'));
        }
      }
      result.push('24:00');
      return result;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-388d0d24","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Time.vue
var Time_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.times,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var Time_staticRenderFns = []
var Time_esExports = { render: Time_render, staticRenderFns: Time_staticRenderFns }
/* harmony default export */ var inputs_Time = (Time_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Time.vue
var Time_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Time___vue_template_functional__ = false
/* styles */
var Time___vue_styles__ = null
/* scopeId */
var Time___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Time___vue_module_identifier__ = null
var Time_Component = Time_normalizeComponent(
  Time,
  inputs_Time,
  Time___vue_template_functional__,
  Time___vue_styles__,
  Time___vue_scopeId__,
  Time___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Time = (Time_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/Timezone.vue




/* harmony default export */ var Timezone = ({
  mixins: [mixins_input],
  computed: {
    timezones: function timezones() {
      return collection(this, 'inputs.timezone.timezones');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4954ad4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/Timezone.vue
var Timezone_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.timezones,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":"","autocomplete":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var Timezone_staticRenderFns = []
var Timezone_esExports = { render: Timezone_render, staticRenderFns: Timezone_staticRenderFns }
/* harmony default export */ var inputs_Timezone = (Timezone_esExports);
// CONCATENATED MODULE: ./src/components/inputs/Timezone.vue
var Timezone_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Timezone___vue_template_functional__ = false
/* styles */
var Timezone___vue_styles__ = null
/* scopeId */
var Timezone___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Timezone___vue_module_identifier__ = null
var Timezone_Component = Timezone_normalizeComponent(
  Timezone,
  inputs_Timezone,
  Timezone___vue_template_functional__,
  Timezone___vue_styles__,
  Timezone___vue_scopeId__,
  Timezone___vue_module_identifier__
)

/* harmony default export */ var components_inputs_Timezone = (Timezone_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputs/WeekDay.vue



/* harmony default export */ var WeekDay = ({
  mixins: [mixins_input],
  computed: {
    wdays: function wdays() {
      var _this = this;

      return [0, 1, 2, 3, 4, 5, 6].map(function (d) {
        return { code: d, name: _this.$t('inputs.weekday.wday.' + d) };
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5072cb0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/WeekDay.vue
var WeekDay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"label":_vm.config.label,"items":_vm.wdays,"item-text":"name","item-value":"code","required":_vm.config.required,"error":_vm.haveErrors(),"rules":_vm.config.errors,"dark":""},on:{"input":function (value) { return _vm.emit(value); }}})}
var WeekDay_staticRenderFns = []
var WeekDay_esExports = { render: WeekDay_render, staticRenderFns: WeekDay_staticRenderFns }
/* harmony default export */ var inputs_WeekDay = (WeekDay_esExports);
// CONCATENATED MODULE: ./src/components/inputs/WeekDay.vue
var WeekDay_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var WeekDay___vue_template_functional__ = false
/* styles */
var WeekDay___vue_styles__ = null
/* scopeId */
var WeekDay___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WeekDay___vue_module_identifier__ = null
var WeekDay_Component = WeekDay_normalizeComponent(
  WeekDay,
  inputs_WeekDay,
  WeekDay___vue_template_functional__,
  WeekDay___vue_styles__,
  WeekDay___vue_scopeId__,
  WeekDay___vue_module_identifier__
)

/* harmony default export */ var components_inputs_WeekDay = (WeekDay_Component.exports);

// CONCATENATED MODULE: ./src/components/inputs/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return components_inputs_Attachment; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return components_inputs_AvailabilityType; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return src_components_inputs_Boolean; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return components_inputs_Category; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return components_inputs_Country; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return src_components_inputs_Date; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return components_inputs_Delay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return components_inputs_Experts; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return components_inputs_File; });
/* unused concated harmony import IncomeInput */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return components_inputs_Income; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return components_inputs_Language; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return components_inputs_Minute; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return components_inputs_OfferType; });
/* unused concated harmony import OccupationInput */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return components_inputs_Occupation; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return components_inputs_Phone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return components_inputs_Portfolio; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return components_inputs_Price; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return components_inputs_RichText; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return components_inputs_Services; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return components_inputs_ServiceType; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return components_inputs_Text; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return components_inputs_Time; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return components_inputs_Timezone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "w", function() { return components_inputs_WeekDay; });



























/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_default__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__call__ = __webpack_require__(173);





var fetchAll = function fetchAll(_ref) {
  var _ref$page = _ref.page,
      page = _ref$page === undefined ? 1 : _ref$page,
      _ref$userId = _ref.userId,
      userId = _ref$userId === undefined ? null : _ref$userId,
      _ref$adminId = _ref.adminId,
      adminId = _ref$adminId === undefined ? null : _ref$adminId,
      _ref$offerId = _ref.offerId,
      offerId = _ref$offerId === undefined ? null : _ref$offerId,
      _ref$serviceType = _ref.serviceType,
      serviceType = _ref$serviceType === undefined ? null : _ref$serviceType,
      _ref$resultCode = _ref.resultCode,
      resultCode = _ref$resultCode === undefined ? null : _ref$resultCode,
      _ref$dateFilter = _ref.dateFilter,
      dateFilter = _ref$dateFilter === undefined ? null : _ref$dateFilter,
      _ref$from = _ref.from,
      from = _ref$from === undefined ? null : _ref$from,
      _ref$to = _ref.to,
      to = _ref$to === undefined ? null : _ref$to,
      _ref$scope = _ref.scope,
      scope = _ref$scope === undefined ? 'all' : _ref$scope;

  var params = {
    page: page,
    user_id: userId,
    admin_id: adminId,
    offer_id: offerId,
    service_type: serviceType,
    result_code: resultCode,
    from: from,
    to: to,
    date_filter: dateFilter,
    scope: scope
  };
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().get('/purchases_v2?' + __WEBPACK_IMPORTED_MODULE_1__utils_default__["a" /* default */].dataToUrlString(params));
};

var fetch = function fetch(_ref2) {
  var id = _ref2.id;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().get('/purchases/' + id);
};

var accept = function accept(_ref3) {
  var id = _ref3.id;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().post('/accept_purchases', { purchase_id: id });
};

var finish = function finish(_ref4) {
  var id = _ref4.id,
      serviceType = _ref4.serviceType,
      _ref4$data = _ref4.data,
      data = _ref4$data === undefined ? {} : _ref4$data;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().put('/' + serviceType + '_services/' + id, data).then(function (_) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().post('/finish_purchases', { purchase_id: id });
  });
};

var refund = function refund(_ref5) {
  var id = _ref5.id,
      reason = _ref5.reason;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().post('/refunds', { purchase_id: id, reason: reason });
};

var totalPrice = function totalPrice(purchase, platform, expert) {
  if (purchase.offer.service_type !== 'phone') {
    return purchase.price;
  }
  if (platform.multi_experts) {
    return __WEBPACK_IMPORTED_MODULE_2__call__["a" /* default */].duration(purchase) / 60 * purchase.service.per_minute_price;
  } else {
    return 0;
  }
};

var creditedPrice = function creditedPrice(purchase, expert) {
  return (purchase.gains || []).filter(function (x) {
    return x.admin_id === expert.id;
  }).map(function (x) {
    return x.price;
  })[0] || 0;
};

var fees = function fees(purchase, platform, expert) {
  return Math.round(totalPrice(purchase, platform, expert) - creditedPrice(purchase, expert));
};

var isPending = function isPending(purchase) {
  return !isRefunded(purchase) && !!purchase.payed_at && !purchase.accepted_at;
};

var isInProgress = function isInProgress(purchase) {
  return !isRefunded(purchase) && !!purchase.accepted_at && !purchase.finished_at;
};

var isFinished = function isFinished(purchase) {
  return isRefunded(purchase) || !!purchase.finished_at;
};

var isRefunded = function isRefunded(purchase) {
  return !!purchase.refunded_at;
};

var isRefundable = function isRefundable(purchase) {
  if (purchase.refunded_at) {
    return false;
  }
  if (!purchase.payed_at) {
    return false;
  }
  if (purchase.finished_at) {
    return false;
  }
  return true;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchAll: fetchAll,
  fetch: fetch,
  accept: accept,
  finish: finish,
  refund: refund,
  totalPrice: totalPrice,
  creditedPrice: creditedPrice,
  fees: fees,
  isPending: isPending,
  isInProgress: isInProgress,
  isFinished: isFinished,
  isRefunded: isRefunded,
  isRefundable: isRefundable
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(11);


var fetch = function fetch() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().get('/expert');
};

var save = function save(_ref) {
  var data = _ref.data;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().put('/expert', data);
};

var isRestricted = function isRestricted(expert) {
  return expert && expert.role === 'restricted';
};

var isAdmin = function isAdmin(expert) {
  return expert && expert.role === 'main';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  save: save,
  isAdmin: isAdmin,
  isRestricted: isRestricted
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(11);



var createAppointment = function createAppointment(_ref) {
  var userId = _ref.userId,
      adminId = _ref.adminId,
      callAt = _ref.callAt;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().post('/phone_services', {
    user_id: userId,
    admin_id: adminId,
    call_at: callAt
  });
};

var hangup = function hangup(_ref2) {
  var id = _ref2.id;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().post('/phone_services/hangup', { purchase_id: id });
};

var record = function record(_ref3) {
  var id = _ref3.id;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().post('/phone_services/' + id + '/audio_file');
};

var durationForInProgressCall = function durationForInProgressCall(purchase, currentTime) {
  var filter = function filter(states, state) {
    return (states || []).filter(function (s) {
      return s.state === state;
    }).map(function (s) {
      return s.created_at;
    });
  };

  var call = purchase.service.call;

  var startsAt = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(filter(call.callee_states, 'in-progress')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(filter(call.caller_states, 'in-progress'))).sort()[0] || [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(filter(call.callee_states, 'ringing')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(filter(call.caller_states, 'ringing'))).sort()[0] || purchase.service.call_at;
  var endsAt = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(filter(call.callee_states, 'completed')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(filter(call.caller_states, 'completed'))).sort()[0];

  var starts = startsAt ? new Date(startsAt) : currentTime;
  var defaultEnd = Math.min(+currentTime, +starts + call.time_limit * 1000);
  var ends = endsAt ? new Date(endsAt) : new Date(defaultEnd);

  var duration = Math.max(0, +ends - +starts);
  return duration / 1000;
};

var duration = function duration(purchase) {
  if (purchase.offer.service_type !== 'phone') {
    return 0;
  }
  var call = purchase.service.call;
  if (!call || !call.duration) {
    return 0;
  }
  var duration = call.duration;
  if (duration > call.time_limit) {
    duration = call.time_limit;
  }
  return duration;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  hangup: hangup,
  record: record,
  createAppointment: createAppointment,
  duration: duration,
  durationForInProgressCall: durationForInProgressCall
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var dataForUrl = function dataForUrl(data) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).sort().filter(function (e) {
    return data[e];
  }).filter(function (e) {
    return ['rowsPerPage', 'totalItems'].indexOf(e) < 0;
  }).reduce(function (res, e) {
    res[e] = data[e];
    return res;
  }, {});
};

var dataToUrlString = function dataToUrlString(data) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataForUrl(data)).map(function (e) {
    return [e, data[e]].join('=');
  }).join('&');
};

var toHumanize = function toHumanize(str) {
  return [str[0].toUpperCase(), str.substr(1)].join('');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  dataForUrl: dataForUrl,
  dataToUrlString: dataToUrlString,
  toHumanize: toHumanize
});

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_purchase__ = __webpack_require__(171);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    purchase: {
      type: Object,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    loading: 'skiliko/purchases/isLoading'
  }), {
    service: function service() {
      return this.purchase.service;
    },
    isPending: function isPending() {
      return __WEBPACK_IMPORTED_MODULE_2__api_purchase__["a" /* default */].isPending(this.purchase);
    },
    isInProgress: function isInProgress() {
      return __WEBPACK_IMPORTED_MODULE_2__api_purchase__["a" /* default */].isInProgress(this.purchase);
    },
    isFinished: function isFinished() {
      return __WEBPACK_IMPORTED_MODULE_2__api_purchase__["a" /* default */].isFinished(this.purchase);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    accept: 'skiliko/purchases/accept',
    _finish: 'skiliko/purchases/finish'
  }), {
    finish: function finish(data) {
      return this._finish({
        id: this.purchase.id,
        serviceType: this.purchase.offer.service_type,
        data: data
      });
    }
  })
});

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_default__ = __webpack_require__(35);



/* harmony default export */ __webpack_exports__["a"] = ({
  color: function color(_color) {
    return 'rgba(' + _color.r + ', ' + _color.g + ', ' + _color.b + ', ' + _color.a + ')';
  },
  colorValue: function colorValue(colorItem) {
    var element = document.createElement('div');
    element.setAttribute('class', colorItem);
    document.body.appendChild(element);
    var color = window.getComputedStyle(element).backgroundColor;
    document.body.removeChild(element);
    var array = color.replace('rgb(', '').replace(')', '').split(', ');
    return {
      r: parseInt(array[0], 10),
      g: parseInt(array[1], 10),
      b: parseInt(array[2], 10),
      a: parseInt(array[3], 10) || 1
    };
  },
  createLinearGradient: function createLinearGradient(component, colors) {
    var gradient = component.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, component.$el.offsetHeight);
    colors.forEach(function (color, i) {
      gradient.addColorStop(i / (colors.length - 1), color);
    });
    return gradient;
  },
  label: function label(value) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

    if (value.trim().length < length) {
      return value;
    } else {
      return value.trim().substr(0, length - 3).trim() + '...';
    }
  },
  datasetIdentifier: function datasetIdentifier(dataKey, params) {
    return dataKey + __WEBPACK_IMPORTED_MODULE_1__utils_default__["a" /* default */].dataToUrlString(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params));
  }
});

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// CONCATENATED MODULE: ./src/mixins/withConversation.js
/* harmony default export */ var withConversation = ({
  props: {
    conversation: {
      type: Object,
      required: true
    }
  },
  computed: {
    user: function user() {
      return [this.conversation.from, this.conversation.to].filter(function (e) {
        return e.scope === 'user';
      })[0];
    },
    expert: function expert() {
      return [this.conversation.from, this.conversation.to].filter(function (e) {
        return e.scope === 'admin';
      })[0];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/ConversationItem.vue






/* harmony default export */ var ConversationItem = ({
  components: {
    DateFormatter: formatters["a" /* Date */]
  },
  mixins: [withConversation],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    pending: 'skiliko/conversations/pending'
  }), {
    isUnread: function isUnread() {
      return !!this.pending[this.conversation._id];
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2671d3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/ConversationItem.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-tile',{attrs:{"router":"","href":{ name: 'MessengerMessage', params: { id: this.conversation._id } }}},[_c('v-list-tile-content',[_c('v-list-tile-title',[(_vm.isUnread)?_c('v-icon',{staticClass:"blue--text"},[_vm._v("brightness_1")]):_vm._e(),_vm._v("\n        "+_vm._s(_vm.user.name)+"\n      ")],1)],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-list-tile-action-text',[_c('date-formatter',{attrs:{"value":_vm.conversation.lastMessageAt}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var messenger_ConversationItem = (esExports);
// CONCATENATED MODULE: ./src/components/messenger/ConversationItem.vue
function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d2671d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ConversationItem,
  messenger_ConversationItem,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_messenger_ConversationItem = (Component.exports);

// EXTERNAL MODULE: ./src/mixins/pagination.js
var pagination = __webpack_require__(115);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/Conversations.vue




/* harmony default export */ var Conversations = ({
  components: {
    ConversationItem: components_messenger_ConversationItem
  },
  mixins: [Object(pagination["a" /* default */])('skiliko/conversations')],
  data: function data() {
    var currentUser = this.$store.getters['skiliko/session/currentUser'];
    return {
      filter: {
        userId: currentUser.chatable_id,
        page: 1
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f192af3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/Conversations.vue
var Conversations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"grey lighten-4",attrs:{"flat":"","height":"100%"}},[_c('v-toolbar',{staticClass:"transparent elevation-0",attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('messenger.conversations.title')))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pb-0 list--full_height list--with_toolbar",attrs:{"two-lines":""}},_vm._l((_vm.conversations),function(conversation){return _c('conversation-item',{key:conversation._id,attrs:{"conversation":conversation}})}),1),_vm._v(" "),_c('v-divider')],1)}
var Conversations_staticRenderFns = []
var Conversations_esExports = { render: Conversations_render, staticRenderFns: Conversations_staticRenderFns }
/* harmony default export */ var messenger_Conversations = (Conversations_esExports);
// CONCATENATED MODULE: ./src/components/messenger/Conversations.vue
function Conversations_injectStyle (ssrContext) {
  __webpack_require__(626)
}
var Conversations_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Conversations___vue_template_functional__ = false
/* styles */
var Conversations___vue_styles__ = Conversations_injectStyle
/* scopeId */
var Conversations___vue_scopeId__ = "data-v-4f192af3"
/* moduleIdentifier (server only) */
var Conversations___vue_module_identifier__ = null
var Conversations_Component = Conversations_normalizeComponent(
  Conversations,
  messenger_Conversations,
  Conversations___vue_template_functional__,
  Conversations___vue_styles__,
  Conversations___vue_scopeId__,
  Conversations___vue_module_identifier__
)

/* harmony default export */ var components_messenger_Conversations = (Conversations_Component.exports);

// EXTERNAL MODULE: ./src/components/messenger/MessageForm.vue + 19 modules
var MessageForm = __webpack_require__(367);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(40);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./src/mixins/scrollableToBottom.js
/* harmony default export */ var scrollableToBottom = ({
  data: function data() {
    return {
      skipScroll: false
    };
  },

  methods: {
    scrollToBottom: function scrollToBottom(force) {
      var _this = this;

      this.$nextTick(function () {
        _this.$el.parentElement.scrollTop = _this.$el.parentElement.scrollHeight - _this.$el.parentElement.clientHeight;
      });
    }
  },
  updated: function updated() {
    if (this.skipScroll) return;
    this.scrollToBottom();
  },
  mounted: function mounted() {
    this.scrollToBottom();
  }
});
// EXTERNAL MODULE: ./src/components/messenger/previews/Offer.vue + 2 modules
var Offer = __webpack_require__(116);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/Message.vue




/* harmony default export */ var Message = ({
  components: {
    DateFormatter: formatters["a" /* Date */]
  },
  props: {
    value: {
      type: Object,
      requires: true
    }
  },
  computed: {
    message: function message() {
      return this.value.content.replace(/\n/g, '<br/>');
    },
    preview: function preview() {
      if (!this.value.data) {
        return null;
      }
      return {
        offer: Offer["a" /* default */],
        page: Offer["a" /* default */]
      }[this.value.data.type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a99ad0c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/Message.vue
var Message_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('date-formatter',{staticClass:"caption",attrs:{"value":_vm.value.sentAt}}),_vm._v(" "),_c('p',{staticClass:"body-1",domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),(_vm.preview)?_c(_vm.preview,{tag:"component",attrs:{"value":this.value.data}}):_vm._e()],1)}
var Message_staticRenderFns = []
var Message_esExports = { render: Message_render, staticRenderFns: Message_staticRenderFns }
/* harmony default export */ var messenger_Message = (Message_esExports);
// CONCATENATED MODULE: ./src/components/messenger/Message.vue
function Message_injectStyle (ssrContext) {
  __webpack_require__(670)
}
var Message_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Message___vue_template_functional__ = false
/* styles */
var Message___vue_styles__ = Message_injectStyle
/* scopeId */
var Message___vue_scopeId__ = "data-v-7a99ad0c"
/* moduleIdentifier (server only) */
var Message___vue_module_identifier__ = null
var Message_Component = Message_normalizeComponent(
  Message,
  messenger_Message,
  Message___vue_template_functional__,
  Message___vue_styles__,
  Message___vue_scopeId__,
  Message___vue_module_identifier__
)

/* harmony default export */ var components_messenger_Message = (Message_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/Messages.vue










var MINUTES = 60 * 1000;

/* harmony default export */ var Messages = ({
  components: {
    DateFormatter: formatters["a" /* Date */],
    Message: components_messenger_Message
  },
  mixins: [Object(pagination["a" /* default */])('skiliko/messages'), withConversation, scrollableToBottom],
  data: function data() {
    return {
      scrollTimeout: null,
      filter: {
        conversationId: this.conversation._id,
        page: 1
      }
    };
  },

  computed: {
    allMessages: function allMessages() {
      var _this = this;

      var page = this.filter.page;
      var messages = [];
      for (var i = 1; i <= page; i++) {
        var id = this.generatePageKey(extends_default()({}, this.filter, {
          page: i
        }));
        var currentPage = this.pages[id] || {};
        messages = [].concat(toConsumableArray_default()((currentPage.list || []).map(function (id) {
          return _this.collection[id];
        })), toConsumableArray_default()(messages));
      }
      return messages;
    },
    sortedMessages: function sortedMessages() {
      return this.allMessages.sort(function (a, b) {
        var aDate = a.sentAt || new Date();
        var bDate = b.sentAt || new Date();
        return aDate.localeCompare(bDate);
      }).filter(function (value, index, self) {
        return self.findIndex(function (x) {
          return x._id === value._id;
        }) === index;
      });
    },
    messagesPerUser: function messagesPerUser() {
      var users = [];
      var currentUser = null;
      for (var i = 0; i < this.sortedMessages.length; i++) {
        var message = this.sortedMessages[i];
        if (!currentUser || currentUser.name !== message.from.name || +new Date(currentUser.lastSendDate) + 5 * MINUTES < +new Date(message.sentAt)) {
          currentUser = extends_default()({}, message.from, {
            key: i,
            firstSentDate: message.sentAt,
            lastSendDate: message.sentAt,
            messages: []
          });
          users.push(currentUser);
        }
        currentUser.messages.push(message);
        currentUser.lastSendDate = message.sentAt;
      }
      return users;
    }
  },
  watch: {
    conversation: function conversation() {
      this.filter = extends_default()({}, this.filter, {
        conversationId: this.conversation._id
      });
    },
    messages: function messages() {
      var _this2 = this;

      this.markAsRead({ ids: this.messages.map(function (e) {
          return e._id;
        }) });
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
      this.scrollTimeout = setTimeout(function () {
        return _this2.skipScroll = false;
      }, 1000);
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    markAsRead: 'skiliko/messages/markAsRead'
  }), {
    more: function more() {
      this.skipScroll = true;
      this.filter = extends_default()({}, this.filter, {
        page: this.filter.page + 1
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4fc8292","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/Messages.vue
var Messages_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{attrs:{"block":"","flat":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.more.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('messenger.more')))]),_vm._v(" "),_vm._l((_vm.messagesPerUser),function(user){return _c('div',{key:user.key,staticClass:"message-group"},[_c('router-link',{staticClass:"subheading mb-2",attrs:{"to":{ name: user.scope === 'user' ? 'User' : 'Expert', params: { id: user.externalId, tab: 'profile' } }}},[_vm._v("\n      "+_vm._s(user.name)+"\n    ")]),_vm._v(" "),_c('date-formatter',{staticClass:"caption",attrs:{"value":user.firstSentDate}}),_vm._v(" "),_vm._l((user.messages),function(message){return _c('message',{key:message._id,attrs:{"value":message}})})],2)})],2)}
var Messages_staticRenderFns = []
var Messages_esExports = { render: Messages_render, staticRenderFns: Messages_staticRenderFns }
/* harmony default export */ var messenger_Messages = (Messages_esExports);
// CONCATENATED MODULE: ./src/components/messenger/Messages.vue
function Messages_injectStyle (ssrContext) {
  __webpack_require__(669)
}
var Messages_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Messages___vue_template_functional__ = false
/* styles */
var Messages___vue_styles__ = Messages_injectStyle
/* scopeId */
var Messages___vue_scopeId__ = "data-v-a4fc8292"
/* moduleIdentifier (server only) */
var Messages___vue_module_identifier__ = null
var Messages_Component = Messages_normalizeComponent(
  Messages,
  messenger_Messages,
  Messages___vue_template_functional__,
  Messages___vue_styles__,
  Messages___vue_scopeId__,
  Messages___vue_module_identifier__
)

/* harmony default export */ var components_messenger_Messages = (Messages_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/Chat.vue





/* harmony default export */ var Chat = ({
  components: {
    Messages: components_messenger_Messages,
    MessageForm: MessageForm["a" /* default */]
  },
  mixins: [withConversation],
  props: {
    noHeader: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b3f038c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/Chat.vue
var Chat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat--window"},[(!_vm.noHeader)?_c('div',{staticClass:"chat--toolbar"},[_c('v-toolbar',{staticClass:"transparent elevation-0",attrs:{"flat":""}},[_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"icon":"","dark":"","router":"","href":{ name: 'Messenger' }}},[_c('v-icon',[_vm._v("keyboard_arrow_left")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","router":"","href":{ name: 'User', params: { id: _vm.user.externalId, tab: 'profile' } }}},[_c('v-icon',[_vm._v("account_circle")])],1)],1),_vm._v(" "),_c('v-divider')],1):_vm._e(),_vm._v(" "),_c('div',{ref:"chatContent",staticClass:"chat--content"},[(_vm.conversation._id)?_c('messages',{attrs:{"conversation":_vm.conversation}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"chat--form"},[_c('v-divider'),_vm._v(" "),_c('message-form',{attrs:{"user":_vm.user,"conversationId":_vm.conversation._id}})],1)])}
var Chat_staticRenderFns = []
var Chat_esExports = { render: Chat_render, staticRenderFns: Chat_staticRenderFns }
/* harmony default export */ var messenger_Chat = (Chat_esExports);
// CONCATENATED MODULE: ./src/components/messenger/Chat.vue
function Chat_injectStyle (ssrContext) {
  __webpack_require__(628)
}
var Chat_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Chat___vue_template_functional__ = false
/* styles */
var Chat___vue_styles__ = Chat_injectStyle
/* scopeId */
var Chat___vue_scopeId__ = "data-v-2b3f038c"
/* moduleIdentifier (server only) */
var Chat___vue_module_identifier__ = null
var Chat_Component = Chat_normalizeComponent(
  Chat,
  messenger_Chat,
  Chat___vue_template_functional__,
  Chat___vue_styles__,
  Chat___vue_scopeId__,
  Chat___vue_module_identifier__
)

/* harmony default export */ var components_messenger_Chat = (Chat_Component.exports);

// CONCATENATED MODULE: ./src/components/messenger/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return components_messenger_Conversations; });
/* unused concated harmony import MessengerConversationItem */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return components_messenger_ConversationItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return components_messenger_Chat; });






/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__(92);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(93);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/utils/http.js
var http = __webpack_require__(11);

// EXTERNAL MODULE: ./src/mixins/purchase.js
var purchase = __webpack_require__(358);

// EXTERNAL MODULE: ./src/components/messenger/index.js + 17 modules
var messenger = __webpack_require__(362);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(0);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Timer.vue



/* harmony default export */ var Timer = ({
  props: {
    value: {
      type: Date,
      required: true
    }
  },
  data: function data() {
    return {
      interval: null,
      now: new Date()
    };
  },

  computed: {
    time: function time() {
      var diff = this.value - this.now;
      if (diff <= 0) {
        this.$emit('finish');
      }
      return moment_default.a.duration(diff);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$set(this, 'interval', setInterval(function () {
      _this.$set(_this, 'now', new Date());
    }, 1000));
  },
  destroyed: function destroyed() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-022ffc0a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',[_vm._v("\n  "+_vm._s(_vm.time.hours())+"h "+_vm._s(_vm.time.minutes(true))+"min "+_vm._s(_vm.time.seconds())+"sec\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Timer = (esExports);
// CONCATENATED MODULE: ./src/components/Timer.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Timer,
  components_Timer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Timer = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/purchase/Availability.vue










/* harmony default export */ var Availability = ({
  mixins: [purchase["a" /* default */]],
  components: {
    MessengerChat: messenger["a" /* MessengerChat */],
    Timer: src_components_Timer
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    conversations: 'skiliko/conversations/collection'
  }), {
    conversation_id: function conversation_id() {
      return this.purchase.service.metadata._id;
    },
    conversation: function conversation() {
      return this.conversations[this.conversation_id];
    },
    service: function service() {
      return this.purchase.service;
    },
    timeLeft: function timeLeft() {
      var left = this.service.duration * 60 - this.service.spent;
      return left < 0 ? 0 : left;
    },
    endDate: function endDate() {
      return new Date(new Date(this.service.start_at).getTime() + this.timeLeft * 1000);
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'skiliko/conversations/fetch',
    fetchPurchase: 'skiliko/purchases/fetch'
  }), {
    stop: function stop() {
      var _this = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(http["a" /* default */])().post('/availability_services/' + _this.purchase.id + '/stop');

              case 2:
                _context.next = 4;
                return _this.fetchPurchase({ id: _this.purchase.id });

              case 4:
                if (!_this.conversation) _this.fetch({ id: _this.conversation_id });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  mounted: function mounted() {
    if (!this.conversation_id) return;
    this.fetch({ id: this.conversation_id });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75bf2bd8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchase/Availability.vue
var Availability_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-row',{attrs:{"actions":""}},[(_vm.service.start_at)?_c('Timer',{attrs:{"value":_vm.endDate},on:{"finish":_vm.stop}}):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.timeLeft)?[(_vm.service.start_at)?_c('v-btn',{staticClass:"ml-3",attrs:{"primary":"","light":"","loading":_vm.loading},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.stop.apply(null, arguments)}}},[_vm._v("\n        "+_vm._s(_vm.$t('purchase.availability.stop'))+"\n      ")]):_vm._e()]:_vm._e()],2),_vm._v(" "),(_vm.service.start_at && this.conversation)?[_c('v-divider'),_vm._v(" "),_c('messenger-chat',{attrs:{"no-header":"","conversation":_vm.conversation}}),_vm._v(" "),_c('v-divider')]:_vm._e()],2)}
var Availability_staticRenderFns = []
var Availability_esExports = { render: Availability_render, staticRenderFns: Availability_staticRenderFns }
/* harmony default export */ var purchase_Availability = (Availability_esExports);
// CONCATENATED MODULE: ./src/components/purchase/Availability.vue
var Availability_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Availability___vue_template_functional__ = false
/* styles */
var Availability___vue_styles__ = null
/* scopeId */
var Availability___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Availability___vue_module_identifier__ = null
var Availability_Component = Availability_normalizeComponent(
  Availability,
  purchase_Availability,
  Availability___vue_template_functional__,
  Availability___vue_styles__,
  Availability___vue_scopeId__,
  Availability___vue_module_identifier__
)

/* harmony default export */ var components_purchase_Availability = __webpack_exports__["a"] = (Availability_Component.exports);


/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_default__ = __webpack_require__(35);




var sort = function sort(sortBy, descending) {
  return sortBy && [descending ? '-' : '+', sortBy.trim()].join('') || '';
};

var fetchAll = function fetchAll(filter) {
  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filter, {
    sort: sort(filter.sortBy, filter.descending)
  });
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().get('/users?' + __WEBPACK_IMPORTED_MODULE_2__utils_default__["a" /* default */].dataToUrlString(data));
};

var fetch = function fetch(_ref) {
  var id = _ref.id;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().get('/users/' + id);
};

var create = function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().post('/users', data);
};

var save = function save(_ref2) {
  var id = _ref2.id,
      data = _ref2.data;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().put('/users/' + id, data);
};

var lock = function lock(_ref3) {
  var id = _ref3.id,
      reason = _ref3.reason;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().post('/users/' + id + '/lock', { reason: reason });
};

var unlock = function unlock(_ref4) {
  var id = _ref4.id,
      reason = _ref4.reason;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().post('/users/' + id + '/unlock', { reason: reason });
};

var risk = function risk(_ref5) {
  var id = _ref5.id,
      reason = _ref5.reason;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().post('/users/' + id + '/risky', { reason: reason });
};

var unrisk = function unrisk(_ref6) {
  var id = _ref6.id,
      reason = _ref6.reason;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().post('/users/' + id + '/unrisky', { reason: reason });
};

var exportUsers = function exportUsers() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().post('/users/export');
};

var importUsers = function importUsers(_ref7) {
  var file = _ref7.file,
      email_notification = _ref7.email_notification;

  var params = new FormData();
  params.append('file', file);
  params.append('email_notification', email_notification);
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().post('/users/import', params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchAll: fetchAll,
  fetch: fetch,
  lock: lock,
  unlock: unlock,
  save: save,
  create: create,
  exportUsers: exportUsers,
  risk: risk,
  unrisk: unrisk,
  importUsers: importUsers
});

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(11);



var paramsToUrlParams = function paramsToUrlParams(obj) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
    return [key, obj[key]].join('=');
  }).join('&');
};

var purchases = function purchases(_ref) {
  var _ref$params = _ref.params,
      params = _ref$params === undefined ? {} : _ref$params;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().get('/stats/revenue?scope=finished&' + paramsToUrlParams(params));
};

var offersRevenue = function offersRevenue(_ref2) {
  var _ref2$params = _ref2.params,
      params = _ref2$params === undefined ? {} : _ref2$params;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().get('/stats/offers_revenue?scope=finished&' + paramsToUrlParams(params));
};

var sessions = function sessions(_ref3) {
  var _ref3$params = _ref3.params,
      params = _ref3$params === undefined ? {} : _ref3$params;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().get('/stats/visits?' + paramsToUrlParams(params));
};

var newVsReturning = function newVsReturning(_ref4) {
  var _ref4$params = _ref4.params,
      params = _ref4$params === undefined ? {} : _ref4$params;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().get('/stats/new_vs_returning?' + paramsToUrlParams(params));
};

var gains = function gains(_ref5) {
  var _ref5$params = _ref5.params,
      params = _ref5$params === undefined ? {} : _ref5$params;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().get('/stats/gains?' + paramsToUrlParams(params));
};

var expertStats = function expertStats(_ref6) {
  var _ref6$params = _ref6.params,
      params = _ref6$params === undefined ? {} : _ref6$params;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().get('/stats/calls?' + paramsToUrlParams(params));
};

var generalExpertStats = function generalExpertStats(_ref7) {
  var _ref7$params = _ref7.params,
      params = _ref7$params === undefined ? {} : _ref7$params;
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_http__["a" /* default */])().get('/stats/experts?' + paramsToUrlParams(params));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  purchases: purchases,
  offersRevenue: offersRevenue,
  sessions: sessions,
  newVsReturning: newVsReturning,
  gains: gains,
  expertStats: expertStats,
  generalExpertStats: generalExpertStats
});

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/mixins/pagination.js
var pagination = __webpack_require__(115);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Activities.vue






/* harmony default export */ var Activities = ({
  components: {
    Date: formatters["a" /* Date */]
  },
  props: {
    userId: {
      type: Number,
      default: null
    },
    adminId: {
      type: Number,
      default: null
    }
  },
  mixins: [Object(pagination["a" /* default */])('skiliko/activities')],
  data: function data() {
    return {
      filter: {
        user_id: this.userId,
        admin_id: this.adminId,
        page: 1,
        per_page: 10
      }
    };
  },

  computed: Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform'
  }),
  methods: {
    prevPage: function prevPage() {
      this.filter = extends_default()({}, this.filter, {
        page: this.filter.page - 1
      });
    },
    nextPage: function nextPage() {
      this.filter = extends_default()({}, this.filter, {
        page: this.filter.page + 1
      });
    },
    data: function data(activity) {
      return extends_default()({}, activity.data, {
        nickname: activity.user ? activity.user.nickname : '',
        amount: activity.data ? activity.data.amount / 100 : null,
        currency: this.platform.currency
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb2f7914","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activities.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_vm._l((_vm.activities),function(activity){return _c('v-list-tile',{key:activity.id,attrs:{"router":"","href":activity.user ? { name: 'User', params: { id: activity.user.id, tab: 'profile' } } : '#'}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(("activities.type." + (activity.action)), _vm.data(activity))))]),_vm._v(" "),(activity.admin || activity.reason)?_c('v-list-tile-sub-title',[(activity.admin)?_c('span',[_vm._v(_vm._s(activity.admin.nickname))]):_vm._e(),_vm._v(" "),(activity.reason)?_c('span',[_vm._v("- "+_vm._s(activity.reason))]):_vm._e(),_vm._v(" "),(activity.data)?_c('span',[_vm._v("- "+_vm._s(Object.keys(activity.data).map(function (x) { return (x + ": " + (activity.data[x])); }).join(', ')))]):_vm._e()]):_c('v-list-tile-sub-title',[_vm._v("\n        "+_vm._s(_vm.$t(("activities.reason." + (activity.action)), _vm.data(activity)))+"\n      ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('Date',{staticClass:"caption",attrs:{"value":activity.created_at,"format":"minimal"}})],1)],1)}),_vm._v(" "),(_vm.pagination.page > 1 || _vm.pagination.nextPage || _vm.loading)?_c('v-list-tile',[_c('v-list-tile-action',[(_vm.pagination.page > 1)?_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.prevPage()}}},[_c('v-icon',[_vm._v("chevron_left")])],1):_vm._e()],1),_vm._v(" "),_c('v-list-tile-content',{attrs:{"justify-center":"","align-center":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',[(_vm.pagination.nextPage)?_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.nextPage()}}},[_c('v-icon',[_vm._v("chevron_right")])],1):_vm._e()],1)],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Activities = (esExports);
// CONCATENATED MODULE: ./src/components/Activities.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Activities,
  components_Activities,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Activities = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// CONCATENATED MODULE: ./src/mixins/chatMessage.js


/* harmony default export */ var chatMessage = ({
  props: {
    user: {
      type: [Object, Array, String],
      required: true
    },
    redirect: {
      type: Boolean,
      default: false
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'skiliko/messages/isLoading',
    currentPlatform: 'skiliko/session/currentPlatform'
  }), {
    chatableUsers: function chatableUsers() {
      if (this.user === 'all') {
        return null;
      }
      if (Array.isArray(this.user)) {
        return this.user.map(function (e) {
          return e._id;
        });
      } else {
        return [this.user._id];
      }
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    _send: 'skiliko/messages/create'
  }), {
    send: function send(_ref) {
      var _this = this;

      var content = _ref.content,
          _ref$data = _ref.data,
          data = _ref$data === undefined ? {} : _ref$data;

      var query = {
        platform: this.currentPlatform.token,
        scope: 'user'
      };
      if (this.chatableUsers) {
        query.ids = this.chatableUsers;
      }
      return this._send({
        content: content,
        data: data,
        query: query
      }).then(function (message) {
        if (_this.redirect) {
          _this.$router.push({
            name: 'MessengerMessage',
            params: {
              id: message.conversation
            }
          });
        }
      });
    },
    sendToConversation: function sendToConversation(conversationId, message) {
      var _this2 = this;

      return this._send({
        conversationId: conversationId,
        from: this.user._id,
        content: message
      }).then(function (message) {
        if (_this2.redirect) {
          _this2.$router.push({
            name: 'MessengerMessage',
            params: {
              id: message.conversation
            }
          });
        }
      });
    }
  })
});
// EXTERNAL MODULE: ./src/components/inputs/index.js + 75 modules
var inputs = __webpack_require__(170);

// CONCATENATED MODULE: ./src/mixins/autoOpenModal.js
/* harmony default export */ var autoOpenModal = ({
  data: function data() {
    return {
      modal: false
    };
  },

  watch: {
    modal: function modal() {
      var _this = this;

      if (!this.modal) {
        this.$nextTick(function () {
          return _this.$emit('closeModal');
        });
      }
    }
  },
  methods: {
    close: function close() {
      this.modal = false;
    }
  },
  mounted: function mounted() {
    this.modal = true;
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/actions/FileUpload.vue





/* harmony default export */ var FileUpload = ({
  components: {
    FileInput: inputs["i" /* FileInput */]
  },
  mixins: [autoOpenModal, chatMessage],
  data: function data() {
    return {
      file: null
    };
  },

  computed: {
    filename: function filename() {
      if (!this.file) {
        return null;
      }
      return this.file.split('/').reverse()[0];
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.send({
        content: this.file,
        data: {
          type: 'file',
          url: this.file
        }
      }).then(function (_) {
        return _this.close();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e64e02","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/actions/FileUpload.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"640px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('messenger.actions.fileupload.title')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('file-input',{attrs:{"config":{
        label: _vm.$t('messenger.actions.fileupload.labels.file'),
        path: 'chat'
      }},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}}),_vm._v(" "),_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm.filename))])],1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"disabled":!_vm.file,"loading":_vm.loading,"primary":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.submit()}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.fileupload.submit')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var actions_FileUpload = (esExports);
// CONCATENATED MODULE: ./src/components/messenger/actions/FileUpload.vue
function injectStyle (ssrContext) {
  __webpack_require__(661)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36e64e02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FileUpload,
  actions_FileUpload,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var messenger_actions_FileUpload = (Component.exports);

// EXTERNAL MODULE: ./src/api/service.js
var service = __webpack_require__(91);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// EXTERNAL MODULE: ./src/components/messenger/previews/Offer.vue + 2 modules
var Offer = __webpack_require__(116);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/actions/ShareOffer.vue









/* harmony default export */ var ShareOffer = ({
  components: {
    Price: formatters["d" /* Price */],
    OfferPreview: Offer["a" /* default */]
  },
  mixins: [autoOpenModal, chatMessage],
  data: function data() {
    return {
      step: 1,
      scope: 'public',
      message: null,
      offer: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    servicesLoading: 'skiliko/services/isLoading',
    servicesByScope: 'skiliko/services/servicesByScope'
  }), {
    scopes: function scopes() {
      var _this = this;

      return service["a" /* default */].AVAILABLE_SCOPES.map(function (e) {
        return { name: _this.$t('messenger.actions.shareoffer.scopes.' + e), code: e };
      });
    },
    services: function services() {
      return this.servicesByScope[this.scope] || [];
    }
  }),
  watch: {
    scope: function scope() {
      this.fetchAll({ scope: this.scope });
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetchAll: 'skiliko/services/fetchAll'
  }), {
    select: function select(offer) {
      this.offer = offer;
      this.step = 3;
    },
    submit: function submit() {
      var _this2 = this;

      this.send({
        content: this.message,
        data: extends_default()({}, this.offer, { type: 'offer' })
      }).then(function (_) {
        return _this2.close();
      });
    }
  }),
  mounted: function mounted() {
    this.fetchAll({ scope: this.scope });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dc119e2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/actions/ShareOffer.vue
var ShareOffer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"640px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('messenger.actions.shareoffer.title.default')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-stepper',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"editable":"","step":1,"complete":_vm.step > 1}},[_vm._v(_vm._s(_vm.$t('messenger.actions.shareoffer.title.kind')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"editable":"","step":2,"complete":_vm.step > 2}},[_vm._v(_vm._s(_vm.$t('messenger.actions.shareoffer.title.offer')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"editable":"","step":3}},[_vm._v(_vm._s(_vm.$t('messenger.actions.shareoffer.title.message')))])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":1}},[_c('v-select',{attrs:{"label":_vm.$t('messenger.actions.shareoffer.labels.scope'),"items":_vm.scopes,"item-text":"name","item-value":"code"},model:{value:(_vm.scope),callback:function ($$v) {_vm.scope=$$v},expression:"scope"}})],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":2}},[_c('v-list',{attrs:{"two-line":"","subheader":""}},_vm._l((_vm.services),function(offer){return _c('v-list-item',{key:offer.id},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                    "+_vm._s(offer.title)+"\n                  ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('price',{attrs:{"value":offer.price}})],1)],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"primary":"","outline":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.select(offer)}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.shareoffer.select')))])],1)],1)],1)}),1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":3}},[(_vm.offer)?_c('offer-preview',{attrs:{"value":_vm.offer}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('messenger.actions.shareoffer.labels.message'),"autofocus":"","multi-line":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[(_vm.step === 1)?_c('v-btn',{attrs:{"primary":"","light":""},nativeOn:{"click":function($event){_vm.step = 2}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.shareoffer.next')))]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('v-btn',{attrs:{"primary":"","light":""},nativeOn:{"click":function($event){_vm.step = 3}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.shareoffer.next')))]):_vm._e(),_vm._v(" "),(_vm.step === 3)?_c('v-btn',{attrs:{"loading":_vm.loading,"primary":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.submit()}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.shareoffer.submit')))]):_vm._e()],1)],1)],1)}
var ShareOffer_staticRenderFns = []
var ShareOffer_esExports = { render: ShareOffer_render, staticRenderFns: ShareOffer_staticRenderFns }
/* harmony default export */ var actions_ShareOffer = (ShareOffer_esExports);
// CONCATENATED MODULE: ./src/components/messenger/actions/ShareOffer.vue
var ShareOffer_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var ShareOffer___vue_template_functional__ = false
/* styles */
var ShareOffer___vue_styles__ = null
/* scopeId */
var ShareOffer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ShareOffer___vue_module_identifier__ = null
var ShareOffer_Component = ShareOffer_normalizeComponent(
  ShareOffer,
  actions_ShareOffer,
  ShareOffer___vue_template_functional__,
  ShareOffer___vue_styles__,
  ShareOffer___vue_scopeId__,
  ShareOffer___vue_module_identifier__
)

/* harmony default export */ var messenger_actions_ShareOffer = (ShareOffer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/actions/SharePage.vue







/* harmony default export */ var SharePage = ({
  components: {
    OfferPreview: Offer["a" /* default */]
  },
  mixins: [autoOpenModal, chatMessage],
  data: function data() {
    return {
      step: 1,
      scope: 'news',
      message: null,
      page: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    servicesLoading: 'skiliko/services/isLoading',
    servicesByScope: 'skiliko/services/servicesByScope',
    categories: 'skiliko/services/categories'
  }), {
    pages: function pages() {
      return this.servicesByScope[this.scope] || [];
    }
  }),
  watch: {
    scope: function scope() {
      this.fetchAll({ scope: this.scope });
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetchAll: 'skiliko/services/fetchAll'
  }), {
    select: function select(page) {
      this.page = page;
      this.step = 3;
    },
    submit: function submit() {
      var _this = this;

      this.send({
        content: this.message,
        data: extends_default()({}, this.page, { type: 'page' })
      }).then(function (_) {
        return _this.close();
      });
    }
  }),
  mounted: function mounted() {
    this.fetchAll({ scope: this.scope });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7027ab69","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/actions/SharePage.vue
var SharePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"640px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('messenger.actions.sharepage.title.default')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-stepper',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"editable":"","step":1,"complete":_vm.step > 1}},[_vm._v(_vm._s(_vm.$t('messenger.actions.sharepage.title.kind')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"editable":"","step":2,"complete":_vm.step > 2}},[_vm._v(_vm._s(_vm.$t('messenger.actions.sharepage.title.page')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"editable":"","step":3}},[_vm._v(_vm._s(_vm.$t('messenger.actions.sharepage.title.message')))])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":1}},[_c('v-select',{attrs:{"label":_vm.$t('messenger.actions.sharepage.labels.scope'),"items":_vm.categories,"item-text":"name","item-value":"code"},model:{value:(_vm.scope),callback:function ($$v) {_vm.scope=$$v},expression:"scope"}})],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":2}},[_c('v-list',{attrs:{"two-line":"","subheader":""}},_vm._l((_vm.pages),function(page){return _c('v-list-item',{key:page.id},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                    "+_vm._s(page.title)+"\n                  ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"primary":"","outline":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.select(page)}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.sharepage.select')))])],1)],1)],1)}),1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":3}},[(_vm.page)?_c('offer-preview',{attrs:{"value":_vm.page}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('messenger.actions.sharepage.labels.message'),"autofocus":"","multi-line":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[(_vm.step === 1)?_c('v-btn',{attrs:{"primary":"","light":""},nativeOn:{"click":function($event){_vm.step = 2}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.sharepage.next')))]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('v-btn',{attrs:{"primary":"","light":""},nativeOn:{"click":function($event){_vm.step = 3}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.sharepage.next')))]):_vm._e(),_vm._v(" "),(_vm.step === 3)?_c('v-btn',{attrs:{"loading":_vm.loading,"primary":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.submit()}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.sharepage.submit')))]):_vm._e()],1)],1)],1)}
var SharePage_staticRenderFns = []
var SharePage_esExports = { render: SharePage_render, staticRenderFns: SharePage_staticRenderFns }
/* harmony default export */ var actions_SharePage = (SharePage_esExports);
// CONCATENATED MODULE: ./src/components/messenger/actions/SharePage.vue
var SharePage_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var SharePage___vue_template_functional__ = false
/* styles */
var SharePage___vue_styles__ = null
/* scopeId */
var SharePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SharePage___vue_module_identifier__ = null
var SharePage_Component = SharePage_normalizeComponent(
  SharePage,
  actions_SharePage,
  SharePage___vue_template_functional__,
  SharePage___vue_styles__,
  SharePage___vue_scopeId__,
  SharePage___vue_module_identifier__
)

/* harmony default export */ var messenger_actions_SharePage = (SharePage_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__(662);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/actions/CreateAppointment.vue







/* harmony default export */ var CreateAppointment = ({
  mixins: [autoOpenModal, chatMessage],
  data: function data() {
    var currentTime = new Date();
    return {
      step: 1,
      day: this.formatDate(currentTime),
      hour: this.formatHour(currentTime)
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    currentExpert: 'skiliko/session/currentUser',
    platform: 'skiliko/session/currentPlatform',
    callLoading: 'skiliko/call/isLoading'
  }), {
    callAtISOString: function callAtISOString() {
      var _day$split = this.day.split('-'),
          _day$split2 = slicedToArray_default()(_day$split, 3),
          year = _day$split2[0],
          month = _day$split2[1],
          day = _day$split2[2];

      var _hour$split = this.hour.split(':'),
          _hour$split2 = slicedToArray_default()(_hour$split, 2),
          hour = _hour$split2[0],
          minutes = _hour$split2[1];

      var currentDate = new Date(year, month - 1, day, hour, minutes);
      var formattedDate = this.formatDate(currentDate, true);
      var formattedHour = this.formatHour(currentDate, true);
      return formattedDate + 'T' + formattedHour + ':00.000Z';
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    createAppointment: 'skiliko/call/createAppointment'
  }), {
    strTime: function strTime(number) {
      return ('0' + number).substr(-2);
    },
    formatDate: function formatDate(date) {
      var utc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var x = utc ? 'UTC' : '';
      return [date['get' + x + 'FullYear'](), this.strTime(date['get' + x + 'Month']() + 1), this.strTime(date['get' + x + 'Date']())].join('-');
    },
    formatHour: function formatHour(date) {
      var utc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var x = utc ? 'UTC' : '';
      return [this.strTime(date['get' + x + 'Hours']()), this.strTime(date['get' + x + 'Minutes']())].join(':');
    },
    allowedDates: function allowedDates(date) {
      return +date >= +new Date();
    },
    content: function content(appointment) {
      return [this.$t('messenger.actions.createappointment.message', this.currentExpert), [this.platform.url, 'transactions', appointment.id].join('/')].join(' ');
    },
    submit: function submit() {
      var _this = this;

      this.createAppointment({
        userId: this.user.externalId,
        adminId: this.currentExpert.id,
        callAt: this.callAtISOString
      }).then(function (appointment) {
        return _this.send({
          content: _this.content(appointment)
        });
      }).then(function (_) {
        return _this.close();
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7c1a22","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/actions/CreateAppointment.vue
var CreateAppointment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"640px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('messenger.actions.createappointment.title.default')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-stepper',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"editable":"","step":1,"complete":_vm.step > 1}},[_vm._v(_vm._s(_vm.$t('messenger.actions.createappointment.title.day')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"editable":"","step":2,"complete":_vm.step > 2}},[_vm._v(_vm._s(_vm.$t('messenger.actions.createappointment.title.hour')))])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":1}},[_c('h4',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.$t('messenger.actions.createappointment.labels.day')))]),_vm._v(" "),_c('v-date-picker',{attrs:{"allowed-dates":_vm.allowedDates,"actions":true,"scrollable":"","landscape":""},model:{value:(_vm.day),callback:function ($$v) {_vm.day=$$v},expression:"day"}})],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":2}},[_c('h4',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.$t('messenger.actions.createappointment.labels.hour')))]),_vm._v(" "),_c('v-time-picker',{attrs:{"actions":true,"format":"24hr","scrollable":"","landscape":""},model:{value:(_vm.hour),callback:function ($$v) {_vm.hour=$$v},expression:"hour"}})],1)],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[(_vm.step === 1)?_c('v-btn',{attrs:{"primary":"","light":""},nativeOn:{"click":function($event){_vm.step = 2}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.createappointment.next')))]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('v-btn',{attrs:{"loading":_vm.loading || _vm.callLoading,"primary":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.submit()}}},[_vm._v(_vm._s(_vm.$t('messenger.actions.createappointment.submit')))]):_vm._e()],1)],1)],1)}
var CreateAppointment_staticRenderFns = []
var CreateAppointment_esExports = { render: CreateAppointment_render, staticRenderFns: CreateAppointment_staticRenderFns }
/* harmony default export */ var actions_CreateAppointment = (CreateAppointment_esExports);
// CONCATENATED MODULE: ./src/components/messenger/actions/CreateAppointment.vue
var CreateAppointment_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var CreateAppointment___vue_template_functional__ = false
/* styles */
var CreateAppointment___vue_styles__ = null
/* scopeId */
var CreateAppointment___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateAppointment___vue_module_identifier__ = null
var CreateAppointment_Component = CreateAppointment_normalizeComponent(
  CreateAppointment,
  actions_CreateAppointment,
  CreateAppointment___vue_template_functional__,
  CreateAppointment___vue_styles__,
  CreateAppointment___vue_scopeId__,
  CreateAppointment___vue_module_identifier__
)

/* harmony default export */ var messenger_actions_CreateAppointment = (CreateAppointment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/Menu.vue







/* harmony default export */ var Menu = ({
  mixins: [chatMessage],
  props: {
    actions: {
      type: Array,
      default: function _default() {
        return [{ key: 'upload', component: messenger_actions_FileUpload }, { key: 'share', component: messenger_actions_ShareOffer }, { key: 'page', component: messenger_actions_SharePage }, { key: 'appointment', component: messenger_actions_CreateAppointment }];
      }
    }
  },
  data: function data() {
    return {
      selectedAction: null
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d07203e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/Menu.vue
var Menu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.actions.length)?_c('v-menu',{attrs:{"top":"","right":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.actions),function(action){return _c('v-list-item',{key:action.key},[_c('v-list-tile',{nativeOn:{"click":function($event){_vm.selectedAction = action}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(("messenger.menu.actions." + (action.key)))))])],1)],1)}),1)],1):_vm._e(),_vm._v(" "),(_vm.selectedAction)?_c(_vm.selectedAction.component,_vm._b({tag:"component",attrs:{"user":_vm.user},on:{"closeModal":function($event){_vm.selectedAction = null}}},'component',_vm.selectedAction.data,false)):_vm._e()],1)}
var Menu_staticRenderFns = []
var Menu_esExports = { render: Menu_render, staticRenderFns: Menu_staticRenderFns }
/* harmony default export */ var messenger_Menu = (Menu_esExports);
// CONCATENATED MODULE: ./src/components/messenger/Menu.vue
var Menu_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Menu___vue_template_functional__ = false
/* styles */
var Menu___vue_styles__ = null
/* scopeId */
var Menu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Menu___vue_module_identifier__ = null
var Menu_Component = Menu_normalizeComponent(
  Menu,
  messenger_Menu,
  Menu___vue_template_functional__,
  Menu___vue_styles__,
  Menu___vue_scopeId__,
  Menu___vue_module_identifier__
)

/* harmony default export */ var components_messenger_Menu = (Menu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messenger/MessageForm.vue





/* harmony default export */ var MessageForm = ({
  components: {
    MessengerMenu: components_messenger_Menu,
    TextInput: inputs["t" /* TextInput */]
  },
  mixins: [chatMessage],
  props: {
    conversationId: {
      type: String
    }
  },
  data: function data() {
    return {
      message: null
    };
  },

  methods: {
    submit: function submit(e) {
      var _this = this;

      if (e && e.shiftKey) return;
      if (this.conversationId) {
        this.sendToConversation(this.conversationId, this.message).then(function (message) {
          _this.message = null;
        });
      } else {
        this.send({ content: this.message }).then(function (message) {
          _this.message = null;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-267d0e84","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/MessageForm.vue
var MessageForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-message"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('messenger-menu',{attrs:{"user":_vm.user}}),_vm._v(" "),_c('div',{staticClass:"input-group input-group--focused input-group--dirty input-group--dark input-group--hide-details input-group--text-field input-group--single-line input-group--multi-line input-group--full-width",attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"input-group__input"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],attrs:{"tabindex":"0","rows":"2","autofocus":""},domProps:{"value":(_vm.message)},on:{"!keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})])]),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","icon":"","loading":_vm.loading}},[_c('v-icon',[_vm._v("send")])],1)],1)])}
var MessageForm_staticRenderFns = []
var MessageForm_esExports = { render: MessageForm_render, staticRenderFns: MessageForm_staticRenderFns }
/* harmony default export */ var messenger_MessageForm = (MessageForm_esExports);
// CONCATENATED MODULE: ./src/components/messenger/MessageForm.vue
function MessageForm_injectStyle (ssrContext) {
  __webpack_require__(629)
  __webpack_require__(630)
}
var MessageForm_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var MessageForm___vue_template_functional__ = false
/* styles */
var MessageForm___vue_styles__ = MessageForm_injectStyle
/* scopeId */
var MessageForm___vue_scopeId__ = "data-v-267d0e84"
/* moduleIdentifier (server only) */
var MessageForm___vue_module_identifier__ = null
var MessageForm_Component = MessageForm_normalizeComponent(
  MessageForm,
  messenger_MessageForm,
  MessageForm___vue_template_functional__,
  MessageForm___vue_styles__,
  MessageForm___vue_scopeId__,
  MessageForm___vue_module_identifier__
)

/* harmony default export */ var components_messenger_MessageForm = __webpack_exports__["a"] = (MessageForm_Component.exports);


/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(11);


var fetchAll = function fetchAll(_ref) {
  var page = _ref.page,
      status = _ref.status;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().get('/ratings?page=' + page + '&status=' + status);
};

var accept = function accept(_ref2) {
  var id = _ref2.id;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().post('/ratings/' + id + '/accept');
};

var reject = function reject(_ref3) {
  var id = _ref3.id;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().post('/ratings/' + id + '/reject');
};

var save = function save(_ref4) {
  var id = _ref4.id,
      data = _ref4.data;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().put('/ratings/' + id, data);
};

var canAccept = function canAccept(feedback) {
  return !feedback.accepted_at || feedback.rejected_at;
};

var canReject = function canReject(feedback) {
  return !feedback.rejected_at;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchAll: fetchAll,
  accept: accept,
  reject: reject,
  save: save,
  canAccept: canAccept,
  canReject: canReject
});

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__(26);
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__(130);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__(403);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(90);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__(587);
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__(588);
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(88);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/vue-clipboard2/vue-clipboard.js
var vue_clipboard = __webpack_require__(589);
var vue_clipboard_default = /*#__PURE__*/__webpack_require__.n(vue_clipboard);

// CONCATENATED MODULE: ./src/plugins/authorisations.js
/* harmony default export */ var authorisations = (function (Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    authorisations: function authorisations(currentUser) {},
    currentUser: function currentUser(store) {
      return store.getters['currentUser'];
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var _this = this;

      var currentUser = options.currentUser,
          authorisations = options.authorisations;


      this.$can = function (action, entity) {
        return authorisations(currentUser(_this.$store))[entity][action];
      };
      this.$cannot = function (action, entity) {
        return !_this.$can(action, entity);
      };
    }
  });
});
// EXTERNAL MODULE: ./src/api/currentExpert.js
var currentExpert = __webpack_require__(172);

// CONCATENATED MODULE: ./src/authorisations/index.js


var DASHBOARD_PLATFORM_DISTRIBUTION_DATE = new Date('2021-10-27T00:00:00.000Z');

/* harmony default export */ var src_authorisations = (function (_ref) {
  var user = _ref.user,
      platform = _ref.platform;

  var isAdmin = currentExpert["a" /* default */].isAdmin(user);
  var isRestricted = currentExpert["a" /* default */].isRestricted(user);
  var isMulti = platform.multi_experts;

  return {
    customers: {
      view: isAdmin
    },
    feedbacks: {
      edit: isAdmin,
      editPublished: isAdmin,
      viewBlocked: isAdmin
    },
    messenger: {
      use: !isRestricted
    },
    platformDistribution: {
      view: isAdmin && isMulti && new Date(platform.created_at) > DASHBOARD_PLATFORM_DISTRIBUTION_DATE
    },
    platformIncomes: {
      view: isAdmin
    },
    platformTraffic: {
      view: isAdmin
    },
    platformAvailabilities: {
      view: isMulti
    },
    platform: {
      customize: isAdmin,
      admin: isAdmin
    },
    links: {
      customize: isAdmin
    },
    services: {
      update: isAdmin,
      assign: isMulti && isAdmin
    },
    team: {
      manage: isAdmin && isMulti,
      viewStats: isAdmin && isMulti
    },
    transfers: {
      manage: platform.settings.payment_provider !== 'payline'
    },
    call: {
      listen: isAdmin
    }
  };
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__(31);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__(92);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(93);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./src/mixins/soundNotification.js


var MAX_PLAY = 15;
var DELAY = 1000;
var audio = new Audio('/static/notification.mp3');

/* harmony default export */ var soundNotification = ({
  data: function data() {
    return {
      notificationCount: 0,
      timeout: null
    };
  },

  methods: {
    clear: function clear() {
      audio.pause();
      audio.currentTime = 0;
      clearTimeout(this.timeout);
      this.notificationCount = 0;
    },
    playNotification: function playNotification() {
      var _this = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                audio.pause();
                audio.currentTime = 0;
                _context.prev = 2;
                _context.next = 5;
                return audio.play();

              case 5:
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](2);

              case 9:
                if (_this.notificationCount < MAX_PLAY) {
                  _this.notificationCount++;
                  _this.timeout = setTimeout(function () {
                    return _this.playNotification();
                  }, DELAY);
                } else {
                  _this.clear();
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 7]]);
      }))();
    }
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(40);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./src/utils/default.js
var utils_default = __webpack_require__(35);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ApplicationMenuItem.vue


/* harmony default export */ var ApplicationMenuItem = ({
  props: {
    route: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff7863a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApplicationMenuItem.vue
var ApplicationMenuItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-tile',{attrs:{"router":"","href":_vm.route,"exact":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: ApplicationMenuItem_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_ApplicationMenuItem = (esExports);
// CONCATENATED MODULE: ./src/components/ApplicationMenuItem.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ApplicationMenuItem,
  components_ApplicationMenuItem,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_ApplicationMenuItem = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ApplicationMenu.vue







/* harmony default export */ var ApplicationMenu = ({
  components: {
    ApplicationMenuItem: src_components_ApplicationMenuItem
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    open: 'application/menuOpen',
    servicesScopes: 'skiliko/services/offers',
    categories: 'skiliko/services/categories',
    currentUser: 'skiliko/session/currentUser'
  }), {
    scopesMetas: function scopesMetas() {
      return {
        public: { icon: 'public', title: this.$t('applicationmenu.menu.services.public') },
        promotion: { icon: 'local_activity', title: this.$t('applicationmenu.menu.services.promotions') },
        private: { icon: 'vpn_lock', title: this.$t('applicationmenu.menu.services.private') }
      };
    },
    menuList: function menuList() {
      var _this = this;

      return [{
        title: this.$t('applicationmenu.menu.dashboard.default'),
        icon: 'dashboard',
        children: [{ title: this.$t('applicationmenu.menu.dashboard.todo'), route: { name: 'Dashboard' }, icon: 'list' }, { title: this.$t('applicationmenu.menu.dashboard.revenues'), route: { name: 'PlatformRevenues' }, icon: 'equalizer', if: function _if() {
            return _this.$can('view', 'platformIncomes');
          } }, { title: this.$t('applicationmenu.menu.dashboard.gains'), route: { name: 'Gains' }, icon: 'attach_money' }, { title: this.$t('applicationmenu.menu.dashboard.availabilities'), route: { name: 'Availabilities' }, icon: 'event_available', if: function _if() {
            return _this.$can('view', 'platformAvailabilities');
          } }, { title: this.$t('applicationmenu.menu.dashboard.statistics'), route: { name: 'Statistics' }, icon: 'insert_chart' }, { title: this.$t('applicationmenu.menu.dashboard.accounts'), route: { name: 'Accounts' }, icon: 'calculate', if: function _if() {
            return _this.$can('view', 'platformDistribution');
          } }]
      }, { title: this.$t('applicationmenu.menu.customers'), route: { name: 'Users' }, icon: 'people', if: function _if() {
          return _this.$can('view', 'customers');
        } }, { title: this.$t('applicationmenu.menu.messenger'), route: { name: 'Messenger' }, icon: 'chat', if: function _if() {
          return _this.$can('use', 'messenger');
        } }, { title: this.$t('applicationmenu.menu.purchases'), route: { name: 'Purchases' }, icon: 'local_atm' }, {
        title: this.$t('applicationmenu.menu.feedbacks.default'),
        icon: 'rate_review',
        children: [{ title: this.$t('applicationmenu.menu.feedbacks.pending'), route: { name: 'FeedbacksPending' }, icon: 'sms' }, { title: this.$t('applicationmenu.menu.feedbacks.accepted'), route: { name: 'FeedbacksAccepted' }, icon: 'done' }, { title: this.$t('applicationmenu.menu.feedbacks.rejected'), route: { name: 'FeedbacksRejected' }, icon: 'block', if: function _if() {
            return _this.$can('viewBlocked', 'feedbacks');
          } }]
      }, {
        title: this.$t('applicationmenu.menu.services.default'),
        icon: 'perm_phone_msg',
        children: [{ title: this.$t('applicationmenu.menu.services.create'), route: { name: 'ServiceCreation' }, icon: 'add', if: function _if() {
            return _this.$can('update', 'services');
          } }].concat(toConsumableArray_default()(this.servicesScopes.map(function (scope) {
          return {
            title: _this.scopesMetas[scope].title,
            route: { name: 'Services', query: { scope: scope } },
            icon: _this.scopesMetas[scope].icon,
            if: function _if() {
              return _this.scopesMetas[scope] || _this.$can('update', 'services');
            }
          };
        })))
      }, {
        title: this.$t('applicationmenu.menu.pages.default'),
        icon: 'library_books',
        if: function _if() {
          return _this.categories.length > 0;
        },
        children: this.categories.map(function (scope) {
          return {
            title: utils_default["a" /* default */].toHumanize(scope),
            route: { name: 'Services', query: { scope: scope } },
            icon: 'description',
            if: function _if() {
              return _this.$can('update', 'services');
            }
          };
        })
      }, { title: this.$t('applicationmenu.menu.settings.team'), route: { name: 'Team' }, icon: 'group_add', if: function _if() {
          return _this.$can('manage', 'team');
        } }, { title: this.$t('applicationmenu.menu.settings.transfers'), route: { name: 'Transfers' }, icon: 'account_balance_wallet', if: function _if() {
          return _this.$can('manage', 'transfers');
        } }, { title: this.$t('applicationmenu.menu.settings.customization'), route: { name: 'Customization' }, icon: 'tune', if: function _if() {
          return _this.$can('customize', 'platform');
        } }, { title: this.$t('applicationmenu.menu.settings.links'), route: { name: 'Links' }, icon: 'link', if: function _if() {
          return _this.$can('customize', 'links');
        } }];
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    updateMenu: 'application/UPDATE_MENU'
  }), {
    valid: function valid(menu) {
      return !menu.if || menu.if && menu.if();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b970b9c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApplicationMenu.vue
var ApplicationMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"persistent":"","value":_vm.open,"light":"","enable-resize-watcher":""},on:{"input":function (value) { return _vm.updateMenu({ open: value }); }}},[_c('v-list',{staticClass:"pa-0"},[_c('v-list-item',[_c('v-list-tile',{attrs:{"avatar":"","tag":"div"}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.currentUser.picture.thumb}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.currentUser.nickname))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","router":"","href":{ name: 'Account', params: { tab: 'profile' } }}},[_c('v-icon',[_vm._v("edit")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},[_c('v-divider'),_vm._v(" "),_vm._l((_vm.menuList),function(menu,i){return [(menu.children && _vm.valid(menu))?_c('v-list-group',{key:i,attrs:{"value":menu.active}},[_c('v-list-tile',{attrs:{"slot":"item"},slot:"item"},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(menu.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(menu.title))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)],1),_vm._v(" "),_vm._l((menu.children),function(subMenu,j){return (_vm.valid(subMenu))?_c('application-menu-item',{key:j,attrs:{"route":subMenu.route,"title":subMenu.title,"icon":subMenu.icon}}):_vm._e()})],2):(_vm.valid(menu))?_c('application-menu-item',{key:i,attrs:{"route":menu.route,"title":menu.title,"icon":menu.icon}}):_vm._e()]})],2)],1)}
var ApplicationMenu_staticRenderFns = []
var ApplicationMenu_esExports = { render: ApplicationMenu_render, staticRenderFns: ApplicationMenu_staticRenderFns }
/* harmony default export */ var components_ApplicationMenu = (ApplicationMenu_esExports);
// CONCATENATED MODULE: ./src/components/ApplicationMenu.vue
var ApplicationMenu_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var ApplicationMenu___vue_template_functional__ = false
/* styles */
var ApplicationMenu___vue_styles__ = null
/* scopeId */
var ApplicationMenu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ApplicationMenu___vue_module_identifier__ = null
var ApplicationMenu_Component = ApplicationMenu_normalizeComponent(
  ApplicationMenu,
  components_ApplicationMenu,
  ApplicationMenu___vue_template_functional__,
  ApplicationMenu___vue_styles__,
  ApplicationMenu___vue_scopeId__,
  ApplicationMenu___vue_module_identifier__
)

/* harmony default export */ var src_components_ApplicationMenu = (ApplicationMenu_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(620);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

// EXTERNAL MODULE: ./src/components/Activities.vue + 2 modules
var Activities = __webpack_require__(366);

// EXTERNAL MODULE: ./src/components/purchase/Availability.vue + 5 modules
var Availability = __webpack_require__(363);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/purchase/popup/Availability.vue




/* harmony default export */ var popup_Availability = ({
  components: { PurchaseDetail: Availability["a" /* default */] },
  props: {
    purchase: {
      type: Object,
      required: true
    }
  },
  methods: Object(vuex_esm["b" /* mapActions */])({
    accept: 'skiliko/purchases/accept'
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b69ac0d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchase/popup/Availability.vue
var Availability_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.purchase.offer.title)+" -- "+_vm._s(_vm.purchase.user.nickname))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('purchase-detail',{attrs:{"purchase":_vm.purchase}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),(!_vm.purchase.accepted_at)?_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"primary":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.accept({ id: _vm.purchase.id })}}},[_vm._v("\n      Accept\n    ")])],1):_vm._e()],1)}
var Availability_staticRenderFns = []
var Availability_esExports = { render: Availability_render, staticRenderFns: Availability_staticRenderFns }
/* harmony default export */ var purchase_popup_Availability = (Availability_esExports);
// CONCATENATED MODULE: ./src/components/purchase/popup/Availability.vue
function injectStyle (ssrContext) {
  __webpack_require__(625)
}
var Availability_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Availability___vue_template_functional__ = false
/* styles */
var Availability___vue_styles__ = injectStyle
/* scopeId */
var Availability___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Availability___vue_module_identifier__ = null
var Availability_Component = Availability_normalizeComponent(
  popup_Availability,
  purchase_popup_Availability,
  Availability___vue_template_functional__,
  Availability___vue_styles__,
  Availability___vue_scopeId__,
  Availability___vue_module_identifier__
)

/* harmony default export */ var components_purchase_popup_Availability = (Availability_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__(113);
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/extensions/credit/value.vue








/* harmony default export */ var value = ({
  components: {
    Price: formatters["d" /* Price */]
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform',
    currentUser: 'skiliko/session/currentUser'
  }), {
    extension: function extension() {
      return this.platform.metadata.extensions['credit'];
    }
  }),
  methods: {
    pay: function pay() {
      var _this = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        var endpoint, response, _ref, id, error, stripe;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = 'https://functions.' + "liveconsult.io" + '/stripe-session';
                _context.next = 3;
                return fetch(endpoint, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: stringify_default()({
                    price: "price_1IeGoAFKpaYfs1wHnXb6flZR",
                    quantity: 5,
                    success_url: window.location.href,
                    cancel_url: window.location.href,
                    platform: _this.platform.id.toString(),
                    platform_url: _this.platform.url,
                    email: _this.currentUser.email
                  })
                });

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();

              case 6:
                _ref = _context.sent;
                id = _ref.id;
                error = _ref.error;

                if (!error) {
                  _context.next = 11;
                  break;
                }

                throw error;

              case 11:
                stripe = window.Stripe("pk_live_bon2fkN6P0bvcI7FW2baYwbJ00zZjzKzwc");
                _context.next = 14;
                return stripe.redirectToCheckout({ sessionId: id });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2805f0d9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/extensions/credit/value.vue
var value_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extension)?_c('v-btn',{nativeOn:{"click":function($event){$event.stopPropagation();return _vm.pay.apply(null, arguments)}}},[_c('v-chip',[_c('price',{staticClass:"mr-2",attrs:{"value":_vm.extension.state.credits,"currency":_vm.platform.currency}}),_vm._v("\n    Recharger\n  ")],1)],1):_vm._e()}
var value_staticRenderFns = []
var value_esExports = { render: value_render, staticRenderFns: value_staticRenderFns }
/* harmony default export */ var credit_value = (value_esExports);
// CONCATENATED MODULE: ./src/components/extensions/credit/value.vue
var value_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var value___vue_template_functional__ = false
/* styles */
var value___vue_styles__ = null
/* scopeId */
var value___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var value___vue_module_identifier__ = null
var value_Component = value_normalizeComponent(
  value,
  credit_value,
  value___vue_template_functional__,
  value___vue_styles__,
  value___vue_scopeId__,
  value___vue_module_identifier__
)

/* harmony default export */ var extensions_credit_value = (value_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ApplicationToolbar.vue









/* harmony default export */ var ApplicationToolbar = ({
  components: {
    Activities: Activities["a" /* default */],
    AvailabilityPopup: components_purchase_popup_Availability,
    CreditValue: extensions_credit_value
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    currentUser: 'skiliko/session/currentUser',
    pending: 'skiliko/messages/pending',
    pendingConversations: 'skiliko/conversations/pending',
    pauseLoading: 'skiliko/pauses/isLoading',
    platform: 'skiliko/session/currentPlatform',
    purchases: 'skiliko/purchases/collection'
  }), {
    pendingMessagesLength: function pendingMessagesLength() {
      return keys_default()(this.pending).length;
    },
    pendingConversationsLength: function pendingConversationsLength() {
      return keys_default()(this.pendingConversations).length;
    },
    inPause: function inPause() {
      return this.currentUser.current_pause;
    },
    currentUserPurchases: function currentUserPurchases() {
      var _this = this;

      return keys_default()(this.purchases).map(function (id) {
        return _this.purchases[id];
      }).filter(function (purchase) {
        return purchase.admin_id === _this.currentUser.id;
      });
    },
    waitingForAcceptancePurchases: function waitingForAcceptancePurchases() {
      return this.currentUserPurchases.filter(function (purchase) {
        return !purchase.accepted_at && purchase.payed_at && !purchase.refunded_at;
      });
    },
    availabilityPurchases: function availabilityPurchases() {
      return this.waitingForAcceptancePurchases.filter(function (purchase) {
        return purchase.offer.service_type === 'availability';
      }).filter(function (purchase) {
        return purchase.offer.service_options.availability_type === 'chat';
      });
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggle: 'application/TOGGLE_MENU'
  }), Object(vuex_esm["b" /* mapActions */])({
    pause: 'skiliko/pauses/create',
    finishPause: 'skiliko/pauses/cancel'
  })),
  watch: {
    pendingMessagesLength: lodash_debounce_default()(function (current, previous) {
      if (window && window.document && window.document.title) {
        var defaultTitle = (window.document.title.match(/^\(\d\) (.*)$/) || [null, window.document.title])[1];
        window.document.title = current ? '(' + current + ') ' + defaultTitle : defaultTitle;
      }
    }, 100)
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36cf67e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApplicationToolbar.vue
var ApplicationToolbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"fixed":"","light":""}},[_c('v-toolbar-side-icon',{attrs:{"light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.toggle()}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Manager")]),_vm._v(" "),(_vm.$can('admin', 'platform'))?_c('CreditValue'):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"btn-toolbar-notification",attrs:{"icon":"","light":"","router":"","href":{ name: 'Messenger' }}},[(_vm.pendingMessagesLength)?_c('v-icon',{directives:[{name:"badge",rawName:"v-badge",value:({ value: _vm.pendingMessagesLength }),expression:"{ value: pendingMessagesLength }"}],staticClass:"red--after"},[_vm._v("\n      notifications\n    ")]):_vm._e()],1),_vm._v(" "),_c('v-toolbar-items',[(_vm.inPause || _vm.pauseLoading)?_c('v-btn',{attrs:{"error":"","light":"","loading":_vm.pauseLoading},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.finishPause()}}},[_vm._v("\n      "+_vm._s(_vm.$t('applicationtoolbar.finishPause'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.waitingForAcceptancePurchases.length > 0)?_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{staticClass:"btn-toolbar-notification",attrs:{"slot":"activator","light":"","icon":""},slot:"activator"},[_c('v-icon',{directives:[{name:"badge",rawName:"v-badge",value:({ value: _vm.waitingForAcceptancePurchases.length }),expression:"{ value: waitingForAcceptancePurchases.length }"}],staticClass:"red--after"},[_vm._v("\n          assignment_turned_in\n        ")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.waitingForAcceptancePurchases),function(purchase){return _c('v-list-tile',{key:purchase.id,attrs:{"nuxt":"","to":("/purchases/" + (purchase.id))}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(purchase.offer.title)+"\n            ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(purchase.user.nickname)+"\n            ")])],1)],1)}),1)],1):_vm._e(),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","light":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("notification_important")])],1),_vm._v(" "),_c('Activities',{attrs:{"small":""}})],1),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","light":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[(!_vm.inPause)?_c('v-list-item',[_c('v-list-tile',{nativeOn:{"click":function($event){return _vm.pause()}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('applicationtoolbar.pause')))])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-item',[_c('v-list-tile',{attrs:{"router":"","href":{ name: 'Account', params: { tab: 'profile' } }}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('applicationtoolbar.edit')))])],1)],1),_vm._v(" "),_c('v-list-item',[_c('v-list-tile',{attrs:{"router":"","href":{ name: 'Logout' }}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('applicationtoolbar.logout')))])],1)],1)],1)],1)],1),_vm._v(" "),(_vm.availabilityPurchases.length > 0)?_c('AvailabilityPopup',{attrs:{"purchases":_vm.availabilityPurchases}}):_vm._e()],1)}
var ApplicationToolbar_staticRenderFns = []
var ApplicationToolbar_esExports = { render: ApplicationToolbar_render, staticRenderFns: ApplicationToolbar_staticRenderFns }
/* harmony default export */ var components_ApplicationToolbar = (ApplicationToolbar_esExports);
// CONCATENATED MODULE: ./src/components/ApplicationToolbar.vue
function ApplicationToolbar_injectStyle (ssrContext) {
  __webpack_require__(619)
}
var ApplicationToolbar_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var ApplicationToolbar___vue_template_functional__ = false
/* styles */
var ApplicationToolbar___vue_styles__ = ApplicationToolbar_injectStyle
/* scopeId */
var ApplicationToolbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ApplicationToolbar___vue_module_identifier__ = null
var ApplicationToolbar_Component = ApplicationToolbar_normalizeComponent(
  ApplicationToolbar,
  components_ApplicationToolbar,
  ApplicationToolbar___vue_template_functional__,
  ApplicationToolbar___vue_styles__,
  ApplicationToolbar___vue_scopeId__,
  ApplicationToolbar___vue_module_identifier__
)

/* harmony default export */ var src_components_ApplicationToolbar = (ApplicationToolbar_Component.exports);

// EXTERNAL MODULE: ./node_modules/twilio-client/es5/twilio.js
var twilio = __webpack_require__(673);
var twilio_default = /*#__PURE__*/__webpack_require__.n(twilio);

// EXTERNAL MODULE: ./src/utils/http.js
var http = __webpack_require__(11);

// CONCATENATED MODULE: ./src/api/credentials.js


var credentials_phone = function phone() {
  return Object(http["a" /* default */])().post('/voip_credentials');
};

/* harmony default export */ var credentials = ({
  phone: credentials_phone
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VoipCall.vue









/* harmony default export */ var VoipCall = ({
  components: { Minute: formatters["c" /* Minute */] },
  data: function data() {
    return {
      identity: null,
      device: null,
      initialized: false,
      call: null,
      callStarted: null,
      time: null,
      date: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    currentUser: 'skiliko/session/currentUser'
  }), {
    duration: function duration() {
      if (!this.date || !this.callStarted) return null;
      return (this.date - this.callStarted) / 1000;
    }
  }),
  watch: {
    currentUser: function currentUser() {
      this.initialized = false;
      this.initialize();
    }
  },
  methods: {
    accept: function accept() {
      var _this = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.call) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return navigator.mediaDevices.getUserMedia({ audio: true });

              case 4:
                _this.call.accept();
                _this.call = null;
                _this.callStarted = new Date();
                if (!_this.timer) {
                  _this.timer = setInterval(function (_) {
                    return _this.date = new Date();
                  }, 1000);
                  _this.date = new Date();
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reject: function reject() {
      if (!this.call) return;
      this.call.reject();
      this.call = null;
    },
    hangup: function hangup() {
      if (!this.device) return;
      this.call = null;
      this.callStarted = null;
      this.device.disconnectAll();
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    initialize: function initialize() {
      var _this2 = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee2() {
        var _ref, data, identity, token;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.currentUser) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                if (!_this2.initialized) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                _this2.identity = null;
                _this2.device = null;
                _this2.initialized = false;
                _context2.prev = 7;
                _context2.next = 10;
                return credentials.phone();

              case 10:
                _ref = _context2.sent;
                data = _ref.data;
                identity = data.identity, token = data.token;

                _this2.identity = identity;

                _this2.device = new twilio["Device"](token, {
                  debug: true,
                  answerOnBridge: true,
                  codecPreferences: ['opus', 'pcmu']
                });

                _this2.device.on('registered', function () {
                  _this2.initialized = true;
                });
                _this2.device.on('error', console.error);
                _this2.device.on('incoming', function (call) {
                  _this2.call = call;
                  _this2.call.addListener('error', function (err) {
                    console.error(err);
                    _this2.hangup();
                  });
                  _this2.call.addListener('disconnect', function () {
                    console.log('disconnect');
                    _this2.hangup();
                  });
                  _this2.call.addListener('cancel', function () {
                    console.log('canceled');
                    _this2.hangup();
                  });
                  _this2.call.addListener('reject', function () {
                    console.log('reject');
                    _this2.hangup();
                  });
                  _this2.call.addListener('transportClose', function () {
                    console.log('transportClose');
                    _this2.hangup();
                  });
                });

                _this2.device.register(token);
                _this2.initialized = true;
                _context2.next = 25;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2['catch'](7);

                console.error(_context2.t0);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 22]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f9853a7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VoipCall.vue
var VoipCall_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.call || _vm.callStarted,"persistent":""}},[(_vm.call)?_c('v-card',[_c('v-card-title',[_vm._v("Appel entrant")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-icon',{staticClass:"ring-animation",attrs:{"large":""}},[_vm._v("phone")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{staticClass:"mr-2",attrs:{"block":"","error":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.reject()}}},[_vm._v("Rejeter l'appel")]),_vm._v(" "),_c('v-btn',{attrs:{"block":"","success":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.accept()}}},[_vm._v("Accepter l'appel")])],1)],1):(_vm.callStarted)?_c('v-card',[_c('v-card-title',[_vm._v("Appel en cours")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('minute',{attrs:{"value":_vm.duration}})],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"block":"","error":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.hangup()}}},[_vm._v("Raccrocher")])],1)],1):_vm._e()],1)}
var VoipCall_staticRenderFns = []
var VoipCall_esExports = { render: VoipCall_render, staticRenderFns: VoipCall_staticRenderFns }
/* harmony default export */ var components_VoipCall = (VoipCall_esExports);
// CONCATENATED MODULE: ./src/components/VoipCall.vue
function VoipCall_injectStyle (ssrContext) {
  __webpack_require__(672)
}
var VoipCall_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var VoipCall___vue_template_functional__ = false
/* styles */
var VoipCall___vue_styles__ = VoipCall_injectStyle
/* scopeId */
var VoipCall___vue_scopeId__ = "data-v-3f9853a7"
/* moduleIdentifier (server only) */
var VoipCall___vue_module_identifier__ = null
var VoipCall_Component = VoipCall_normalizeComponent(
  VoipCall,
  components_VoipCall,
  VoipCall___vue_template_functional__,
  VoipCall___vue_styles__,
  VoipCall___vue_scopeId__,
  VoipCall___vue_module_identifier__
)

/* harmony default export */ var src_components_VoipCall = (VoipCall_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue










/* harmony default export */ var App = ({
  components: {
    ApplicationMenu: src_components_ApplicationMenu,
    ApplicationToolbar: src_components_ApplicationToolbar,
    ChatPopup: components_purchase_popup_Availability,
    VoipCall: src_components_VoipCall
  },
  mixins: [soundNotification],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    menuOpen: 'application/menuOpen',
    isConnected: 'skiliko/session/connected',
    token: 'skiliko/session/token',
    needInformations: 'skiliko/session/needInformations',
    purchases: 'skiliko/purchases/collection'
  }), {
    fullScreen: function fullScreen() {
      return !this.isConnected || this.needInformations;
    },
    currentChatPurchase: function currentChatPurchase() {
      var _this = this;

      return keys_default()(this.purchases).map(function (key) {
        return _this.purchases[key];
      }).filter(function (purchase) {
        return purchase.offer.service_type === 'availability';
      }).filter(function (purchase) {
        return purchase.offer.service_options.availability_type === 'chat';
      }).filter(function (purchase) {
        return purchase.accepted_at && purchase.service.start_at || purchase.payed_at && !purchase.accepted_at;
      })[0];
    }
  }),
  methods: Object(vuex_esm["b" /* mapActions */])({
    fetchCurrentUser: 'skiliko/session/currentUser',
    fetchCurrentPlatform: 'skiliko/session/currentPlatform'
  }),
  watch: {
    currentChatPurchase: function currentChatPurchase(current, previous) {
      !previous && current ? this.playNotification() : this.clear();
    }
  },
  mounted: function mounted() {
    if (this.isConnected) {
      this.fetchCurrentPlatform({ token: this.token });
      this.fetchCurrentUser();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e63bb9c0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{ 'full-screen': _vm.fullScreen },attrs:{"id":"app"}},[(!_vm.fullScreen)?_c('application-menu'):_vm._e(),_vm._v(" "),(!_vm.fullScreen)?_c('application-toolbar'):_vm._e(),_vm._v(" "),_c('main',[(_vm.currentChatPurchase)?_c('v-dialog',{attrs:{"value":true,"width":"600px","lazy":"","absolute":"","persistent":""}},[_c('chat-popup',{attrs:{"purchase":_vm.currentChatPurchase}})],1):_vm._e(),_vm._v(" "),_c('voip-call'),_vm._v(" "),_c('v-container',{staticClass:"container--full_height",attrs:{"fluid":_vm.menuOpen,"fixed":!_vm.menuOpen}},[_c('router-view')],1)],1)],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__(609)
  __webpack_require__(611)
}
var App_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = "data-v-e63bb9c0"
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/application/mutations.js
/* harmony default export */ var mutations = ({
  UPDATE_PLATFORM_NAME: function UPDATE_PLATFORM_NAME(state) {
    return state.specificManager = [{"url":"expert.voyancequalite.com","platformName":"voyancequalite.com","terms":"https://www.voyancequalite.com/conditions-dutilisation-expert","privacy":"https://www.voyancequalite.com/vie-privee"},{"url":"expert.esoalia.com","platformName":"esoalia.com","terms":"https://s3-eu-west-1.amazonaws.com/skiliko/cgu_site.pdf","privacy":"https://s3-eu-west-1.amazonaws.com/skiliko/vie_privee_cookies.pdf"},{"url":"expert.voyancelac.ch","platformName":"voyancelac.ch","terms":"https://s3-eu-west-1.amazonaws.com/skiliko/cgu_site.pdf","privacy":"https://s3-eu-west-1.amazonaws.com/skiliko/vie_privee_cookies.pdf"},{"url":"expert.panamevoyance.com","platformName":"panamevoyance.com","terms":"https://s3-eu-west-1.amazonaws.com/skiliko/cgu_site.pdf","privacy":"https://s3-eu-west-1.amazonaws.com/skiliko/vie_privee_cookies.pdf"},{"url":"expert.trustvoyance.com","platformName":"trustvoyance.com","terms":"https://s3-eu-west-1.amazonaws.com/skiliko/cgu_site.pdf","privacy":"https://s3-eu-west-1.amazonaws.com/skiliko/vie_privee_cookies.pdf"},{"url":"expert.swizeo.ch","platformName":"swizeo.ch","terms":"https://s3-eu-west-1.amazonaws.com/skiliko/cgu_site.pdf","privacy":"https://s3-eu-west-1.amazonaws.com/skiliko/vie_privee_cookies.pdf"}].filter(function (e) {
      return e.url === location.host;
    })[0] || {
      terms: "https://s3-eu-west-1.amazonaws.com/skiliko/cgu_site.pdf",
      privacy: "https://s3-eu-west-1.amazonaws.com/skiliko/vie_privee_cookies.pdf"
    };
  },
  UPDATE_MENU: function UPDATE_MENU(state, _ref) {
    var open = _ref.open;
    return state.menuOpen = open;
  },
  TOGGLE_MENU: function TOGGLE_MENU(state) {
    return state.menuOpen = !state.menuOpen;
  },
  UPDATE_LANGUAGES: function UPDATE_LANGUAGES(state, _ref2) {
    var languages = _ref2.languages;
    return state.languages = languages;
  },
  UPDATE_COUNTRIES: function UPDATE_COUNTRIES(state, _ref3) {
    var countries = _ref3.countries;
    return state.countries = countries;
  }
});
// CONCATENATED MODULE: ./src/store/application/getters.js

var getters_objectToSelect = function objectToSelect(object) {
  return keys_default()(object).map(function (e) {
    return { code: e, name: object[e] };
  });
};

/* harmony default export */ var application_getters = ({
  menuOpen: function menuOpen(state) {
    return state.menuOpen;
  },
  platformName: function platformName(state) {
    return (state.specificManager || {}).platformName;
  },
  specificManager: function specificManager(state) {
    return state.specificManager;
  },
  languages: function languages(state) {
    return getters_objectToSelect(state.languages);
  },
  countries: function countries(state) {
    return getters_objectToSelect(state.countries);
  }
});
// CONCATENATED MODULE: ./src/store/application/state.js
/* harmony default export */ var application_state = ({
  menuOpen: false,
  specificManager: {},
  languages: {},
  countries: {}
});
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(159);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/store/application/actions.js




var actions_fetchLanguages = function fetchLanguages(_ref) {
  var commit = _ref.commit,
      state = _ref.state;
  return keys_default()(state.languages).length > 0 ? promise_default.a.resolve() : axios_default.a.get('https://skiliko.firebaseio.com/languages.json').then(function (_ref2) {
    var data = _ref2.data;
    return commit('UPDATE_LANGUAGES', { languages: data });
  });
};

var actions_fetchCountries = function fetchCountries(_ref3) {
  var commit = _ref3.commit,
      state = _ref3.state;
  return keys_default()(state.countries).length > 0 ? promise_default.a.resolve() : axios_default.a.get('https://skiliko.firebaseio.com/translations/fr/collection/countries.json').then(function (_ref4) {
    var data = _ref4.data;
    return commit('UPDATE_COUNTRIES', { countries: data });
  });
};

/* harmony default export */ var actions = ({
  fetchLanguages: actions_fetchLanguages,
  fetchCountries: actions_fetchCountries
});
// CONCATENATED MODULE: ./src/store/application/index.js





/* harmony default export */ var application = ({
  namespaced: true,
  mutations: mutations,
  getters: application_getters,
  state: application_state,
  actions: actions
});
// CONCATENATED MODULE: ./src/store/skiliko/helpers/loading.js
/* harmony default export */ var loading = ({
  state: {
    isLoading: false
  },
  mutations: {
    changeLoading: function changeLoading(state, _ref) {
      var isLoading = _ref.isLoading;
      return state.isLoading = isLoading;
    }
  },
  getters: {
    isLoading: function isLoading(state) {
      return state.isLoading;
    }
  }
});
// CONCATENATED MODULE: ./src/api/session.js



var session_login = function login(_ref) {
  var email = _ref.email,
      password = _ref.password,
      platformName = _ref.platformName;
  return Object(http["a" /* default */])().post('/oauth/token', {
    grant_type: 'password',
    scope: 'admin',
    username: email,
    password: password
  }, {
    headers: {
      PlatformTokenName: platformName
    }
  }).then(function (token) {
    js_cookie_default.a.set('authorization', token.data);
    return token;
  });
};

var session_logout = function logout() {
  var token = (js_cookie_default.a.getJSON('authorization') || {}).access_token;
  return Object(http["a" /* default */])().post('/oauth/revoke', { token: token }).then(function (_) {
    return js_cookie_default.a.remove('authorization');
  });
};

var session_connectAs = function connectAs(_ref2) {
  var adminId = _ref2.adminId;
  return Object(http["a" /* default */])().post('/connect_as', { admin_id: adminId }).then(function (token) {
    js_cookie_default.a.set('authorization', token.data);
    return token;
  });
};

/* harmony default export */ var session = ({
  login: session_login,
  logout: session_logout,
  connectAs: session_connectAs
});
// CONCATENATED MODULE: ./src/api/platform.js


var platform_fetch = function fetch(_ref) {
  var token = _ref.token;
  return Object(http["a" /* default */])().get('/platforms/' + token);
};

var platform_save = function save(_ref2) {
  var data = _ref2.data,
      token = _ref2.token;
  return Object(http["a" /* default */])().put('/platforms/' + token, data);
};

/* harmony default export */ var api_platform = ({
  fetch: platform_fetch,
  save: platform_save
});
// CONCATENATED MODULE: ./src/store/skiliko/session/actions.js





var handleError = function handleError(commit, error) {
  commit('changeLoading', { isLoading: false });
  throw error;
};

/* harmony default export */ var session_actions = ({
  currentUser: function currentUser(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('changeLoading', { isLoading: true });
    return currentExpert["a" /* default */].fetch().then(function (_ref2) {
      var data = _ref2.data;

      commit('changeLoading', { isLoading: false });
      commit('currentUser', { user: data });
      dispatch('skiliko/chat/init', {}, { root: true });
    }).catch(function (error) {
      return handleError(commit, error);
    });
  },
  updateCurrentUser: function updateCurrentUser(_ref3, _ref4) {
    var commit = _ref3.commit;
    var data = _ref4.data;

    commit('changeLoading', { isLoading: true });
    return currentExpert["a" /* default */].save({ data: data }).then(function (_ref5) {
      var data = _ref5.data;

      commit('changeLoading', { isLoading: false });
      commit('currentUser', { user: data });
    }).catch(function (error) {
      return handleError(commit, error);
    });
  },
  currentPlatform: function currentPlatform(_ref6, _ref7) {
    var commit = _ref6.commit;
    var token = _ref7.token;

    commit('changeLoading', { isLoading: true });
    return api_platform.fetch({ token: token.platform_token }).then(function (_ref8) {
      var data = _ref8.data;

      commit('changeLoading', { isLoading: false });
      commit('currentPlatform', { platform: data });
    }).catch(function (error) {
      return handleError(commit, error);
    });
  },
  reloadPlatform: function reloadPlatform(_ref9) {
    var dispatch = _ref9.dispatch,
        getters = _ref9.getters;

    var token = { platform_token: getters['currentPlatform'].token };
    return dispatch('currentPlatform', { token: token });
  },
  updateCurrentPlatform: function updateCurrentPlatform(_ref10, _ref11) {
    var commit = _ref10.commit,
        getters = _ref10.getters;
    var data = _ref11.data;

    commit('changeLoading', { isLoading: true });
    return api_platform.save({ data: data, token: getters.currentPlatform.token }).then(function (_ref12) {
      var data = _ref12.data;

      commit('changeLoading', { isLoading: false });
      commit('currentPlatform', { platform: data });
    }).catch(function (error) {
      return handleError(commit, error);
    });
  },
  login: function login(_ref13, _ref14) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    var email = _ref14.email,
        password = _ref14.password,
        platformName = _ref14.platformName;

    commit('changeLoading', { isLoading: true });
    commit('loginError', { error: null });
    return session.login({ email: email, password: password, platformName: platformName }).then(function (_ref15) {
      var data = _ref15.data;

      return promise_default.a.all([dispatch('currentUser'), dispatch('currentPlatform', { token: data })]).then(function (_) {
        return commit('loginEnd', data);
      });
    }).catch(function (error) {
      commit('loginError', { error: error.response ? error.response.data.error : error.message });
      handleError(commit, error);
    });
  },
  logout: function logout(_ref16) {
    var commit = _ref16.commit;

    commit('changeLoading', { isLoading: true });
    return session.logout().then(function (_) {
      commit('reset');
      commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      return handleError(commit, error);
    });
  },
  connectAs: function connectAs(_ref17, _ref18) {
    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;
    var adminId = _ref18.adminId;

    commit('changeLoading', { isLoading: true });
    return session.connectAs({ adminId: adminId }).then(function (_ref19) {
      var data = _ref19.data;

      dispatch('currentUser').then(function (_) {
        return commit('loginEnd', data);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/session/index.js





/* harmony default export */ var skiliko_session = ({
  namespaced: true,
  state: extends_default()({}, loading.state, {
    currentPlatform: null,
    currentUser: !!js_cookie_default.a.getJSON('authorization'),
    loginError: null,
    token: js_cookie_default.a.getJSON('authorization')
  }),
  mutations: extends_default()({}, loading.mutations, {
    reset: function reset(state) {
      state.currentPlatform = state.currentUser = state.token = state.loginError = null;
    },
    currentUser: function currentUser(state, _ref) {
      var user = _ref.user;
      return state.currentUser = user;
    },
    currentPlatform: function currentPlatform(state, _ref2) {
      var platform = _ref2.platform;
      return state.currentPlatform = platform;
    },
    loginEnd: function loginEnd(state, token) {
      return state.token = token;
    },
    loginError: function loginError(state, _ref3) {
      var error = _ref3.error;
      return state.loginError = error;
    }
  }),
  getters: extends_default()({}, loading.getters, {
    currentUser: function currentUser(state) {
      return state.currentUser;
    },
    currentPlatform: function currentPlatform(state) {
      return state.currentPlatform;
    },
    connected: function connected(state) {
      return !!state.token && !!state.currentUser && !!js_cookie_default.a.getJSON('authorization');
    },
    needInformations: function needInformations(state) {
      if (state.currentUser && state.currentUser.need_informations) {
        return true;
      }
      if (state.currentPlatform && state.currentPlatform.need_informations) {
        return true;
      }
      return false;
    },
    token: function token(state) {
      return state.token;
    },
    loginError: function loginError(state) {
      return state.loginError;
    }
  }),
  actions: session_actions
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(79);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/skiliko/helpers/collection.js


var collection__updateItem = function _updateItem(state, item) {
  return collection__replaceItem(state, extends_default()({}, state.collectionById[item.id || item._id], item));
};

var collection__replaceItem = function _replaceItem(state, item) {
  return state.collectionById = extends_default()({}, state.collectionById, defineProperty_default()({}, item.id || item._id, item));
};

var collection__updateCollection = function _updateCollection(state, collection) {
  return state.collectionById = extends_default()({}, state.collectionById, collection.reduce(function (accumulator, item) {
    accumulator[item.id || item._id] = item;
    return accumulator;
  }, {}));
};

/* harmony default export */ var helpers_collection = ({
  state: {
    collectionById: {}
  },
  getters: {
    collection: function collection(state) {
      return state.collectionById;
    }
  },
  mutations: {
    updateItem: function updateItem(state, _ref) {
      var item = _ref.item;
      return collection__updateItem(state, item);
    },
    replaceItem: function replaceItem(state, _ref2) {
      var item = _ref2.item;
      return collection__replaceItem(state, item);
    },
    updateCollection: function updateCollection(state, _ref3) {
      var collection = _ref3.collection;
      return collection__updateCollection(state, collection);
    }
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/helpers/collectionPerPage.js






/* harmony default export */ var collectionPerPage = ({
  state: extends_default()({}, helpers_collection.state, {
    collectionPerPage: {}
  }),
  getters: extends_default()({}, helpers_collection.getters, {
    pages: function pages(state) {
      return state.collectionPerPage;
    }
  }),
  mutations: extends_default()({}, helpers_collection.mutations, {
    collectionForPageFetched: function collectionForPageFetched(state, _ref) {
      var collectionForPage = _ref.collectionForPage,
          pagination = _ref.pagination,
          scope = _ref.scope;

      state.collectionPerPage = extends_default()({}, state.collectionPerPage, defineProperty_default()({}, utils_default["a" /* default */].dataToUrlString(scope), {
        list: collectionForPage.map(function (e) {
          return e.id || e._id;
        }),
        pagination: pagination
      }));
      helpers_collection.mutations.updateCollection(state, { collection: collectionForPage });
    },
    appendItem: function appendItem(state, _ref2) {
      var item = _ref2.item,
          scope = _ref2.scope;

      var key = utils_default["a" /* default */].dataToUrlString(scope);
      var existingPagination = state.collectionPerPage[key] || { list: [], pagination: {} };
      state.collectionPerPage = extends_default()({}, state.collectionPerPage, defineProperty_default()({}, key, {
        list: [].concat(toConsumableArray_default()(existingPagination.list), [item.id || item._id]).filter(function (value, index, self) {
          return self.indexOf(value) === index;
        }),
        pagination: existingPagination.pagination
      }));
      helpers_collection.mutations.updateCollection(state, { collection: [item] });
    }
  })
});
// EXTERNAL MODULE: ./src/api/user.js
var api_user = __webpack_require__(364);

// CONCATENATED MODULE: ./src/store/skiliko/users/actions.js



var onItemSuccess = function onItemSuccess(commit, item) {
  commit('changeLoading', { isLoading: false });
  commit('replaceItem', { item: item });
  return item;
};

var actions_onError = function onError(commit, error) {
  commit('userError', { error: error.response ? error.response.data.error : error.message });
  commit('changeLoading', { isLoading: false });
  return promise_default.a.reject(error);
};

var adminAction = function adminAction(action) {
  return function (_ref, _ref2) {
    var commit = _ref.commit;
    var id = _ref2.id,
        reason = _ref2.reason;

    commit('changeLoading', { isLoading: true });
    return action({ id: id, reason: reason }).then(function (_ref3) {
      var data = _ref3.data;
      return onItemSuccess(commit, data);
    }).catch(function (error) {
      return actions_onError(commit, error);
    });
  };
};

/* harmony default export */ var users_actions = ({
  fetchPerPage: function fetchPerPage(_ref4, filter) {
    var commit = _ref4.commit,
        getters = _ref4.getters,
        rootState = _ref4.rootState;

    commit('changeLoading', { isLoading: true });
    return api_user["a" /* default */].fetchAll(filter).then(function (_ref5) {
      var data = _ref5.data,
          pagination = _ref5.pagination;

      commit('collectionForPageFetched', {
        collectionForPage: data,
        pagination: pagination,
        scope: filter
      });
      commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      return actions_onError(commit, error);
    });
  },
  fetch: function fetch(_ref6, _ref7) {
    var commit = _ref6.commit;
    var id = _ref7.id;

    commit('changeLoading', { isLoading: true });
    return api_user["a" /* default */].fetch({ id: id }).then(function (_ref8) {
      var data = _ref8.data;
      return onItemSuccess(commit, data);
    }).catch(function (error) {
      return actions_onError(commit, error);
    });
  },
  lock: adminAction(api_user["a" /* default */].lock),
  unlock: adminAction(api_user["a" /* default */].unlock),
  risk: adminAction(api_user["a" /* default */].risk),
  unrisk: adminAction(api_user["a" /* default */].unrisk),
  save: function save(_ref9, _ref10) {
    var commit = _ref9.commit;
    var id = _ref10.id,
        data = _ref10.data;

    commit('changeLoading', { isLoading: true });
    return api_user["a" /* default */].save({ id: id, data: data }).then(function (_ref11) {
      var data = _ref11.data;
      return onItemSuccess(commit, data);
    }).catch(function (error) {
      return actions_onError(commit, error);
    });
  },
  create: function create(_ref12, data) {
    var commit = _ref12.commit;

    commit('changeLoading', { isLoading: true });
    return api_user["a" /* default */].create(data).then(function (_ref13) {
      var data = _ref13.data;
      return onItemSuccess(commit, data);
    }).catch(function (error) {
      return actions_onError(commit, error);
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/users/index.js






/* harmony default export */ var users = ({
  namespaced: true,
  state: extends_default()({}, loading.state, collectionPerPage.state, {
    userError: null
  }),
  mutations: extends_default()({}, loading.mutations, collectionPerPage.mutations, {
    userError: function userError(state, _ref) {
      var error = _ref.error;
      return state.userError = error;
    }
  }),
  getters: extends_default()({}, loading.getters, collectionPerPage.getters),
  actions: users_actions
});
// EXTERNAL MODULE: ./src/api/feedback.js
var feedback = __webpack_require__(368);

// CONCATENATED MODULE: ./src/store/skiliko/feedbacks/actions.js


/* harmony default export */ var feedbacks_actions = ({
  save: function save(_ref, _ref2) {
    var commit = _ref.commit;
    var id = _ref2.id,
        data = _ref2.data;

    commit('updateItem', { item: { id: id, loading: true } });
    return feedback["a" /* default */].save({ id: id, data: data }).then(function (_ref3) {
      var data = _ref3.data;
      return commit('replaceItem', { item: data });
    }).catch(function (_) {
      return commit('updateItem', { id: id, loading: false });
    });
  },
  accept: function accept(_ref4, _ref5) {
    var commit = _ref4.commit;
    var id = _ref5.id;

    commit('updateItem', { item: { id: id, loading: true } });
    return feedback["a" /* default */].accept({ id: id }).then(function (_ref6) {
      var data = _ref6.data;
      return commit('replaceItem', { item: data });
    }).catch(function (_) {
      return commit('updateItem', { id: id, loading: false });
    });
  },
  reject: function reject(_ref7, _ref8) {
    var commit = _ref7.commit;
    var id = _ref8.id;

    commit('updateItem', { item: { id: id, loading: true } });
    return feedback["a" /* default */].reject({ id: id }).then(function (_ref9) {
      var data = _ref9.data;
      return commit('replaceItem', { item: data });
    }).catch(function (_) {
      return commit('updateItem', { id: id, loading: false });
    });
  },
  fetchPerPage: function fetchPerPage(_ref10, _ref11) {
    var commit = _ref10.commit;
    var _ref11$page = _ref11.page,
        page = _ref11$page === undefined ? 1 : _ref11$page,
        _ref11$status = _ref11.status,
        status = _ref11$status === undefined ? 'pending' : _ref11$status;

    commit('changeLoading', { isLoading: true });
    return feedback["a" /* default */].fetchAll({ page: page, status: status }).then(function (_ref12) {
      var data = _ref12.data,
          pagination = _ref12.pagination;

      commit('collectionForPageFetched', {
        collectionForPage: data,
        pagination: pagination,
        scope: {
          page: page,
          status: status
        }
      });
      commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      commit('feedbacksError', { error: error.response ? error.response.data.error : error.message });
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/feedbacks/index.js






/* harmony default export */ var feedbacks = ({
  namespaced: true,
  state: extends_default()({}, loading.state, collectionPerPage.state, {
    feedbacksError: null
  }),
  mutations: extends_default()({}, loading.mutations, collectionPerPage.mutations, {
    feedbacksError: function feedbacksError(state, _ref) {
      var error = _ref.error;
      return state.feedbacksError = error;
    }
  }),
  getters: extends_default()({}, loading.getters, collectionPerPage.getters),
  actions: feedbacks_actions
});
// EXTERNAL MODULE: ./src/api/service.js
var service = __webpack_require__(91);

// CONCATENATED MODULE: ./src/store/skiliko/services/actions.js


var initLoad = function initLoad(commit) {
  return commit('changeLoading', { isLoading: true });
};

var onCollectionSuccess = function onCollectionSuccess(commit, _ref) {
  var scope = _ref.scope,
      data = _ref.data;

  commit('updateScope', { scope: scope, services: data });
  commit('updateCollection', { collection: data });
  commit('changeLoading', { isLoading: false });
  return data;
};

var actions_onItemSuccess = function onItemSuccess(commit, _ref2) {
  var data = _ref2.data;

  commit('replaceItem', { item: data });
  commit('changeLoading', { isLoading: false });
  return data;
};

var services_actions_onError = function onError(commit, _ref3) {
  var error = _ref3.error;

  commit('changeLoading', { isLoading: false });
  throw error;
};

/* harmony default export */ var services_actions = ({
  fetchAll: function fetchAll(_ref4, _ref5) {
    var commit = _ref4.commit;
    var _ref5$scope = _ref5.scope,
        scope = _ref5$scope === undefined ? 'public' : _ref5$scope;

    initLoad(commit);
    return service["a" /* default */].fetchAll({ scope: scope }).then(function (_ref6) {
      var data = _ref6.data;
      return onCollectionSuccess(commit, { scope: scope, data: data });
    }).catch(function (error) {
      return services_actions_onError(commit, { error: error });
    });
  },
  fetch: function fetch(_ref7, _ref8) {
    var commit = _ref7.commit;
    var id = _ref8.id;

    initLoad(commit);
    return service["a" /* default */].get({ id: id }).then(function (_ref9) {
      var data = _ref9.data;
      return actions_onItemSuccess(commit, { data: data });
    }).catch(function (error) {
      return services_actions_onError(commit, { error: error });
    });
  },
  update: function update(_ref10, _ref11) {
    var commit = _ref10.commit;
    var id = _ref11.id,
        data = _ref11.data;

    initLoad(commit);
    return service["a" /* default */].update({ id: id, data: data }).then(function (_ref12) {
      var data = _ref12.data;
      return actions_onItemSuccess(commit, { data: data });
    }).catch(function (error) {
      return services_actions_onError(commit, { error: error });
    });
  },
  create: function create(_ref13, _ref14) {
    var commit = _ref13.commit;
    var data = _ref14.data;

    initLoad(commit);
    return service["a" /* default */].create({ data: data }).then(function (_ref15) {
      var data = _ref15.data;
      return actions_onItemSuccess(commit, { data: data });
    }).catch(function (error) {
      return services_actions_onError(commit, { error: error });
    });
  },
  remove: function remove(_ref16, _ref17) {
    var commit = _ref16.commit;
    var id = _ref17.id;

    initLoad(commit);
    return service["a" /* default */].remove({ id: id }).then(function (_) {
      return actions_onItemSuccess(commit, { data: { id: id } });
    }).catch(function (error) {
      return services_actions_onError(commit, { error: error });
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/services/index.js








/* harmony default export */ var skiliko_services = ({
  namespaced: true,
  state: extends_default()({}, loading.state, helpers_collection.state, {
    scopes: {
      public: [],
      promotion: [],
      private: []
    }
  }),
  getters: extends_default()({}, loading.getters, helpers_collection.getters, {
    scopes: function scopes(state, getter) {
      return keys_default()(state.scopes);
    },
    offers: function offers(state, getter) {
      return keys_default()(state.scopes).filter(function (x) {
        return getter.categories.indexOf(x) < 0;
      });
    },
    categories: function categories(state, getter, rootState, rootGetters) {
      var platform = rootGetters['skiliko/session/currentPlatform'];
      if (!platform) {
        return [];
      }
      if (!platform.settings.custom_offers) {
        return [];
      }
      return platform.settings.custom_offers.split(',');
    },
    servicesByScope: function servicesByScope(state, getters) {
      return getters.scopes.reduce(function (accumulator, scope) {
        accumulator[scope] = (state.scopes[scope] || []).map(function (id) {
          return getters.collection[id];
        });
        return accumulator;
      }, {});
    }
  }),
  mutations: extends_default()({}, loading.mutations, helpers_collection.mutations, {
    updateScope: function updateScope(state, _ref) {
      var scope = _ref.scope,
          services = _ref.services;

      state.scopes = extends_default()({}, state.scopes, defineProperty_default()({}, scope, services.map(function (service) {
        return service.id;
      })));
    }
  }),
  actions: services_actions
});
// CONCATENATED MODULE: ./src/api/expert.js



var expert_fetchAll = function fetchAll() {
  return Object(http["a" /* default */])().get('/experts');
};

var expert_fetch = function fetch(_ref) {
  var id = _ref.id;
  return Object(http["a" /* default */])().get('/experts/' + id);
};

var expert_updatePriorities = function updatePriorities(_ref2) {
  var priorities = _ref2.priorities;
  return Object(http["a" /* default */])().post('/expert_priorities', { priorities: stringify_default()(priorities) });
};

var expert_save = function save(_ref3) {
  var id = _ref3.id,
      data = _ref3.data;
  return Object(http["a" /* default */])().put('/experts/' + id, data);
};

var expert_remove = function remove(_ref4) {
  var id = _ref4.id;
  return Object(http["a" /* default */])().delete('/experts/' + id);
};

var expert_invite = function invite(_ref5) {
  var email = _ref5.email,
      password = _ref5.password,
      password_confirmation = _ref5.password_confirmation;
  return Object(http["a" /* default */])().post('/experts', { email: email, password: password, password_confirmation: password_confirmation });
};

var expert_availabilities = function availabilities() {
  return Object(http["a" /* default */])().get('/availabilities');
};

/* harmony default export */ var expert = ({
  fetchAll: expert_fetchAll,
  fetch: expert_fetch,
  updatePriorities: expert_updatePriorities,
  save: expert_save,
  remove: expert_remove,
  invite: expert_invite,
  availabilities: expert_availabilities
});
// CONCATENATED MODULE: ./src/store/skiliko/experts/actions.js



var actions_initLoad = function initLoad(commit) {
  return commit('changeLoading', { isLoading: true });
};

var onSuccess = function onSuccess(commit, _ref) {
  var data = _ref.data;

  commit('updateExpertsList', { list: data.map(function (e) {
      return e.id;
    }) });
  commit('updateCollection', { collection: data });
  commit('changeLoading', { isLoading: false });
};

var experts_actions_onError = function onError(commit, _ref2) {
  var error = _ref2.error;

  commit('changeLoading', { isLoading: false });
  throw error;
};

/* harmony default export */ var experts_actions = ({
  fetchAll: function fetchAll(_ref3) {
    var commit = _ref3.commit;

    actions_initLoad(commit);
    return expert.fetchAll().then(function (_ref4) {
      var data = _ref4.data;
      return onSuccess(commit, { data: data });
    }).catch(function (error) {
      return experts_actions_onError(commit, { error: error });
    });
  },
  fetch: function fetch(_ref5, _ref6) {
    var commit = _ref5.commit;
    var id = _ref6.id;

    actions_initLoad(commit);
    return expert.fetch({ id: id }).then(function (_ref7) {
      var data = _ref7.data;

      commit('changeLoading', { isLoading: false });
      commit('replaceItem', { item: data });
    }).catch(function (error) {
      return experts_actions_onError(commit, { error: error });
    });
  },
  updateRole: function updateRole(_ref8, _ref9) {
    var commit = _ref8.commit;
    var id = _ref9.id,
        role = _ref9.role;

    actions_initLoad(commit);
    return expert.save({ id: id, data: { role: role } }).then(function (_ref10) {
      var data = _ref10.data;

      commit('changeLoading', { isLoading: false });
      commit('replaceItem', { item: data });
    }).catch(function (error) {
      return experts_actions_onError(commit, { error: error });
    });
  },
  save: function save(_ref11, _ref12) {
    var commit = _ref11.commit;
    var id = _ref12.id,
        data = _ref12.data;

    actions_initLoad(commit);
    if (data.password !== '') {
      data.password_confirmation = data.password;
    }
    return expert.save({ id: id, data: data }).then(function (_ref13) {
      var data = _ref13.data;

      commit('changeLoading', { isLoading: false });
      commit('replaceItem', { item: data });
    }).catch(function (error) {
      return experts_actions_onError(commit, { error: error });
    });
  },
  updatePriority: function updatePriority(_ref14, _ref15) {
    var commit = _ref14.commit,
        getters = _ref14.getters;
    var id = _ref15.id,
        up = _ref15.up;

    var index = getters.experts.findIndex(function (e) {
      return e.id === id;
    });
    if (!up && index >= getters.experts.length - 1 || up && index <= 0) {
      return;
    }
    var newOrder = [].concat(toConsumableArray_default()(getters.experts.map(function (e) {
      return e.id;
    })));
    var position = up ? -1 : 1;
    newOrder[index] = newOrder[index + position];
    newOrder[index + position] = id;
    commit('updateExpertsList', { list: newOrder });
    var priorities = newOrder.map(function (id, index) {
      return { id: id, value: index };
    });
    priorities.forEach(function (p) {
      return commit('updateItem', { item: { id: p.id, priority: p.value } });
    });
    return expert.updatePriorities({ priorities: priorities });
  },
  invite: function invite(_ref16, _ref17) {
    var commit = _ref16.commit,
        getters = _ref16.getters;
    var email = _ref17.email,
        password = _ref17.password;

    actions_initLoad(commit);
    return expert.invite({ email: email, password: password, password_confirmation: password }).then(function (_ref18) {
      var data = _ref18.data;

      onSuccess(commit, { data: [].concat(toConsumableArray_default()(getters.experts), [data]) });
      return data;
    }).catch(function (error) {
      return experts_actions_onError(commit, { error: error });
    });
  },
  remove: function remove(_ref19, _ref20) {
    var commit = _ref19.commit,
        getters = _ref19.getters;
    var id = _ref20.id;

    actions_initLoad(commit);
    return expert.remove({ id: id }).then(function (_ref21) {
      var data = _ref21.data;

      onSuccess(commit, { data: [].concat(toConsumableArray_default()(getters.experts)).filter(function (e) {
          return e.id !== id;
        }) });
      return data;
    }).catch(function (error) {
      return experts_actions_onError(commit, { error: error });
    });
  },
  availabilities: function availabilities(_ref22) {
    var commit = _ref22.commit;

    actions_initLoad(commit);
    return expert.availabilities().then(function (_ref23) {
      var data = _ref23.data;

      data.forEach(function (e) {
        return commit('updateItem', { item: e });
      });
      return data;
    }).catch(function (error) {
      return experts_actions_onError(commit, { error: error });
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/experts/index.js






/* harmony default export */ var experts = ({
  namespaced: true,
  state: extends_default()({}, loading.state, helpers_collection.state, {
    expertsList: []
  }),
  mutations: extends_default()({}, loading.mutations, helpers_collection.mutations, {
    updateExpertsList: function updateExpertsList(state, _ref) {
      var list = _ref.list;
      return state.expertsList = list;
    }
  }),
  getters: extends_default()({}, loading.getters, helpers_collection.getters, {
    experts: function experts(state, getters) {
      return state.expertsList.map(function (id) {
        return getters.collection[id];
      });
    }
  }),
  actions: experts_actions
});
// CONCATENATED MODULE: ./src/api/bank.js


var bank_fetch = function fetch() {
  return Object(http["a" /* default */])().get('/bank');
};

var bank_fetchKyc = function fetchKyc() {
  return Object(http["a" /* default */])().get('/kyc');
};

var bank_save = function save(_ref) {
  var data = _ref.data;
  return Object(http["a" /* default */])().post('/banks', data);
};

var bank_wallet = function wallet() {
  return Object(http["a" /* default */])().get('/balances');
};

var bank_transfer = function transfer(_ref2) {
  var amount = _ref2.amount,
      currency = _ref2.currency,
      reference = _ref2.reference;
  return Object(http["a" /* default */])().post('/payouts', {
    currency: currency,
    amount: amount,
    reference: reference
  });
};

/* harmony default export */ var api_bank = ({
  fetch: bank_fetch,
  fetchKyc: bank_fetchKyc,
  save: bank_save,
  wallet: bank_wallet,
  transfer: bank_transfer
});
// CONCATENATED MODULE: ./src/store/skiliko/bank/actions.js


/* harmony default export */ var bank_actions = ({
  fetchBank: function fetchBank(_ref) {
    var commit = _ref.commit;

    commit('changeLoading', { isLoading: true });
    return api_bank.fetch().then(function (_ref2) {
      var data = _ref2.data;

      commit('changeLoading', { isLoading: false });
      commit('updateBank', { bank: data });
    }).catch(function (error) {
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  },
  fetchKyc: function fetchKyc(_ref3) {
    var commit = _ref3.commit;

    commit('changeLoading', { isLoading: true });
    return api_bank.fetchKyc().then(function (_ref4) {
      var data = _ref4.data;

      commit('updateKyc', { kyc: data });
      commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  },
  save: function save(_ref5, _ref6) {
    var commit = _ref5.commit;
    var data = _ref6.data;

    commit('changeLoading', { isLoading: true });
    return api_bank.save({ data: data }).then(function (_ref7) {
      var data = _ref7.data;

      commit('updateBank', { bank: data });
      commit('changeLoading', { isLoading: false });
    }).catch(function (err) {
      commit('changeLoading', { isLoading: false });
      err.response.data = { iban: ['is invalid'] };
      throw err;
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/bank/index.js




/* harmony default export */ var skiliko_bank = ({
  namespaced: true,
  state: extends_default()({}, loading.state, {
    bank: {},
    kyc: {}
  }),
  mutations: extends_default()({}, loading.mutations, {
    updateBank: function updateBank(state, _ref) {
      var bank = _ref.bank;
      return state.bank = bank;
    },
    updateKyc: function updateKyc(state, _ref2) {
      var kyc = _ref2.kyc;
      return state.kyc = kyc;
    }
  }),
  getters: extends_default()({}, loading.getters, {
    bank: function bank(state) {
      return extends_default()({}, state.bank);
    },
    kyc: function kyc(state) {
      return extends_default()({}, state.kyc);
    }
  }),
  actions: bank_actions
});
// EXTERNAL MODULE: ./src/api/purchase.js
var purchase = __webpack_require__(171);

// CONCATENATED MODULE: ./src/store/skiliko/purchases/actions.js


/* harmony default export */ var purchases_actions = ({
  fetchPerPage: function fetchPerPage(_ref, _ref2) {
    var commit = _ref.commit,
        getters = _ref.getters,
        rootState = _ref.rootState;
    var _ref2$page = _ref2.page,
        page = _ref2$page === undefined ? 1 : _ref2$page,
        _ref2$userId = _ref2.userId,
        userId = _ref2$userId === undefined ? null : _ref2$userId,
        _ref2$adminId = _ref2.adminId,
        adminId = _ref2$adminId === undefined ? null : _ref2$adminId,
        _ref2$offerId = _ref2.offerId,
        offerId = _ref2$offerId === undefined ? null : _ref2$offerId,
        _ref2$serviceType = _ref2.serviceType,
        serviceType = _ref2$serviceType === undefined ? null : _ref2$serviceType,
        _ref2$resultCode = _ref2.resultCode,
        resultCode = _ref2$resultCode === undefined ? null : _ref2$resultCode,
        _ref2$dateFilter = _ref2.dateFilter,
        dateFilter = _ref2$dateFilter === undefined ? null : _ref2$dateFilter,
        _ref2$from = _ref2.from,
        from = _ref2$from === undefined ? null : _ref2$from,
        _ref2$to = _ref2.to,
        to = _ref2$to === undefined ? null : _ref2$to,
        _ref2$scope = _ref2.scope,
        scope = _ref2$scope === undefined ? 'all' : _ref2$scope;

    commit('changeLoading', { isLoading: true });
    return purchase["a" /* default */].fetchAll({ page: page, userId: userId, adminId: adminId, offerId: offerId, serviceType: serviceType, resultCode: resultCode, scope: scope, dateFilter: dateFilter, from: from, to: to }).then(function (_ref3) {
      var data = _ref3.data,
          pagination = _ref3.pagination;

      commit('collectionForPageFetched', {
        collectionForPage: data,
        pagination: pagination,
        scope: {
          page: page,
          userId: userId,
          adminId: adminId,
          offerId: offerId,
          serviceType: serviceType,
          resultCode: resultCode,
          from: from,
          to: to,
          dateFilter: dateFilter,
          scope: scope
        }
      });
      commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      commit('purchaseError', { error: error.response ? error.response.data.error : error.message });
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  },
  fetch: function fetch(_ref4, _ref5) {
    var commit = _ref4.commit;
    var id = _ref5.id;

    commit('changeLoading', { isLoading: true });
    return purchase["a" /* default */].fetch({ id: id }).then(function (_ref6) {
      var data = _ref6.data;

      commit('replaceItem', { item: data });
      commit('changeLoading', { isLoading: false });
      return data;
    }).catch(function (error) {
      commit('purchaseError', { error: error.response ? error.response.data.error : error.message });
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  },
  refund: function refund(_ref7, _ref8) {
    var commit = _ref7.commit;
    var id = _ref8.id,
        reason = _ref8.reason;

    commit('changeLoading', { isLoading: true });
    return purchase["a" /* default */].refund({ id: id, reason: reason }).then(function (_ref9) {
      var data = _ref9.data;

      commit('replaceItem', { item: data });
      commit('changeLoading', { isLoading: false });
      return data;
    }).catch(function (error) {
      commit('purchaseError', { error: error.response ? error.response.data.error : error.message });
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  },
  accept: function accept(_ref10, _ref11) {
    var commit = _ref10.commit;
    var id = _ref11.id;

    commit('changeLoading', { isLoading: true });
    return purchase["a" /* default */].accept({ id: id }).then(function (_ref12) {
      var data = _ref12.data;

      commit('replaceItem', { item: data });
      commit('changeLoading', { isLoading: false });
      return data;
    }).catch(function (error) {
      commit('purchaseError', { error: error.response ? error.response.data.error : error.message });
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  },
  finish: function finish(_ref13, _ref14) {
    var commit = _ref13.commit;
    var id = _ref14.id,
        serviceType = _ref14.serviceType,
        data = _ref14.data;

    commit('changeLoading', { isLoading: true });
    return purchase["a" /* default */].finish({ id: id, data: data, serviceType: serviceType }).then(function (_ref15) {
      var data = _ref15.data;

      commit('replaceItem', { item: data });
      commit('changeLoading', { isLoading: false });
      return data;
    }).catch(function (error) {
      commit('purchaseError', { error: error.response ? error.response.data.error : error.message });
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/purchases/index.js






/* harmony default export */ var purchases = ({
  namespaced: true,
  state: extends_default()({}, loading.state, collectionPerPage.state, {
    purchaseError: null
  }),
  mutations: extends_default()({}, loading.mutations, collectionPerPage.mutations, {
    purchaseError: function purchaseError(state, _ref) {
      var error = _ref.error;
      return state.purchaseError = error;
    }
  }),
  getters: extends_default()({}, loading.getters, collectionPerPage.getters),
  actions: purchases_actions
});
// CONCATENATED MODULE: ./src/api/link.js


var link_create = function create(_ref) {
  var data = _ref.data;
  return Object(http["a" /* default */])().post('/links', data);
};

var link_remove = function remove(_ref2) {
  var id = _ref2.id;
  return Object(http["a" /* default */])().delete('/links/' + id);
};

/* harmony default export */ var api_link = ({
  create: link_create,
  remove: link_remove
});
// CONCATENATED MODULE: ./src/store/skiliko/links/index.js





/* harmony default export */ var links = ({
  namespaced: true,
  state: extends_default()({}, loading.state),
  getters: extends_default()({}, loading.getters, {
    links: function links(state, getters, rootState, rootGetters) {
      return (rootGetters['skiliko/session/currentPlatform'] || {}).links || [];
    }
  }),
  mutations: extends_default()({}, loading.mutations),
  actions: {
    remove: function remove(_ref, _ref2) {
      var commit = _ref.commit,
          rootGetters = _ref.rootGetters;
      var id = _ref2.id;

      commit('changeLoading', { isLoading: true });
      var platform = rootGetters['skiliko/session/currentPlatform'] || {};
      commit('skiliko/session/currentPlatform', { platform: extends_default()({}, platform, {
          links: platform.links.filter(function (link) {
            return link.id !== id;
          })
        }) }, { root: true });
      return api_link.remove({ id: id }).then(function (_) {
        return commit('changeLoading', { isLoading: false });
      }).catch(function (error) {
        commit('changeLoading', { isLoading: false });
        throw error;
      });
    },
    save: function save(_ref3, _ref4) {
      var commit = _ref3.commit,
          rootGetters = _ref3.rootGetters;
      var data = _ref4.data;

      commit('changeLoading', { isLoading: true });
      return api_link.create({ data: data }).then(function (_ref5) {
        var data = _ref5.data;

        var platform = rootGetters['skiliko/session/currentPlatform'] || {};
        commit('skiliko/session/currentPlatform', { platform: extends_default()({}, platform, {
            links: [].concat(toConsumableArray_default()(platform.links), [data])
          }) }, { root: true });
        commit('changeLoading', { isLoading: false });
        return data;
      }).catch(function (error) {
        commit('changeLoading', { isLoading: false });
        throw error;
      });
    }
  }
});
// EXTERNAL MODULE: ./src/api/metrics.js
var metrics = __webpack_require__(365);

// EXTERNAL MODULE: ./src/utils/charts.js
var charts = __webpack_require__(359);

// CONCATENATED MODULE: ./src/store/skiliko/metrics/actions.js



/* harmony default export */ var metrics_actions = ({
  fetch: function fetch(_ref, _ref2) {
    var commit = _ref.commit;
    var id = _ref2.id,
        _ref2$params = _ref2.params,
        params = _ref2$params === undefined ? {} : _ref2$params;

    var key = charts["a" /* default */].datasetIdentifier(id, params);
    commit('updateDataset', { id: key, data: { loading: true } });
    return metrics["a" /* default */][id]({ params: params }).then(function (_ref3) {
      var data = _ref3.data;
      return commit('updateDataset', { id: key, data: data });
    }).catch(function (error) {
      commit('updateDataset', { id: key, data: { loading: false } });
      throw error;
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/metrics/index.js




/* harmony default export */ var skiliko_metrics = ({
  namespaced: true,
  state: {
    datasets: {}
  },
  mutations: {
    updateDataset: function updateDataset(state, _ref) {
      var id = _ref.id,
          data = _ref.data;

      state.datasets = extends_default()({}, state.datasets, defineProperty_default()({}, id, extends_default()({}, state.datasets[id], {
        loading: false
      }, data)));
    }
  },
  getters: {
    datasets: function datasets(state) {
      return state.datasets;
    }
  },
  actions: metrics_actions
});
// CONCATENATED MODULE: ./src/api/invitation.js



var invitation_accept = function accept(_ref) {
  var token = _ref.token,
      password = _ref.password,
      passwordConfirmation = _ref.passwordConfirmation,
      platformToken = _ref.platformToken;
  return Object(http["a" /* default */])().put('/invitations', {
    invitation_token: token,
    password: password,
    password_confirmation: passwordConfirmation,
    resource_type: 'Admin',
    scope: 'admin'
  }, {
    headers: {
      PlatformToken: platformToken
    }
  }).then(function (token) {
    js_cookie_default.a.set('authorization', token.data);
    return token;
  });
};

/* harmony default export */ var invitation = ({
  accept: invitation_accept
});
// CONCATENATED MODULE: ./src/store/skiliko/invitations/index.js





/* harmony default export */ var invitations = ({
  namespaced: true,
  state: extends_default()({}, loading.state),
  getters: extends_default()({}, loading.getters),
  mutations: extends_default()({}, loading.mutations),
  actions: {
    accept: function accept(_ref, _ref2) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      var token = _ref2.token,
          password = _ref2.password,
          passwordConfirmation = _ref2.passwordConfirmation,
          platformToken = _ref2.platformToken;

      commit('changeLoading', { isLoading: true });
      return invitation.accept({ token: token, password: password, passwordConfirmation: passwordConfirmation, platformToken: platformToken }).then(function (_ref3) {
        var data = _ref3.data;

        return promise_default.a.all([dispatch('skiliko/session/currentUser', {}, { root: true }), dispatch('skiliko/session/currentPlatform', { token: data }, { root: true })]).then(function (_) {
          commit('skiliko/session/loginEnd', data, { root: true });
          commit('changeLoading', { isLoading: false });
        });
      }).catch(function (error) {
        commit('changeLoading', { isLoading: false });
        throw error;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/api/password.js


var password_sendEmail = function sendEmail(_ref) {
  var email = _ref.email,
      platformName = _ref.platformName;
  return Object(http["a" /* default */])().post('/passwords', {
    email: email,
    resource_type: 'Admin',
    scope: 'admin'
  }, {
    headers: {
      PlatformTokenName: platformName
    }
  });
};

var password_reset = function reset(_ref2) {
  var token = _ref2.token,
      password = _ref2.password,
      passwordConfirmation = _ref2.passwordConfirmation,
      platformName = _ref2.platformName;
  return Object(http["a" /* default */])().put('/passwords', {
    reset_password_token: token,
    password: password,
    password_confirmation: passwordConfirmation,
    resource_type: 'Admin',
    scope: 'admin'
  }, {
    headers: {
      PlatformTokenName: platformName
    }
  });
};

/* harmony default export */ var api_password = ({
  sendEmail: password_sendEmail,
  reset: password_reset
});
// CONCATENATED MODULE: ./src/store/skiliko/password/index.js



/* harmony default export */ var skiliko_password = ({
  namespaced: true,
  state: loading.state,
  getters: loading.getters,
  mutations: loading.mutations,
  actions: {
    sendEmail: function sendEmail(_ref, _ref2) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      var email = _ref2.email,
          platformName = _ref2.platformName;

      commit('changeLoading', { isLoading: true });
      return api_password.sendEmail({ email: email, platformName: platformName }).then(function (_ref3) {
        var data = _ref3.data;

        commit('changeLoading', { isLoading: false });
        return data;
      }).catch(function (error) {
        commit('changeLoading', { isLoading: false });
        throw error;
      });
    },
    reset: function reset(_ref4, _ref5) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;
      var token = _ref5.token,
          password = _ref5.password,
          passwordConfirmation = _ref5.passwordConfirmation,
          platformName = _ref5.platformName;

      commit('changeLoading', { isLoading: true });
      return api_password.reset({ token: token, password: password, passwordConfirmation: passwordConfirmation, platformName: platformName }).then(function (_ref6) {
        var data = _ref6.data;

        commit('changeLoading', { isLoading: false });
        return data;
      }).catch(function (error) {
        commit('changeLoading', { isLoading: false });
        throw error;
      });
    }
  }
});
// EXTERNAL MODULE: ./src/api/call.js
var call = __webpack_require__(173);

// CONCATENATED MODULE: ./src/store/skiliko/call/index.js




/* harmony default export */ var skiliko_call = ({
  namespaced: true,
  state: extends_default()({}, loading.state),
  mutations: extends_default()({}, loading.mutations),
  getters: extends_default()({}, loading.getters),
  actions: {
    createAppointment: function createAppointment(_ref, _ref2) {
      var commit = _ref.commit;
      var userId = _ref2.userId,
          adminId = _ref2.adminId,
          callAt = _ref2.callAt;

      commit('changeLoading', { isLoading: true });
      return call["a" /* default */].createAppointment({ userId: userId, adminId: adminId, callAt: callAt }).then(function (_ref3) {
        var data = _ref3.data;

        commit('skiliko/purchases/replaceItem', { item: data }, { root: true });
        commit('changeLoading', { isLoading: false });
        return data;
      }).catch(function (error) {
        commit('changeLoading', { isLoading: false });
        throw error;
      });
    },
    hangup: function hangup(_ref4, _ref5) {
      var commit = _ref4.commit;
      var id = _ref5.id;

      commit('changeLoading', { isLoading: true });
      return call["a" /* default */].hangup({ id: id }).then(function (_ref6) {
        var data = _ref6.data;

        commit('skiliko/purchases/replaceItem', { item: data }, { root: true });
        commit('changeLoading', { isLoading: false });
        return data;
      }).catch(function (error) {
        commit('changeLoading', { isLoading: false });
        throw error;
      });
    },
    fetchAudio: function fetchAudio(_ref7, _ref8) {
      var commit = _ref7.commit;
      var id = _ref8.id;

      commit('changeLoading', { isLoading: true });
      return call["a" /* default */].record({ id: id }).then(function (_ref9) {
        var data = _ref9.data;

        commit('changeLoading', { isLoading: false });
        return data;
      }).catch(function (error) {
        commit('changeLoading', { isLoading: false });
        throw error;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/api/transfer.js



var transfer_fetchAll = function fetchAll(_ref) {
  var _ref$page = _ref.page,
      page = _ref$page === undefined ? 1 : _ref$page;
  return Object(http["a" /* default */])().get('/payouts?' + utils_default["a" /* default */].dataToUrlString({ page: page }));
};

/* harmony default export */ var api_transfer = ({
  fetchAll: transfer_fetchAll
});
// CONCATENATED MODULE: ./src/store/skiliko/transfers/actions.js


/* harmony default export */ var transfers_actions = ({
  fetchPerPage: function fetchPerPage(_ref, _ref2) {
    var commit = _ref.commit,
        getters = _ref.getters,
        rootState = _ref.rootState;
    var _ref2$page = _ref2.page,
        page = _ref2$page === undefined ? 1 : _ref2$page;

    commit('changeLoading', { isLoading: true });
    return api_transfer.fetchAll({ page: page }).then(function (_ref3) {
      var data = _ref3.data,
          pagination = _ref3.pagination;

      commit('collectionForPageFetched', {
        collectionForPage: data,
        pagination: pagination,
        scope: { page: page }
      });
      commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/transfers/index.js






/* harmony default export */ var transfers = ({
  namespaced: true,
  state: extends_default()({}, loading.state, collectionPerPage.state),
  mutations: extends_default()({}, loading.mutations, collectionPerPage.mutations),
  getters: extends_default()({}, loading.getters, collectionPerPage.getters),
  actions: transfers_actions
});
// CONCATENATED MODULE: ./src/store/skiliko/wallets/actions.js


/* harmony default export */ var wallets_actions = ({
  fetch: function fetch(_ref) {
    var commit = _ref.commit;

    commit('changeLoading', { isLoading: true });
    return api_bank.wallet().then(function (_ref2) {
      var data = _ref2.data;

      commit('changeLoading', { isLoading: false });
      commit('updateWallet', { wallet: data });
    }).catch(function (error) {
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  },
  transfer: function transfer(_ref3, _ref4) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    var amount = _ref4.amount,
        currency = _ref4.currency,
        reference = _ref4.reference;

    commit('changeLoading', { isLoading: true });
    return api_bank.transfer({ amount: amount, currency: currency, reference: reference }).then(function (_ref5) {
      var data = _ref5.data;
      return dispatch('fetch');
    }).catch(function (err) {
      commit('changeLoading', { isLoading: false });
      throw err;
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/wallets/index.js




/* harmony default export */ var wallets = ({
  namespaced: true,
  state: extends_default()({}, loading.state, {
    wallet: {}
  }),
  mutations: extends_default()({}, loading.mutations, {
    updateWallet: function updateWallet(state, _ref) {
      var wallet = _ref.wallet;
      return state.wallet = wallet;
    }
  }),
  getters: extends_default()({}, loading.getters, {
    wallet: function wallet(state) {
      return extends_default()({}, state.wallet);
    }
  }),
  actions: wallets_actions
});
// EXTERNAL MODULE: ./node_modules/socket.io-client/lib/index.js
var socket_io_client_lib = __webpack_require__(369);
var socket_io_client_lib_default = /*#__PURE__*/__webpack_require__.n(socket_io_client_lib);

// CONCATENATED MODULE: ./src/api/messenger.js





var ChatDetails = {
  socket: null,
  user: null
};

var messenger_init = function init(userId) {
  return new promise_default.a(function (resolve, reject) {
    ChatDetails.user = userId;
    ChatDetails.socket = socket_io_client_lib_default()(Object(http["b" /* endpoint */])("chat", { protocol: 'wss' }), {
      transports: ['websocket'],
      query: 'user=' + userId
    });
    ChatDetails.socket.on('connect', function () {
      return resolve(ChatDetails.socket);
    });
    ChatDetails.socket.on('disconnect', function () {
      return ChatDetails.socket = null;
    });
    ChatDetails.socket.on('error', function (error) {
      return reject(error);
    });
  });
};

var messenger_fetchConversations = function fetchConversations(_ref) {
  var userId = _ref.userId,
      _ref$page = _ref.page,
      page = _ref$page === undefined ? 1 : _ref$page;
  return Object(http["a" /* default */])(Object(http["b" /* endpoint */])("chat")).get('/users/' + userId + '/conversations?' + utils_default["a" /* default */].dataToUrlString({ page: page }));
};

var messenger_fetchConversation = function fetchConversation(_ref2) {
  var id = _ref2.id;
  return Object(http["a" /* default */])(Object(http["b" /* endpoint */])("chat")).get('/conversations/' + id);
};

var messenger_fetchPending = function fetchPending(_ref3) {
  var userId = _ref3.userId;
  return Object(http["a" /* default */])(Object(http["b" /* endpoint */])("chat")).get('/pendings?' + utils_default["a" /* default */].dataToUrlString({ user: userId }));
};

var messenger_messages = function messages(_ref4) {
  var conversationId = _ref4.conversationId,
      _ref4$page = _ref4.page,
      page = _ref4$page === undefined ? 1 : _ref4$page;
  return Object(http["a" /* default */])(Object(http["b" /* endpoint */])("chat")).get('/conversations/' + conversationId + '/messages?' + utils_default["a" /* default */].dataToUrlString({ page: page }));
};

var messenger_markAsRead = function markAsRead(_ref5) {
  var ids = _ref5.ids,
      readAt = _ref5.readAt,
      user = _ref5.user;
  return ids.length ? Object(http["a" /* default */])(Object(http["b" /* endpoint */])("chat")).post('/read', { ids: ids, readAt: readAt, user: user }) : promise_default.a.resolve();
};

var messenger_markAsReceived = function markAsReceived(_ref6) {
  var id = _ref6.id,
      receivedAt = _ref6.receivedAt,
      user = _ref6.user;
  return Object(http["a" /* default */])(Object(http["b" /* endpoint */])("chat")).put('/messages/' + id, { receivedAt: receivedAt, user: user });
};

var messenger_sendMessage = function sendMessage(_ref7) {
  var content = _ref7.content,
      from = _ref7.from,
      query = _ref7.query,
      data = _ref7.data,
      conversationId = _ref7.conversationId;

  if (conversationId) {
    return Object(http["a" /* default */])(Object(http["b" /* endpoint */])("chat")).post('/conversations/' + conversationId + '/messages', {
      from: from,
      content: content,
      data: data
    });
  } else {
    return Object(http["a" /* default */])(Object(http["b" /* endpoint */])("chat")).post('/messages', {
      from: from,
      query: query,
      content: content,
      data: data,
      sentAt: new Date()
    });
  }
};

var messenger_findConversation = function findConversation(_ref8) {
  var from = _ref8.from,
      to = _ref8.to;
  return Object(http["a" /* default */])(Object(http["b" /* endpoint */])("chat")).post('/conversations/search', { from: from, to: to });
};

/* harmony default export */ var messenger = ({
  init: messenger_init,
  fetchConversations: messenger_fetchConversations,
  fetchConversation: messenger_fetchConversation,
  findConversation: messenger_findConversation,
  fetchPending: messenger_fetchPending,
  sendMessage: messenger_sendMessage,
  messages: messenger_messages,
  markAsRead: messenger_markAsRead,
  markAsReceived: messenger_markAsReceived,
  ChatDetails: ChatDetails
});
// CONCATENATED MODULE: ./src/store/skiliko/conversations/actions.js


var conversations_actions_initLoad = function initLoad(commit) {
  return commit('changeLoading', { isLoading: true });
};

var conversations_actions_onError = function onError(commit, _ref) {
  var error = _ref.error;

  commit('changeLoading', { isLoading: false });
  throw error;
};

/* harmony default export */ var conversations_actions = ({
  fetch: function fetch(_ref2, _ref3) {
    var commit = _ref2.commit;
    var id = _ref3.id;

    conversations_actions_initLoad(commit);
    return messenger.fetchConversation({ id: id }).then(function (_ref4) {
      var data = _ref4.data;

      commit('replaceItem', { item: data });
      commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      return conversations_actions_onError(commit, { error: error });
    });
  },
  fetchPerPage: function fetchPerPage(_ref5, _ref6) {
    var commit = _ref5.commit;
    var page = _ref6.page,
        userId = _ref6.userId;

    conversations_actions_initLoad(commit);
    return messenger.fetchConversations({ page: page, userId: userId }).then(function (_ref7) {
      var data = _ref7.data,
          pagination = _ref7.pagination;

      commit('collectionForPageFetched', {
        collectionForPage: data,
        pagination: pagination,
        scope: { page: page, userId: userId }
      });
      commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      return conversations_actions_onError(commit, { error: error });
    });
  },
  findConversationWith: function findConversationWith(_ref8, _ref9) {
    var commit = _ref8.commit,
        rootGetters = _ref8.rootGetters;
    var user = _ref9.user;

    var otherUser = rootGetters['skiliko/session/currentUser'].chatable_id;
    commit('changeLoading', { isLoading: true });
    return messenger.findConversation({
      from: user,
      to: otherUser
    }).then(function (_ref10) {
      var data = _ref10.data;

      commit('replaceItem', { item: data });
      commit('changeLoading', { isLoading: false });
      return data;
    }).catch(function (error) {
      return conversations_actions_onError(commit, { error: error });
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/conversations/index.js






/* harmony default export */ var conversations = ({
  namespaced: true,
  state: extends_default()({}, loading.state, collectionPerPage.state),
  mutations: extends_default()({}, loading.mutations, collectionPerPage.mutations),
  getters: extends_default()({}, loading.getters, collectionPerPage.getters, {
    pending: function pending(state, getters, rootState, rootGetters) {
      return rootGetters['skiliko/messages/pending'].reduce(function (conversations, message) {
        conversations[message.conversation] = conversations[message.conversation] || [];
        conversations[message.conversation].push(message);
        return conversations;
      }, {});
    }
  }),
  actions: conversations_actions
});
// CONCATENATED MODULE: ./src/store/skiliko/messages/actions.js



var messages_actions_initLoad = function initLoad(commit) {
  return commit('changeLoading', { isLoading: true });
};

var messages_actions_onError = function onError(commit, _ref) {
  var error = _ref.error;

  commit('changeLoading', { isLoading: false });
  throw error;
};

var addMessage = function addMessage(_ref2, _ref3) {
  var commit = _ref2.commit,
      getters = _ref2.getters;
  var message = _ref3.message;

  var existingMessage = getters.collection[message._id];
  commit('updateItem', { item: message });
  if (!existingMessage) {
    commit('appendItem', {
      item: message,
      scope: {
        conversationId: message.conversation,
        page: 1
      }
    });
  }
};

/* harmony default export */ var messages_actions = ({
  fetchPerPage: function fetchPerPage(_ref4, _ref5) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    var page = _ref5.page,
        conversationId = _ref5.conversationId;

    messages_actions_initLoad(commit);
    return messenger.messages({ page: page, conversationId: conversationId }).then(function (_ref6) {
      var data = _ref6.data,
          pagination = _ref6.pagination;

      commit('collectionForPageFetched', {
        collectionForPage: data,
        pagination: pagination,
        scope: { page: page, conversationId: conversationId }
      });
      return promise_default.a.all(data.filter(function (e) {
        return !e.receivedAt;
      }).map(function (e) {
        return dispatch('markAsReceived', { id: e._id });
      }));
    }).then(function (_) {
      return commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      return messages_actions_onError(commit, { error: error });
    });
  },
  fetchPending: function fetchPending(_ref7) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch,
        rootGetters = _ref7.rootGetters;

    messages_actions_initLoad(commit);
    return messenger.fetchPending({ userId: rootGetters['skiliko/session/currentUser'].chatable_id }).then(function (_ref8) {
      var data = _ref8.data;

      commit('updateCollection', { collection: data });
      return promise_default.a.all(data.filter(function (e) {
        return !e.receivedAt;
      }).map(function (e) {
        return dispatch('markAsReceived', { id: e._id });
      }));
    }).then(function (_) {
      return commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      return messages_actions_onError(commit, { error: error });
    });
  },
  create: function create(_ref9, _ref10) {
    var commit = _ref9.commit,
        getters = _ref9.getters,
        rootGetters = _ref9.rootGetters;
    var query = _ref10.query,
        content = _ref10.content,
        data = _ref10.data,
        conversationId = _ref10.conversationId;

    messages_actions_initLoad(commit);
    var from = rootGetters['skiliko/session/currentUser'].chatable_id;
    return messenger.sendMessage({
      from: from,
      query: query,
      data: data,
      content: content,
      conversationId: conversationId
    }).then(function (_ref11) {
      var data = _ref11.data;

      addMessage({ commit: commit, getters: getters }, { message: data });
      commit('changeLoading', { isLoading: false });
      return data;
    }).catch(function (error) {
      return messages_actions_onError(commit, { error: error });
    });
  },
  markAsReceived: function markAsReceived(_ref12, _ref13) {
    var commit = _ref12.commit,
        getters = _ref12.getters,
        rootGetters = _ref12.rootGetters;
    var id = _ref13.id;

    var message = getters.collection[id];
    if (message.to._id !== rootGetters['skiliko/session/currentUser'].chatable_id) {
      return;
    }
    if (getters.collection[id].receivedAt) {
      return;
    }
    var receivedAt = new Date();
    commit('updateItem', {
      item: {
        _id: id,
        receivedAt: receivedAt
      }
    });
    return messenger.markAsReceived({
      id: id,
      user: rootGetters['skiliko/session/currentUser'].chatable_id,
      receivedAt: receivedAt
    });
  },
  markAsRead: function markAsRead(_ref14, _ref15) {
    var commit = _ref14.commit,
        getters = _ref14.getters,
        rootGetters = _ref14.rootGetters;
    var ids = _ref15.ids;

    var validIds = ids.map(function (id) {
      return getters.collection[id];
    }).filter(function (m) {
      return !m.readAt;
    }).filter(function (m) {
      return m.to._id === rootGetters['skiliko/session/currentUser'].chatable_id;
    }).map(function (m) {
      return m._id;
    });
    var readAt = new Date();
    if (!validIds.length) {
      return;
    }
    validIds.forEach(function (id) {
      return commit('updateItem', {
        item: {
          _id: id,
          readAt: readAt
        }
      });
    });
    return messenger.markAsRead({
      ids: validIds,
      user: rootGetters['skiliko/session/currentUser'].chatable_id,
      readAt: readAt
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/messages/index.js







/* harmony default export */ var skiliko_messages = ({
  namespaced: true,
  state: extends_default()({}, loading.state, collectionPerPage.state),
  mutations: extends_default()({}, loading.mutations, collectionPerPage.mutations),
  getters: extends_default()({}, loading.getters, collectionPerPage.getters, {
    pending: function pending(state, getters, rootState, rootGetters) {
      return rootGetters['skiliko/session/currentUser'] ? keys_default()(getters.collection).map(function (id) {
        return getters.collection[id];
      }).filter(function (message) {
        return message.to.scope === 'admin';
      }).filter(function (message) {
        return message.to._id === rootGetters['skiliko/session/currentUser'].chatable_id;
      }).filter(function (message) {
        return !message.readAt;
      }) : [];
    }
  }),
  actions: messages_actions
});
// CONCATENATED MODULE: ./src/store/skiliko/chat/index.js



var handlers = {
  'messages:created': function messagesCreated(_ref, data) {
    var commit = _ref.commit;
    return commit('skiliko/messages/appendItem', {
      item: data,
      scope: {
        conversationId: data.conversation,
        page: 1
      }
    }, { root: true });
  },
  'messages:updated': function messagesUpdated(_ref2, data) {
    var commit = _ref2.commit;
    return commit('skiliko/messages/updateItem', { item: data }, { root: true });
  },
  'conversations:update': function conversationsUpdate(_ref3, data) {
    var commit = _ref3.commit;

    commit('skiliko/conversations/appendItem', {
      item: data,
      scope: {
        page: 1,
        userId: [data.from, data.to].filter(function (e) {
          return e.scope === 'admin';
        })[0]._id
      }
    }, { root: true });
    commit('skiliko/conversations/updateItem', { item: data }, { root: true });
  },
  'purchase:update': function purchaseUpdate(_ref4, data) {
    var dispatch = _ref4.dispatch;

    dispatch('skiliko/purchases/fetch', JSON.parse(data), { root: true });
  }
};

var _init = false;

/* harmony default export */ var chat = ({
  namespaced: true,
  actions: {
    init: function init(store) {
      if (_init) return;
      _init = true;
      var user = store.rootGetters['skiliko/session/currentUser'];
      return messenger.init(user.chatable_id).then(function (socket) {
        keys_default()(handlers).forEach(function (event) {
          socket.on(event, function (data) {
            return handlers[event](store, data);
          });
        });
        store.dispatch('skiliko/messages/fetchPending', {}, { root: true });
      }).catch(function (error) {
        return console.debug('error', error);
      });
    }
  }
});
// CONCATENATED MODULE: ./src/api/pause.js


var pause_create = function create() {
  return Object(http["a" /* default */])().post('/pauses');
};

var pause_cancel = function cancel() {
  return Object(http["a" /* default */])().delete('/pauses');
};

/* harmony default export */ var pause = ({
  create: pause_create,
  cancel: pause_cancel
});
// CONCATENATED MODULE: ./src/store/skiliko/pauses/index.js




var wrapLoading = function wrapLoading(_ref, action) {
  var commit = _ref.commit;

  commit('changeLoading', { isLoading: true });
  return action().then(function (_ref2) {
    var data = _ref2.data;

    commit('changeLoading', { isLoading: false });
    return data;
  }).catch(function (error) {
    commit('changeLoading', { isLoading: false });
    throw error;
  });
};

/* harmony default export */ var pauses = ({
  namespaced: true,
  state: extends_default()({}, loading.state),
  getters: extends_default()({}, loading.getters),
  mutations: extends_default()({}, loading.mutations),
  actions: {
    create: function create(store) {
      return wrapLoading(store, function () {
        return pause.create();
      }).then(function (user) {
        return store.commit('skiliko/session/currentUser', { user: user }, { root: true });
      });
    },
    cancel: function cancel(store) {
      return wrapLoading(store, function () {
        return pause.cancel();
      }).then(function (user) {
        return store.commit('skiliko/session/currentUser', { user: user }, { root: true });
      });
    }
  }
});
// CONCATENATED MODULE: ./src/api/card.js





var card_formatParams = function formatParams(params) {
  return keys_default()(params).map(function (k) {
    return [k, params[k]].join('=');
  }).join('&');
};

var card_preregister = function preregister() {
  return Object(http["a" /* default */])().post('/preregistered_cards').then(function (x) {
    return x.data;
  });
};

var card_tokenize = function tokenize(cardNumber, cardMonth, cardYear, cardCvx, data) {
  return axios_default.a.post(data.card_registration_url, card_formatParams({
    data: data.preregistration_data,
    accessKeyRef: data.access_key,
    cardNumber: cardNumber,
    cardCvx: cardCvx,
    cardExpirationDate: [cardMonth, cardYear.substr(-2)].join('')
  }), {
    headers: { 'Content-Type': 'text/plain' }
  }).then(function (x) {
    return x.data;
  });
};

var card_finalize = function finalize(preregisteredCard, token) {
  return Object(http["a" /* default */])().put('/cards/' + preregisteredCard.id, {
    registration_data: token
  }).then(function (x) {
    return x.data;
  });
};

var card_create = function create(cardNumber, month, year, cvx) {
  return card_preregister().then(function (preregisteredCard) {
    return card_tokenize(cardNumber, month, year, cvx, preregisteredCard).then(function (token) {
      return card_finalize(preregisteredCard, token);
    });
  }).then(function (x) {
    return x.status === 'ERROR' ? promise_default.a.reject(x) : x;
  });
};

/* harmony default export */ var card = ({
  create: card_create
});
// CONCATENATED MODULE: ./src/store/skiliko/cards/index.js


/* harmony default export */ var cards = ({
  namespaced: true,
  actions: {
    create: function create(store, _ref) {
      var number = _ref.number,
          month = _ref.month,
          year = _ref.year,
          cvx = _ref.cvx;
      return card.create(number, month, year, cvx);
    }
  }
});
// CONCATENATED MODULE: ./src/api/outcome.js



var outcome_fetchAll = function fetchAll(_ref) {
  var _ref$page = _ref.page,
      page = _ref$page === undefined ? 1 : _ref$page;
  return Object(http["a" /* default */])().get('/outcomes?' + utils_default["a" /* default */].dataToUrlString({ page: page }));
};

/* harmony default export */ var outcome = ({
  fetchAll: outcome_fetchAll
});
// CONCATENATED MODULE: ./src/store/skiliko/outcomes/actions.js


/* harmony default export */ var outcomes_actions = ({
  fetchPerPage: function fetchPerPage(_ref, _ref2) {
    var commit = _ref.commit,
        getters = _ref.getters,
        rootState = _ref.rootState;
    var _ref2$page = _ref2.page,
        page = _ref2$page === undefined ? 1 : _ref2$page;

    commit('changeLoading', { isLoading: true });
    return outcome.fetchAll({ page: page }).then(function (_ref3) {
      var data = _ref3.data,
          pagination = _ref3.pagination;

      commit('collectionForPageFetched', {
        collectionForPage: data,
        pagination: pagination,
        scope: { page: page }
      });
      commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      commit('changeLoading', { isLoading: false });
      throw error;
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/outcomes/index.js






/* harmony default export */ var outcomes = ({
  namespaced: true,
  state: extends_default()({}, loading.state, collectionPerPage.state),
  mutations: extends_default()({}, loading.mutations, collectionPerPage.mutations),
  getters: extends_default()({}, loading.getters, collectionPerPage.getters),
  actions: outcomes_actions
});
// CONCATENATED MODULE: ./src/api/minute_gift.js


var minute_gift_create = function create(_ref) {
  var user_id = _ref.user_id,
      minutes = _ref.minutes,
      card_id = _ref.card_id,
      reason = _ref.reason;
  return Object(http["a" /* default */])().post('/minute_gifts', {
    user_id: user_id,
    minutes: minutes,
    reason: reason,
    card_id: card_id
  });
};

var minute_gift_update = function update(_ref2) {
  var id = _ref2.id;
  return Object(http["a" /* default */])().put('/minute_gifts/' + id);
};

/* harmony default export */ var minute_gift = ({
  create: minute_gift_create,
  update: minute_gift_update
});
// CONCATENATED MODULE: ./src/store/skiliko/minute_gifts/index.js




/* harmony default export */ var minute_gifts = ({
  namespaced: true,
  state: extends_default()({}, loading.state),
  getters: extends_default()({}, loading.getters),
  mutations: extends_default()({}, loading.mutations),
  actions: {
    create: function create(_ref, _ref2) {
      var commit = _ref.commit;
      var user_id = _ref2.user_id,
          card_id = _ref2.card_id,
          minutes = _ref2.minutes,
          reason = _ref2.reason;

      commit('changeLoading', { isLoading: true });
      return minute_gift.create({
        user_id: user_id,
        card_id: card_id,
        minutes: minutes,
        reason: reason
      }).then(function (_ref3) {
        var data = _ref3.data;

        commit('changeLoading', { isLoading: false });
        commit('skiliko/users/updateItem', { item: data.user }, { root: true });
        return data;
      }).catch(function (error) {
        commit('changeLoading', { isLoading: false });
        throw error;
      });
    },
    update: function update(_ref4, _ref5) {
      var commit = _ref4.commit;
      var id = _ref5.id;

      commit('changeLoading', { isLoading: true });
      return minute_gift.update({ id: id }).then(function (_ref6) {
        var data = _ref6.data;

        commit('changeLoading', { isLoading: false });
        commit('skiliko/users/updateItem', { item: data.user }, { root: true });
        return data;
      }).catch(function (error) {
        commit('changeLoading', { isLoading: false });
        throw error;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/api/activity.js



var activity_fetchAll = function fetchAll(filter) {
  return Object(http["a" /* default */])().get('/activities?' + utils_default["a" /* default */].dataToUrlString(filter));
};

/* harmony default export */ var activity = ({
  fetchAll: activity_fetchAll
});
// CONCATENATED MODULE: ./src/store/skiliko/activities/actions.js



var activities_actions_onError = function onError(commit, error) {
  commit('changeLoading', { isLoading: false });
  return promise_default.a.reject(error);
};

/* harmony default export */ var activities_actions = ({
  fetchPerPage: function fetchPerPage(_ref, filter) {
    var commit = _ref.commit;

    commit('changeLoading', { isLoading: true });
    return activity.fetchAll(filter).then(function (_ref2) {
      var data = _ref2.data,
          pagination = _ref2.pagination;

      commit('collectionForPageFetched', {
        collectionForPage: data,
        pagination: pagination,
        scope: filter
      });
      commit('changeLoading', { isLoading: false });
    }).catch(function (error) {
      return activities_actions_onError(commit, error);
    });
  }
});
// CONCATENATED MODULE: ./src/store/skiliko/activities/index.js






/* harmony default export */ var activities = ({
  namespaced: true,
  state: extends_default()({}, loading.state, collectionPerPage.state),
  mutations: extends_default()({}, loading.mutations, collectionPerPage.mutations),
  getters: extends_default()({}, loading.getters, collectionPerPage.getters),
  actions: activities_actions
});
// CONCATENATED MODULE: ./src/store/skiliko/index.js























/* harmony default export */ var skiliko = ({
  namespaced: true,
  modules: {
    session: skiliko_session,
    users: users,
    feedbacks: feedbacks,
    services: skiliko_services,
    experts: experts,
    bank: skiliko_bank,
    purchases: purchases,
    links: links,
    metrics: skiliko_metrics,
    invitations: invitations,
    password: skiliko_password,
    call: skiliko_call,
    transfers: transfers,
    wallets: wallets,
    conversations: conversations,
    messages: skiliko_messages,
    chat: chat,
    pauses: pauses,
    cards: cards,
    outcomes: outcomes,
    minuteGifts: minute_gifts,
    activities: activities
  }
});
// CONCATENATED MODULE: ./src/store/index.js






vue_runtime_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var src_store = (new vuex_esm["a" /* default */].Store({
  modules: {
    application: application,
    skiliko: skiliko
  },

  strict: "production" !== 'production'
}));
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__(742);

// CONCATENATED MODULE: ./src/router/metas.js
var auth = { auth: true };
var notConnected = { auth: false };
// CONCATENATED MODULE: ./src/router/RouteDelegate.js
/* harmony default export */ var RouteDelegate = ({
  render: function render(h) {
    return h('router-view');
  }
});
// CONCATENATED MODULE: ./src/router/dashboards.route.js


var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 980));
};
var PlatformRevenues = function PlatformRevenues() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 981));
};
var TeamAvailabilities = function TeamAvailabilities() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 982));
};
var Gains = function Gains() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 983));
};
var Statistics = function Statistics() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 984));
};
var Accounting = function Accounting() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 985));
};

/* harmony default export */ var dashboards_route = ([{
  path: '/',
  component: RouteDelegate,
  meta: auth,
  children: [{
    path: '',
    name: 'Dashboard',
    component: Dashboard
  }, {
    path: 'revenues',
    name: 'PlatformRevenues',
    component: PlatformRevenues
  }, {
    path: 'gains',
    name: 'Gains',
    component: Gains
  }, {
    path: 'availabilities',
    name: 'Availabilities',
    component: TeamAvailabilities,
    props: function props(route) {
      return {
        interval: route.query.interval
      };
    }
  }, {
    path: 'statistics',
    name: 'Statistics',
    component: Statistics
  }, {
    path: 'accounting',
    name: 'Accounting',
    component: Accounting
  }]
}]);
// CONCATENATED MODULE: ./src/router/users.route.js


var Users = function Users() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 986));
};
var User = function User() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 987));
};

/* harmony default export */ var users_route = ([{
  path: '/users',
  component: RouteDelegate,
  meta: auth,
  children: [{
    path: '',
    name: 'Users',
    component: Users,
    meta: auth,
    props: function props(route) {
      return {
        page: parseInt(route.query.page, 10) || 1,
        descending: route.query.descending === 'true',
        sortBy: route.query.sortBy
      };
    }
  }, {
    path: ':id/:tab',
    name: 'User',
    component: User,
    meta: auth,
    props: function props(route) {
      return {
        id: parseInt(route.params.id, 10),
        tab: route.params.tab || 'profile'
      };
    }
  }]
}]);
// CONCATENATED MODULE: ./src/router/purchases.route.js


var Purchases = function Purchases() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 988));
};
var Purchase = function Purchase() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 989));
};

/* harmony default export */ var purchases_route = ([{
  path: '/purchases',
  component: RouteDelegate,
  meta: auth,
  children: [{
    path: '',
    name: 'Purchases',
    component: Purchases,
    meta: auth,
    props: function props(route) {
      return {
        page: parseInt(route.query.page, 10) || 1
      };
    }
  }, {
    path: ':id',
    name: 'Purchase',
    component: Purchase,
    meta: auth,
    props: function props(route) {
      return {
        id: parseInt(route.params.id, 10)
      };
    }
  }]
}]);
// CONCATENATED MODULE: ./src/router/services.route.js


var Services = function Services() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 990));
};
var ServiceEdition = function ServiceEdition() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 991));
};
var ServiceCreation = function ServiceCreation() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 992));
};

/* harmony default export */ var services_route = ([{
  path: '/services',
  component: RouteDelegate,
  meta: auth,
  children: [{
    path: '',
    name: 'Services',
    component: Services,
    props: function props(route) {
      return route.query;
    }
  }, {
    path: 'new',
    name: 'ServiceCreation',
    component: ServiceCreation
  }, {
    path: ':id',
    name: 'Service',
    component: ServiceEdition,
    props: function props(route) {
      return {
        id: parseInt(route.params.id, 10)
      };
    }
  }]
}]);
// CONCATENATED MODULE: ./src/router/feedbacks.route.js


var Feedbacks = function Feedbacks() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 993));
};

/* harmony default export */ var feedbacks_route = ([{
  path: '/feedbacks',
  component: RouteDelegate,
  meta: auth,
  children: [{
    path: '',
    name: 'Feedbacks',
    redirect: 'pending' }, {
    path: 'pending',
    name: 'FeedbacksPending',
    component: Feedbacks,
    props: function props(route) {
      return {
        page: parseInt(route.query.page, 10) || 1,
        status: 'pending'
      };
    }
  }, {
    path: 'accepted',
    name: 'FeedbacksAccepted',
    component: Feedbacks,
    props: function props(route) {
      return {
        page: parseInt(route.query.page, 10) || 1,
        status: 'accepted'
      };
    }
  }, {
    path: 'rejected',
    name: 'FeedbacksRejected',
    component: Feedbacks,
    props: function props(route) {
      return {
        page: parseInt(route.query.page, 10) || 1,
        status: 'rejected'
      };
    }
  }]
}]);
// CONCATENATED MODULE: ./src/router/experts.route.js


var Expert = function Expert() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 994));
};
var Team = function Team() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 995));
};

/* harmony default export */ var experts_route = ([{
  path: '/experts',
  component: RouteDelegate,
  meta: auth,
  children: [{
    path: '/',
    name: 'Team',
    component: Team
  }, {
    path: ':id/:tab',
    name: 'Expert',
    component: Expert,
    props: function props(route) {
      return {
        id: parseInt(route.params.id, 10),
        tab: route.params.tab || 'profile'
      };
    }
  }]
}]);
// CONCATENATED MODULE: ./src/router/session.route.js

var Setup = function Setup() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 996));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 997));
};
var Logout = function Logout() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 998));
};
var ResetPassword = function ResetPassword() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 999));
};
var Invitation = function Invitation() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1000));
};
var ForgotPassword = function ForgotPassword() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1001));
};
var Account = function Account() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1002));
};

/* harmony default export */ var session_route = ([{
  path: '/setup',
  name: 'Setup',
  component: Setup,
  meta: auth
}, {
  path: '/login',
  name: 'Login',
  component: Login,
  meta: notConnected
}, {
  path: '/logout',
  name: 'Logout',
  component: Logout,
  meta: auth
}, {
  path: '/forgot_password',
  name: 'ForgotPassword',
  component: ForgotPassword,
  meta: notConnected
}, {
  path: '/reset_password/:platformName/:token',
  name: 'ResetPassword',
  component: ResetPassword,
  props: true,
  meta: notConnected
}, {
  path: '/invitations/:platformToken/:token',
  name: 'Invitation',
  component: Invitation,
  props: true,
  meta: notConnected
}, {
  path: '/account/:tab',
  name: 'Account',
  component: Account,
  meta: auth,
  props: true
}]);
// CONCATENATED MODULE: ./src/router/transfers.route.js

var Transfers = function Transfers() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1003));
};

/* harmony default export */ var transfers_route = ([{
  path: '/transfers',
  name: 'Transfers',
  component: Transfers,
  meta: auth
}]);
// CONCATENATED MODULE: ./src/router/customizations.route.js

var Customization = function Customization() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1004));
};
var Links = function Links() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1005));
};

/* harmony default export */ var customizations_route = ([{
  path: '/customization',
  name: 'Customization',
  component: Customization,
  meta: auth
}, {
  path: '/smart-link',
  name: 'Links',
  component: Links,
  meta: auth
}]);
// CONCATENATED MODULE: ./src/router/messenger.route.js

var Messenger = function Messenger() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1006));
};
var MessengerWelcome = function MessengerWelcome() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1007));
};
var MessengerMessage = function MessengerMessage() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1008));
};
var MessengerNew = function MessengerNew() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1009));
};

/* harmony default export */ var messenger_route = ([{
  path: '/messenger',
  component: Messenger,
  meta: auth,
  children: [{
    path: '',
    name: 'Messenger',
    component: MessengerWelcome
  }, {
    path: 'new',
    name: 'MessengerNew',
    component: MessengerNew,
    props: function props(route) {
      return {
        _id: route.query._id,
        name: route.query.name,
        externalId: parseInt(route.query.externalId, 10) || null,
        scope: route.query.scope
      };
    }
  }, {
    path: ':id',
    name: 'MessengerMessage',
    component: MessengerMessage,
    props: true
  }]
}]);
// CONCATENATED MODULE: ./src/router/errors.route.js
var NotFound = function NotFound() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1010));
};

/* harmony default export */ var errors_route = ([{
  path: '/404',
  name: 'NotFound',
  component: NotFound
}, {
  path: '*',
  redirect: '/404'
}]);
// CONCATENATED MODULE: ./src/router/index.js















vue_runtime_esm["default"].use(vue_router_esm["a" /* default */]);

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  if (to.hash) {
    return { selector: to.hash };
  }
  if (savedPosition) {
    return savedPosition;
  }
  return { x: 0, y: 0 };
};

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  scrollBehavior: scrollBehavior,
  routes: [].concat(toConsumableArray_default()(dashboards_route), toConsumableArray_default()(session_route), toConsumableArray_default()(users_route), toConsumableArray_default()(purchases_route), toConsumableArray_default()(services_route), toConsumableArray_default()(feedbacks_route), toConsumableArray_default()(transfers_route), toConsumableArray_default()(customizations_route), toConsumableArray_default()(experts_route), toConsumableArray_default()(messenger_route), toConsumableArray_default()(errors_route))
}));
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__(743);

// CONCATENATED MODULE: ./src/i18n/dateTimeFormats.js
/* harmony default export */ var dateTimeFormats = ({
  fr: {
    minimal: {
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',

      hour: 'numeric',
      minute: 'numeric'
    },
    precise: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',

      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }
  },
  en: {
    minimal: {
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',

      hour: 'numeric',
      minute: 'numeric'
    },
    precise: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',

      hour: 'numeric',
      minute: 'numeric'
    }
  }
});
// CONCATENATED MODULE: ./src/i18n/numberFormats.js
/* harmony default export */ var numberFormats = ({
  EUR: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  },
  GBP: {
    currency: {
      style: 'currency',
      currency: 'GBP'
    }
  },
  CHF: {
    currency: {
      style: 'currency',
      currency: 'CHF'
    }
  }
});
// CONCATENATED MODULE: ./src/i18n/index.js





vue_runtime_esm["default"].use(vue_i18n_esm["a" /* default */]);

/* harmony default export */ var i18n = (function () {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'fr';
  return new vue_i18n_esm["a" /* default */]({
    locale: locale,
    fallbackLocale: 'en',
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats,
    messages: {
      fr: __webpack_require__(744),
      en: __webpack_require__(745)
    }
  });
});
// CONCATENATED MODULE: ./src/main.js
















var APP_ID = 'jmiko15j';
vue_runtime_esm["default"].config.productionTip = false;

var main_currentPlatform = function currentPlatform() {
  return src_store.getters['skiliko/session/currentPlatform'];
};
var main__currentUser = function _currentUser() {
  return src_store.getters['skiliko/session/currentUser'];
};
var main_loggedIn = function loggedIn() {
  return src_store.getters['skiliko/session/connected'];
};
var main_needInformations = function needInformations() {
  return src_store.getters['skiliko/session/needInformations'];
};

vue_runtime_esm["default"].use(vuetify_default.a);
vue_runtime_esm["default"].use(authorisations, {
  authorisations: src_authorisations,
  currentUser: function currentUser(store) {
    return {
      platform: main_currentPlatform(),
      user: main__currentUser()
    };
  }
});
vue_runtime_esm["default"].use(vue_clipboard_default.a);

Object(vuex_router_sync["sync"])(src_store, router);

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.auth === true;
  }) && !main_loggedIn()) {
    return next({ name: 'Login', query: { redirect: to.fullPath } });
  }
  if (to.matched.some(function (record) {
    return record.meta.auth === false;
  }) && main_loggedIn()) {
    return next({ path: '/' });
  }
  if (main_needInformations() && to.name !== 'Setup') {
    return next({ name: 'Setup' });
  }
  next();
});

var main_intercomUser = function intercomUser() {
  var user = src_store.getters['skiliko/session/currentUser'];
  return user && (typeof user === 'undefined' ? 'undefined' : typeof_default()(user)) === 'object' ? {
    user_id: user.id,
    email: user.email,
    name: [user.first_name, user.last_name].filter(function (x) {
      return x;
    }).join(' '),
    phone: user.phone
  } : {};
};

window.intercomSettings = extends_default()({
  app_id: APP_ID,
  custom_launcher_selector: '#intercom-trigger',
  hide_default_launcher: true
}, main_intercomUser());(function () {
  var w = window;var ic = w.Intercom;if (typeof ic === 'function') {
    ic('reattach_activator');ic('update', w.intercomSettings);
  } else {
    var d = document;var i = function i() {
      i.c(arguments);
    };i.q = [];i.c = function (args) {
      i.q.push(args);
    };w.Intercom = i;var l = function l() {
      var s = d.createElement('script');s.type = 'text/javascript';s.async = true;s.src = 'https://widget.intercom.io/widget/' + APP_ID;var x = d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);
    };if (document.readyState === 'complete') {
      l();
    } else if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
})();

window.Intercom('boot', extends_default()({
  app_id: APP_ID
}, main_intercomUser()));

window.Intercom('hide');

router.afterEach(function (route) {
  window.Intercom('update', extends_default()({
    app_id: APP_ID
  }, main_intercomUser()));
  if (route.name === 'Logout') {
    window.Intercom('shutdown');
  }
});

src_store.commit('application/UPDATE_PLATFORM_NAME');

var main_init = function init() {
  return new vue_runtime_esm["default"]({
    el: '#app',
    router: router,
    store: src_store,
    i18n: i18n(main_currentPlatform() ? main_currentPlatform().locale : 'fr'),
    render: function render(h) {
      return h(src_App);
    }
  });
};

if (js_cookie_default.a.getJSON('authorization')) {
  promise_default.a.all([src_store.dispatch('skiliko/session/currentUser', {}, { root: true }), src_store.dispatch('skiliko/session/currentPlatform', { token: js_cookie_default.a.getJSON('authorization') }, { root: true })]).then(main_init);
} else {
  main_init();
}

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formatters/Date.vue


/* harmony default export */ var formatters_Date = ({
  props: {
    value: {
      type: [String, Date],
      required: true
    },
    format: {
      type: String,
      default: 'long'
    }
  },
  computed: {
    date: function date() {
      return new Date(this.value);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-450ec36a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/formatters/Date.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',[_vm._v(_vm._s(_vm.$d(_vm.date, _vm.format)))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_formatters_Date = (esExports);
// CONCATENATED MODULE: ./src/components/formatters/Date.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  formatters_Date,
  components_formatters_Date,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_formatters_Date = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formatters/ErrorCode.vue


/* harmony default export */ var ErrorCode = ({
  props: {
    code: {
      type: [String, Number],
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4acabecc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/formatters/ErrorCode.vue
var ErrorCode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.$t(("formatters.errorcode.code." + _vm.code))))])}
var ErrorCode_staticRenderFns = []
var ErrorCode_esExports = { render: ErrorCode_render, staticRenderFns: ErrorCode_staticRenderFns }
/* harmony default export */ var formatters_ErrorCode = (ErrorCode_esExports);
// CONCATENATED MODULE: ./src/components/formatters/ErrorCode.vue
var ErrorCode_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var ErrorCode___vue_template_functional__ = false
/* styles */
var ErrorCode___vue_styles__ = null
/* scopeId */
var ErrorCode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ErrorCode___vue_module_identifier__ = null
var ErrorCode_Component = ErrorCode_normalizeComponent(
  ErrorCode,
  formatters_ErrorCode,
  ErrorCode___vue_template_functional__,
  ErrorCode___vue_styles__,
  ErrorCode___vue_scopeId__,
  ErrorCode___vue_module_identifier__
)

/* harmony default export */ var components_formatters_ErrorCode = (ErrorCode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formatters/Price.vue


/* harmony default export */ var Price = ({
  props: {
    value: {
      type: [Number, String]
    },
    currency: {
      type: String,
      default: 'EUR'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a257a60","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/formatters/Price.vue
var Price_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.value ? _vm.$n(_vm.value / 100, 'currency', _vm.currency) : '-'))])}
var Price_staticRenderFns = []
var Price_esExports = { render: Price_render, staticRenderFns: Price_staticRenderFns }
/* harmony default export */ var formatters_Price = (Price_esExports);
// CONCATENATED MODULE: ./src/components/formatters/Price.vue
var Price_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Price___vue_template_functional__ = false
/* styles */
var Price___vue_styles__ = null
/* scopeId */
var Price___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Price___vue_module_identifier__ = null
var Price_Component = Price_normalizeComponent(
  Price,
  formatters_Price,
  Price___vue_template_functional__,
  Price___vue_styles__,
  Price___vue_scopeId__,
  Price___vue_module_identifier__
)

/* harmony default export */ var components_formatters_Price = (Price_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formatters/Minute.vue


/* harmony default export */ var Minute = ({
  props: {
    value: {
      type: Number,
      required: true
    },
    short: {
      type: Boolean,
      default: false
    },
    displayEmpty: {
      type: Boolean,
      default: false
    },
    ignoreSeconds: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hours: function hours() {
      return Math.floor(this.value / 60 / 60);
    },
    minutes: function minutes() {
      return Math.floor(this.value / 60 - this.hours * 60);
    },
    seconds: function seconds() {
      return parseInt(this.value - this.minutes * 60 - this.hours * 60 * 60, 10);
    },
    timeArray: function timeArray() {
      var _this = this;

      var units = ['hour', 'minute', 'second'];
      return [this.hours, this.minutes, this.ignoreSeconds ? 0 : this.seconds].map(function (value, i) {
        return value ? i === 0 ? _this.$n(value) : _this.numberToString(value) : null;
      }).map(function (value, i) {
        return value ? { value: value, unit: units[i] } : { value: null };
      }).filter(function (x) {
        return x.value;
      });
    },
    minutesInLongFormat: function minutesInLongFormat() {
      var _this2 = this;

      var times = this.timeArray;
      return times.map(function (time, i) {
        var sizeOfOne = times.length === 1;
        var lastElement = i < times.length - 1;
        var isSecond = time.unit === 'second';
        if (sizeOfOne || lastElement || isSecond) {
          return [time.value, _this2.$t('formatters.minute.units.' + time.unit)].join('');
        } else {
          return time.value;
        }
      }).join(' ');
    }
  },
  methods: {
    numberToString: function numberToString(number) {
      return ('0' + number).substr(-2);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce326f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/formatters/Minute.vue
var Minute_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.short)?_c('span',[(_vm.hours !== 0)?_c('span',[_vm._v(_vm._s(_vm.$n(_vm.hours))+" :")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.$n(_vm.minutes))+"\n  "),(_vm.seconds !== 0 && !_vm.ignoreSeconds)?_c('span',[_vm._v(" : "+_vm._s(_vm.numberToString(_vm.seconds)))]):_vm._e()]):_c('span',[_vm._v("\n  "+_vm._s(_vm.minutesInLongFormat)+"\n")])}
var Minute_staticRenderFns = []
var Minute_esExports = { render: Minute_render, staticRenderFns: Minute_staticRenderFns }
/* harmony default export */ var formatters_Minute = (Minute_esExports);
// CONCATENATED MODULE: ./src/components/formatters/Minute.vue
var Minute_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Minute___vue_template_functional__ = false
/* styles */
var Minute___vue_styles__ = null
/* scopeId */
var Minute___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Minute___vue_module_identifier__ = null
var Minute_Component = Minute_normalizeComponent(
  Minute,
  formatters_Minute,
  Minute___vue_template_functional__,
  Minute___vue_styles__,
  Minute___vue_scopeId__,
  Minute___vue_module_identifier__
)

/* harmony default export */ var components_formatters_Minute = (Minute_Component.exports);

// CONCATENATED MODULE: ./src/components/formatters/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return src_components_formatters_Date; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return components_formatters_ErrorCode; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return components_formatters_Price; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return components_formatters_Minute; });







/***/ }),

/***/ 609:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 619:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint array-bracket-spacing: 0, quotes: 0, semi: 0, indent: 0, no-var: 0, object-shorthand: 0, prefer-arrow-callback: 0, no-undef: 0, eqeqeq: 0, no-use-before-define: 0, prefer-spread: 0, spaced-comment: 0, prefer-rest-params: 0, wrap-iife: 0, lines-around-directive: 0, no-unused-vars: 0, no-empty: 0 */

/*
International Telephone Input v6.0.8
https://github.com/Bluefieldscom/intl-tel-input.git
*/
// wrap in UMD - see https://github.com/umdjs/umd/blob/master/jqueryPlugin.js
(function(factory) {
    if (true) {
        try {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ !(function webpackMissingModule() { var e = new Error("Cannot find module \"jquery\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()) ], __WEBPACK_AMD_DEFINE_RESULT__ = (function($) {
                factory($, window, document);
            }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } catch (ex) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                factory(false, window, document);
            }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        }
    } else if (typeof module !== "undefined") {
        try {
            factory(require("jquery"), window, document);
        } catch (ex) {
            factory(false, window, document);
        }
    } else {
        if (typeof jQuery !== "undefined") {
            factory(jQuery, window, document);
        } else {
            factory(false, window, document);
        }
    }
})(function($, window, document, undefined) {
    "use strict";
    // these vars persist through all instances of the plugin
    var pluginName = "intlTelInput", id = 0, // give each instance it's own id for calling some methods on all instances
    defaults = {
        // typing digits after a valid number will be added to the extension part of the number
        allowExtensions: false,
        // automatically format the number according to the selected country
        autoFormat: true,
        // if there is just a dial code in the input: remove it on blur, and re-add it on focus
        autoHideDialCode: true,
        // add or remove input placeholder with an example number for the selected country
        autoPlaceholder: true,
        // default country
        defaultCountry: "",
        // geoIp lookup function
        geoIpLookup: null,
        // don't insert international dial codes
        nationalMode: true,
        // number type to use for placeholders
        numberType: "MOBILE",
        // display only these countries
        onlyCountries: [],
        // the countries at the top of the list. defaults to united states and united kingdom
        preferredCountries: [ "us", "gb" ],
        // specify the path to the libphonenumber script to enable validation/formatting
        utilsScript: ""
    }, keys = {
        UP: 38,
        DOWN: 40,
        ENTER: 13,
        ESC: 27,
        PLUS: 43,
        A: 65,
        Z: 90,
        ZERO: 48,
        NINE: 57,
        SPACE: 32,
        BSPACE: 8,
        TAB: 9,
        DEL: 46,
        CTRL: 17,
        CMD1: 91,
        // Chrome
        CMD2: 224
    }, windowLoaded = false, allInstances = [];
    function extend(object1, object2) {
        var newObject = {};
        var oldObjects = [ object1, object2 ];
        for (var i = 0; i < oldObjects.length; i++) {
            var currentObject = oldObjects[i];
            for (var key in currentObject) {
                if (currentObject.hasOwnProperty(key)) {
                    newObject[key] = currentObject[key];
                }
            }
        }
        return newObject;
    }
    function inArray(value, array) {
        for (var i = 0; i < array.length; i++) {
            if (array[i] === value) {
                return i;
            }
        }
        return -1;
    }
    function trim(text) {
        if (text) {
            return (text + "").replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        } else {
            return "";
        }
    }
    function hasClass(element, className) {
        return (element.className + " ").indexOf(className + " ") >= 0;
    }
    function removeClass(element, className) {
        if (element.classList) {
            element.classList.remove(className);
        } else {
            var elementClassName = element.className + " ";
            element.className = trim(elementClassName.replace(className + " ", ""));
        }
    }
    function addClass(element, className) {
        if (element.classList) {
            element.classList.add(className);
        } else if (!element.className) {
            element.className = className;
        } else if (!hasClass(element, className)) {
            element.className += " " + className;
        }
    }
    function whichKey(e) {
        if (e.which) {
            return e.which;
        } else {
            return e.charCode !== null && e.charCode !== undefined ? e.charCode : e.keyCode;
        }
    }
    function isNumeric(string) {
        return string - parseFloat(string) + 1 >= 0;
    }
    function getWindowScrollTop() {
        var supportPageOffset = window.pageYOffset !== undefined;
        var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
        if (supportPageOffset) {
            return window.pageYOffset;
        } else if (isCSS1Compat) {
            return document.documentElement.scrollTop;
        } else {
            return document.body.scrollTop;
        }
    }
    function getWindowInnerHeight() {
        if (window.innerHeight === undefined) {
            return document.documentElement.clientHeight;
        } else {
            return window.innerHeight;
        }
    }
    function getDocumentHeight() {
        var html = document.documentElement;
        var body = document.body;
        return Math.max(body.scrollHeight, html.scrollHeight, body.offsetHeight, html.offsetHeight, body.clientHeight, html.clientHeight);
    }
    function forEach(elements, fn) {
        for (var i = 0; i < elements.length; i++) {
            fn(elements[i]);
        }
    }
    function first(elements, fn) {
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            if (fn(element)) {
                return element;
            }
        }
    }
    function hasFocus(element) {
        return element.parentNode && element.parentNode.querySelector(":focus") === element;
    }
    // tagName is lowercased
    function getClosest(element, tagName) {
        if (element.tagName && element.tagName.toLowerCase() === tagName) {
            return element;
        } else if (element.parentNode) {
            return getClosest(element.parentNode, tagName);
        } else {
            return null;
        }
    }
    function dispatchEvent(element, eventName, bubbles, cancellable) {
        if (document.createEvent) {
            var event = document.createEvent("HTMLEvents");
            event.initEvent(eventName, bubbles, cancellable);
            element.dispatchEvent(event);
        } else if (element.fireEvent) {
            element.fireEvent("on" + eventName);
        } else {
            throw new Error("-_-");
        }
    }
    function dispatchCustomEvent(element, eventName, bubbles, cancellable, data) {
        if (window.CustomEvent || document.createEvent) {
            var event;
            if (window.CustomEvent) {
                event = new CustomEvent(eventName, data);
            } else if (document.createEvent) {
                event = document.createEvent("CustomEvent");
                event.initCustomEvent(eventName, bubbles, cancellable, data);
            }
            return element.dispatchEvent(event);
        }
    }
    function createHandler(element, fn) {
        if (element.addEventListener) {
            return fn;
        } else if (element.attachEvent) {
            return function(event) {
                fn.call(element, event);
            };
        } else {
            throw new Error("-_-");
        }
    }
    function addEventListener(element, eventName, handler) {
        if (element.addEventListener) {
            element.addEventListener(eventName, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent("on" + eventName, handler);
        } else {
            throw new Error("-_-");
        }
    }
    function removeEventListener(element, eventName, handler) {
        if (element.removeEventListener) {
            element.removeEventListener(eventName, handler, false);
        } else if (element.detachEvent) {
            element.detachEvent("on" + eventName, handler);
        } else {
            throw new Error("-_-");
        }
    }
    function stopPropagation(event) {
        if (event.stopPropagation) {
            event.stopPropagation();
        } else {
            event.cancelBubble = true;
        }
    }
    function preventDefault(event) {
        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }
    }
    function getOffset(element) {
        var rect = element.getBoundingClientRect();
        return {
            top: rect.top + document.body.scrollTop,
            left: rect.left + document.body.scrollLeft
        };
    }
    var storage = {
        get: function(key) {
            if (window.localStorage) {
                return window.localStorage.getItem(key);
            } else if ($ && $.cookie) {
                return $.cookie(key);
            } else {
                return "";
            }
        },
        set: function(key, value, options) {
            if (window.localStorage) {
                return window.localStorage.setItem(key, value);
            } else if ($ && $.cookie) {
                return $.cookie(key, value, options);
            }
        }
    };
    // keep track of if the window.load event has fired as impossible to check after the fact
    addEventListener(window, "load", function() {
        windowLoaded = true;
    });
    var methods = {
        getListItemByCode: function(countryList, countryCode) {
            // unfortunately IE8 doesn't support :not css selector -_-
            var listItems = countryList.querySelectorAll("[data-country-code=" + countryCode + "]");
            var listItem = first(listItems, function(item) {
                return !hasClass(item, "preferred");
            });
            return listItem;
        },
        getDropdownHeight: function(countryList) {
            var height;
            countryList.className = "country-list v-hide";
            height = countryList.offsetHeight;
            countryList.className = "country-list hide";
            return height;
        },
        generateMarkup: function(isMobile, anyPreferredCountries) {
            var selectedFlagInner = document.createElement("div");
            var flagsContainer = document.createElement("div");
            var mainContainer = document.createElement("div");
            var selectedFlag = document.createElement("div");
            var arrow = document.createElement("div");
            var countryList;
            var divider;
            selectedFlagInner.className = "iti-flag";
            flagsContainer.className = "flag-dropdown";
            mainContainer.className = "intl-tel-input";
            selectedFlag.className = "selected-flag";
            arrow.className = "arrow";
            // make element focusable and tab naviagable
            selectedFlag.tabIndex = 0;
            // country list
            // mobile is just a native select element
            // desktop is a proper list containing: preferred countries, then divider, then all countries
            if (isMobile) {
                countryList = document.createElement("select");
                countryList.className = "iti-mobile-select";
            } else {
                countryList = document.createElement("ul");
                countryList.className = "country-list hide";
                if (anyPreferredCountries) {
                    divider = document.createElement("li");
                    divider.className = "divider";
                }
            }
            // must do it this way instead of using a literal syntax, otherwise the min version will have a syntax error
            var ret = {};
            ret.selectedFlagInner = selectedFlagInner;
            ret.flagsContainer = flagsContainer;
            ret.mainContainer = mainContainer;
            ret.selectedFlag = selectedFlag;
            ret.countryList = countryList;
            ret.divider = divider;
            ret.arrow = arrow;
            return ret;
        },
        restructureMarkup: function(element, markup) {
            var selectedFlagInner = markup.selectedFlagInner;
            var flagsContainer = markup.flagsContainer;
            var mainContainer = markup.mainContainer;
            var selectedFlag = markup.selectedFlag;
            var countryList = markup.countryList;
            var arrow = markup.arrow;
            // This check is necessary since this element may have been created without a parent using Javascript
            if (element.parentNode) {
                element.parentNode.insertBefore(mainContainer, element);
            }
            mainContainer.appendChild(element);
            mainContainer.insertBefore(flagsContainer, element);
            // currently selected flag (displayed to left of input)
            flagsContainer.appendChild(selectedFlag);
            selectedFlag.appendChild(selectedFlagInner);
            selectedFlag.appendChild(arrow);
            // country list
            // mobile is just a native select element
            // desktop is a proper list containing: preferred countries, then divider, then all countries
            flagsContainer.appendChild(countryList);
        }
    };
    function IntlTelInput(element, options) {
        var instance = this.instance = new Plugin(element, options || {});
        this.inputElement = element;
        instance._init();
    }
    // get the country data object
    IntlTelInput.getCountryData = function() {
        return allCountries;
    };
    IntlTelInput.version = "6.0.8";
    IntlTelInput.prototype = {
        selectCountry: function(countryCode) {
            return this.instance.selectCountry(countryCode);
        },
        getSelectedCountryData: function() {
            return this.instance.getSelectedCountryData();
        },
        setNumber: function(number, format, addSuffix, preventConversion, isAllowedKey) {
            return this.instance.setNumber(number, format, addSuffix, preventConversion, isAllowedKey);
        },
        getValidationError: function() {
            return this.instance.getValidationError();
        },
        autoCountryLoaded: function() {
            return this.instance.autoCountryLoaded();
        },
        isValidNumber: function() {
            return this.instance.isValidNumber();
        },
        getNumber: function(type) {
            return this.instance.getNumber(type);
        },
        loadUtils: function(path) {
            return this.instance.loadUtils(path);
        },
        getNumberType: function() {
            return this.instance.getNumberType();
        },
        getExtension: function() {
            return this.instance.getExtension();
        },
        utilsLoaded: function() {
            return this.instance.utilsLoaded();
        },
        destroy: function() {
            return this.instance.destroy();
        }
    };
    window.IntlTelInput = IntlTelInput;
    function Plugin(element, options) {
        this.element = element;
        this.options = extend(defaults, options);
        this._defaults = defaults;
        // unique identifier for this instance
        allInstances[id] = this;
        this.id = id;
        id++;
        // Chrome, FF, Safari, IE9+
        this.isGoodBrowser = Boolean(element.setSelectionRange);
        this.hadInitialPlaceholder = element.hasAttribute("placeholder");
        this._name = pluginName;
        // For some reason tests fail when this line is omitted
        if ($) {
            $(element);
        }
    }
    Plugin.prototype = {
        _init: function() {
            // if in nationalMode, disable options relating to dial codes
            if (this.options.nationalMode) {
                this.options.autoHideDialCode = false;
            }
            // IE Mobile doesn't support the keypress event (see issue 68) which makes autoFormat impossible
            if (navigator.userAgent.match(/IEMobile/i)) {
                this.options.autoFormat = false;
            }
            // we cannot just test screen size as some smartphones/website meta tags will report desktop resolutions
            // Note: for some reason jasmine fucks up if you put this in the main Plugin function with the rest of these declarations
            // Note: to target Android Mobiles (and not Tablets), we must find "Android" and "Mobile"
            this.isMobile = false;///Android.+Mobile|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            // we return these deferred objects from the _init() call so they can be watched, and then we resolve them when each specific request returns
            // Note: again, jasmine had a spazz when I put these in the Plugin function
            if ($) {
                this.autoCountryDeferred = new $.Deferred();
                this.utilsScriptDeferred = new $.Deferred();
            }
            // process all the data: onlyCountries, preferredCountries etc
            this._processCountryData();
            // generate the markup
            this._generateMarkup(this.isMobile, this.element, this.countries, this.preferredCountries);
            // set the initial state of the input value and the selected flag
            this._setInitialState();
            // start all of the event listeners: autoHideDialCode, input keydown, selectedFlag click
            this._initListeners();
            // utils script, and auto country
            this._initRequests();
            // return the deferreds
            if ($) {
                return [ this.autoCountryDeferred, this.utilsScriptDeferred ];
            }
        },
        /********************
   *  PRIVATE METHODS
   ********************/
        // prepare all of the country data, including onlyCountries and preferredCountries options
        _processCountryData: function() {
            // set the instances country data objects
            this._setInstanceCountryData();
            // set the preferredCountries property
            this._setPreferredCountries();
        },
        // add a country code to this.countryCodes
        _addCountryCode: function(iso2, dialCode, priority) {
            if (!(dialCode in this.countryCodes)) {
                this.countryCodes[dialCode] = [];
            }
            var index = priority || 0;
            this.countryCodes[dialCode][index] = iso2;
        },
        // process onlyCountries array if present, and generate the countryCodes map
        _setInstanceCountryData: function() {
            var i;
            // process onlyCountries option
            if (this.options.onlyCountries.length) {
                // standardise case
                for (i = 0; i < this.options.onlyCountries.length; i++) {
                    this.options.onlyCountries[i] = this.options.onlyCountries[i].toLowerCase();
                }
                // build instance country array
                this.countries = [];
                for (i = 0; i < allCountries.length; i++) {
                    if (inArray(allCountries[i].iso2, this.options.onlyCountries) != -1) {
                        this.countries.push(allCountries[i]);
                    }
                }
            } else {
                this.countries = allCountries;
            }
            // generate countryCodes map
            this.countryCodes = {};
            for (i = 0; i < this.countries.length; i++) {
                var c = this.countries[i];
                this._addCountryCode(c.iso2, c.dialCode, c.priority);
                // area codes
                if (c.areaCodes) {
                    for (var j = 0; j < c.areaCodes.length; j++) {
                        // full dial code is country code + dial code
                        this._addCountryCode(c.iso2, c.dialCode + c.areaCodes[j]);
                    }
                }
            }
        },
        // process preferred countries - iterate through the preferences,
        // fetching the country data for each one
        _setPreferredCountries: function() {
            this.preferredCountries = [];
            for (var i = 0; i < this.options.preferredCountries.length; i++) {
                var countryCode = this.options.preferredCountries[i].toLowerCase(), countryData = this._getCountryData(countryCode, false, true);
                if (countryData) {
                    this.preferredCountries.push(countryData);
                }
            }
        },
        // generate all of the markup for the plugin: the selected flag overlay, and the dropdown
        _generateMarkup: function(isMobile, element, countries, preferredCountries) {
            var markup = methods.generateMarkup(isMobile, preferredCountries.length);
            methods.restructureMarkup(element, markup);
            // prevent autocomplete as there's no safe, cross-browser event we can react to, so it can easily put the plugin in an inconsistent state e.g. the wrong flag selected for the autocompleted number, which on submit could mean the wrong number is saved (esp in nationalMode)
            element.setAttribute("autocomplete", "off");
            this.selectedFlagInner = markup.selectedFlagInner;
            this.flagsContainer = markup.flagsContainer;
            this.selectedFlag = markup.selectedFlag;
            this.countryList = markup.countryList;
            this.arrow = markup.arrow;
            if (preferredCountries.length && !isMobile) {
                this._appendListItems(preferredCountries, "preferred");
                this.countryList.appendChild(markup.divider);
            }
            this._appendListItems(countries, "");
            if (!isMobile) {
                // now we can grab the dropdown height, and hide it properly
                this.dropdownHeight = methods.getDropdownHeight(this.countryList);
                // this is useful in lots of places
                this.countryListItems = this.countryList.querySelectorAll(".country");
            }
        },
        // add a country <li> to the countryList <ul> container
        // UPDATE: if isMobile, add an <option> to the countryList <select> container
        _appendListItems: function(countries, className) {
            // we create so many DOM elements, it is faster to build a temp string
            // and then add everything to the DOM in one go at the end
            var tmp = "";
            // for each country
            for (var i = 0; i < countries.length; i++) {
                var c = countries[i];
                if (this.isMobile) {
                    tmp += "<option data-dial-code='" + c.dialCode + "' value='" + c.iso2 + "'>";
                    tmp += c.name + " +" + c.dialCode;
                    tmp += "</option>";
                } else {
                    // open the list item
                    tmp += "<li class='country " + className + "' data-dial-code='" + c.dialCode + "' data-country-code='" + c.iso2 + "'>";
                    // add the flag
                    tmp += "<div class='flag'><div class='iti-flag " + c.iso2 + "'></div></div>";
                    // and the country name and dial code
                    tmp += "<span class='country-name'>" + c.name + "</span>";
                    tmp += "<span class='dial-code'>+" + c.dialCode + "</span>";
                    // close the list item
                    tmp += "</li>";
                }
            }
            this.countryList.innerHTML += tmp;
        },
        // set the initial state of the input value and the selected flag
        _setInitialState: function() {
            var val = this.element.value;
            // if there is a number, and it's valid, we can go ahead and set the flag, else fall back to default
            if (this._getDialCode(val)) {
                this._updateFlagFromNumber(val, true);
            } else if (this.options.defaultCountry != "auto") {
                // check the defaultCountry option, else fall back to the first in the list
                if (this.options.defaultCountry) {
                    this.options.defaultCountry = this._getCountryData(this.options.defaultCountry.toLowerCase(), false, false);
                } else {
                    this.options.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0] : this.countries[0];
                }
                this._selectFlag(this.options.defaultCountry.iso2);
                // if empty, insert the default dial code (this function will check !nationalMode and !autoHideDialCode)
                if (!val) {
                    this._updateDialCode(this.options.defaultCountry.dialCode, false);
                }
            }
            // format
            if (val) {
                // this wont be run after _updateDialCode as that's only called if no val
                this._updateVal(val);
            }
        },
        // initialise the main event listeners: input keyup, and click selected flag
        _initListeners: function() {
            var that = this;
            this._eventListeners = {};
            this._initKeyListeners();
            // autoFormat prevents the change event from firing, so we need to check for changes between focus and blur in order to manually trigger it
            if (this.options.autoHideDialCode || this.options.autoFormat) {
                this._initFocusListeners();
            }
            if (this.isMobile) {
                this._eventListeners.onMobileCountryListChange = createHandler(this.countryList, function(e) {
                    var selectedItem = this.querySelector("option:checked");
                    if (selectedItem) {
                        that._selectListItem(selectedItem);
                    }
                });
                addEventListener(this.countryList, "change", this._eventListeners.onMobileCountryListChange);
            } else {
                // hack for input nested inside label: clicking the selected-flag to open the dropdown would then automatically trigger a 2nd click on the input which would close it again
                var label = getClosest(this.element, "label");
                if (label) {
                    this._eventListeners.onLabelClicked = createHandler(function(e) {
                        // if the dropdown is closed, then focus the input, else ignore the click
                        if (hasClass(that.countryList, "hide")) {
                            that.element.focus();
                        } else {
                            preventDefault(e);
                        }
                    });
                    addEventListener(label, "click", this._eventListeners.onLabelClicked);
                }
                // toggle country dropdown on click
                this._eventListeners.onSelectedFlagClicked = createHandler(this.selectedFlag, function(e) {
                    // only intercept this event if we're opening the dropdown
                    // else let it bubble up to the top ("click-off-to-close" listener)
                    // we cannot just stopPropagation as it may be needed to close another instance
                    if (hasClass(that.countryList, "hide") && !that.element.disabled && !that.element.readonly) {
                        that._showDropdown();
                    }
                });
                addEventListener(this.selectedFlag, "click", this._eventListeners.onSelectedFlagClicked);
            }
            // open dropdown list if currently focused
            this._eventListeners.onFlagKeydown = createHandler(this.flagsContainer, function(e) {
                var isDropdownHidden = hasClass(that.countryList, "hide");
                var which = whichKey(e);
                if (isDropdownHidden && (which == keys.UP || which == keys.DOWN || which == keys.SPACE || which == keys.ENTER)) {
                    // prevent form from being submitted if "ENTER" was pressed
                    preventDefault(e);
                    // prevent event from being handled again by document
                    stopPropagation(e);
                    that._showDropdown();
                }
                // allow navigation from dropdown to input on TAB
                if (which == keys.TAB) {
                    that._closeDropdown();
                }
            });
            addEventListener(this.flagsContainer, "keydown", this._eventListeners.onFlagKeydown);
        },
        _initRequests: function() {
            var that = this;
            // if the user has specified the path to the utils script, fetch it on window.load
            if (this.options.utilsScript) {
                // if the plugin is being initialised after the window.load event has already been fired
                if (windowLoaded) {
                    this.loadUtils();
                } else {
                    // wait until the load event so we don't block any other requests e.g. the flags image
                    addEventListener(window, "load", createHandler(window, function() {
                        that.loadUtils();
                    }));
                }
            } else if ($) {
                this.utilsScriptDeferred.resolve();
            }
            if (this.options.defaultCountry == "auto") {
                this._loadAutoCountry();
            } else if ($) {
                this.autoCountryDeferred.resolve();
            }
        },
        _loadAutoCountry: function() {
            var that = this;
            // check for cookie
            var cookieAutoCountry = storage.get("itiAutoCountry");
            if (cookieAutoCountry) {
                IntlTelInput.autoCountry = cookieAutoCountry;
            }
            // 3 options:
            // 1) already loaded (we're done)
            // 2) not already started loading (start)
            // 3) already started loading (do nothing - just wait for loading callback to fire)
            if (IntlTelInput.autoCountry) {
                this.autoCountryLoaded();
            } else if (!IntlTelInput.startedLoadingAutoCountry) {
                // don't do this twice!
                IntlTelInput.startedLoadingAutoCountry = true;
                if (typeof this.options.geoIpLookup === "function") {
                    this.options.geoIpLookup(function(countryCode) {
                        IntlTelInput.autoCountry = countryCode.toLowerCase();
                        storage.set("itiAutoCountry", IntlTelInput.autoCountry, {
                            path: "/"
                        });
                        // tell all instances the auto country is ready
                        // TODO: this should just be the current instances
                        // UPDATE: use setTimeout in case their geoIpLookup function calls this callback straight away (e.g. if they have already done the geo ip lookup somewhere else). Using setTimeout means that the current thread of execution will finish before executing this, which allows the plugin to finish initialising.
                        setTimeout(function() {
                            forEach(allInstances, function(instance) {
                                if (instance) {
                                    instance.autoCountryLoaded();
                                }
                            });
                        });
                    });
                }
            }
        },
        _initKeyListeners: function() {
            var that = this;
            if (this.options.autoFormat) {
                // format number and update flag on keypress
                // use keypress event as we want to ignore all input except for a select few keys,
                // but we dont want to ignore the navigation keys like the arrows etc.
                // NOTE: no point in refactoring this to only bind these listeners on focus/blur because then you would need to have those 2 listeners running the whole time anyway...
                this._eventListeners.onElementKeypress = createHandler(this.element, function(e) {
                    // 32 is space, and after that it's all chars (not meta/nav keys)
                    // this fix is needed for Firefox, which triggers keypress event for some meta/nav keys
                    // Update: also ignore if this is a metaKey e.g. FF and Safari trigger keypress on the v of Ctrl+v
                    // Update: also ignore if ctrlKey (FF on Windows/Ubuntu)
                    // Update: also check that we have utils before we do any autoFormat stuff
                    var which = whichKey(e);
                    if (which >= keys.SPACE && !e.ctrlKey && !e.metaKey && window.intlTelInputUtils && !that.element.readonly) {
                        preventDefault(e);
                        // allowed keys are just numeric keys and plus
                        // we must allow plus for the case where the user does select-all and then hits plus to start typing a new number. we could refine this logic to first check that the selection contains a plus, but that wont work in old browsers, and I think it's overkill anyway
                        var isAllowedKey = which >= keys.ZERO && which <= keys.NINE || which == keys.PLUS, input = that.element, noSelection = that.isGoodBrowser && input.selectionStart == input.selectionEnd, max = that.element.maxlength || that.element.getAttribute("maxlength"), val = that.element.value, // assumes that if max exists, it is >0
                        isBelowMax = max ? val.length < max : true;
                        // first: ensure we dont go over maxlength. we must do this here to prevent adding digits in the middle of the number
                        // still reformat even if not an allowed key as they could by typing a formatting char, but ignore if there's a selection as doesn't make sense to replace selection with illegal char and then immediately remove it
                        if (isBelowMax && (isAllowedKey || noSelection)) {
                            var newChar = isAllowedKey ? String.fromCharCode(which) : null;
                            that._handleInputKey(newChar, true, isAllowedKey);
                            // if something has changed, trigger the input event (which was otherwised squashed by the preventDefault)
                            if (val != that.element.value) {
                                dispatchEvent(that.element, "input", true, false);
                            }
                        }
                        if (!isAllowedKey) {
                            that._handleInvalidKey();
                        }
                    }
                });
                addEventListener(this.element, "keypress", this._eventListeners.onElementKeypress);
            }
            // handle cut/paste event (now supported in all major browsers)
            this._eventListeners.onElementCutOrPaste = createHandler(this.element, function() {
                // hack because "paste" event is fired before input is updated
                setTimeout(function() {
                    if (that.options.autoFormat && window.intlTelInputUtils) {
                        var cursorAtEnd = that.isGoodBrowser && that.element.selectionStart == that.element.value.length;
                        that._handleInputKey(null, cursorAtEnd);
                        that._ensurePlus();
                    } else {
                        // if no autoFormat, just update flag
                        // FIXME: tests still pass when this line is commented
                        that._updateFlagFromNumber(that.element.value);
                    }
                });
            });
            addEventListener(this.element, "paste", this._eventListeners.onElementCutOrPaste);
            addEventListener(this.element, "cut", this._eventListeners.onElementCutOrPaste);
            // handle keyup event
            // if autoFormat enabled: we use keyup to catch delete events (after the fact)
            // if no autoFormat, this is used to update the flag
            this._eventListeners.onElementKeyup = createHandler(this.element, function(e) {
                // the "enter" key event from selecting a dropdown item is triggered here on the input, because the document.keydown handler that initially handles that event triggers a focus on the input, and so the keyup for that same key event gets triggered here. weird, but just make sure we dont bother doing any re-formatting in this case (we've already done preventDefault in the keydown handler, so it wont actually submit the form or anything).
                // ALSO: ignore keyup if readonly
                var which = whichKey(e);
                if (which == keys.ENTER || that.element.readonly) {} else if (that.options.autoFormat && window.intlTelInputUtils) {
                    // cursorAtEnd defaults to false for bad browsers else they would never get a reformat on delete
                    var cursorAtEnd = that.isGoodBrowser && that.element.selectionStart == that.element.value.length;
                    if (!that.element.value) {
                        // if they just cleared the input, update the flag to the default
                        that._updateFlagFromNumber("");
                    } else if (which == keys.DEL && !cursorAtEnd || which == keys.BSPACE) {
                        // if delete in the middle: reformat with no suffix (no need to reformat if delete at end)
                        // if backspace: reformat with no suffix (need to reformat if at end to remove any lingering suffix - this is a feature)
                        // important to remember never to add suffix on any delete key as can fuck up in ie8 so you can never delete a formatting char at the end
                        that._handleInputKey();
                    }
                    that._ensurePlus();
                } else {
                    // if no autoFormat, just update flag
                    that._updateFlagFromNumber(that.element.value);
                }
            });
            addEventListener(this.element, "keyup", this._eventListeners.onElementKeyup);
        },
        // prevent deleting the plus (if not in nationalMode)
        _ensurePlus: function() {
            if (!this.options.nationalMode) {
                var val = this.element.value;
                if (val.charAt(0) != "+") {
                    // newCursorPos is current pos + 1 to account for the plus we are about to add
                    var newCursorPos = this.isGoodBrowser ? this.element.selectionStart + 1 : 0;
                    // FIXME: tests still pass when this line is commented out -_-
                    this.element.value = "+" + val;
                    if (this.isGoodBrowser) {
                        this.element.setSelectionRange(newCursorPos, newCursorPos);
                    }
                }
            }
        },
        // alert the user to an invalid key event
        _handleInvalidKey: function() {
            var that = this;
            dispatchCustomEvent(this.element, "invalidkey", true, true);
            addClass(this.element, "iti-invalid-key");
            setTimeout(function() {
                removeClass(that.element, "iti-invalid-key");
            }, 100);
        },
        // when autoFormat is enabled: handle various key events on the input:
        // 1) adding a new number character, which will replace any selection, reformat, and preserve the cursor position
        // 2) reformatting on backspace/delete
        // 3) cut/paste event
        _handleInputKey: function(newNumericChar, addSuffix, isAllowedKey) {
            var val = this.element.value, cleanBefore = this._getClean(val), originalLeftChars, digitsOnRight = 0;
            if (this.isGoodBrowser) {
                // cursor strategy: maintain the number of digits on the right. we use the right instead of the left so that A) we dont have to account for the new digit (or multiple digits if paste event), and B) we're always on the right side of formatting suffixes
                digitsOnRight = this._getDigitsOnRight(val, this.element.selectionEnd);
                // if handling a new number character: insert it in the right place
                if (newNumericChar) {
                    // replace any selection they may have made with the new char
                    val = val.substr(0, this.element.selectionStart) + newNumericChar + val.substring(this.element.selectionEnd, val.length);
                } else {
                    // here we're not handling a new char, we're just doing a re-format (e.g. on delete/backspace/paste, after the fact), but we still need to maintain the cursor position. so make note of the char on the left, and then after the re-format, we'll count in the same number of digits from the right, and then keep going through any formatting chars until we hit the same left char that we had before.
                    // UPDATE: now have to store 2 chars as extensions formatting contains 2 spaces so you need to be able to distinguish
                    originalLeftChars = val.substr(this.element.selectionStart - 2, 2);
                }
            } else if (newNumericChar) {
                val += newNumericChar;
            }
            // update the number and flag
            this.setNumber(val, null, addSuffix, true, isAllowedKey);
            // update the cursor position
            if (this.isGoodBrowser) {
                var newCursor;
                val = this.element.value;
                // if it was at the end, keep it there
                if (!digitsOnRight) {
                    newCursor = val.length;
                } else {
                    // else count in the same number of digits from the right
                    newCursor = this._getCursorFromDigitsOnRight(val, digitsOnRight);
                    // but if delete/paste etc, keep going left until hit the same left char as before
                    if (!newNumericChar) {
                        newCursor = this._getCursorFromLeftChar(val, newCursor, originalLeftChars);
                    }
                }
                // set the new cursor
                this.element.setSelectionRange(newCursor, newCursor);
            }
        },
        // we start from the position in guessCursor, and work our way left until we hit the originalLeftChars or a number to make sure that after reformatting the cursor has the same char on the left in the case of a delete etc
        _getCursorFromLeftChar: function(val, guessCursor, originalLeftChars) {
            for (var i = guessCursor; i > 0; i--) {
                var leftChar = val.charAt(i - 1);
                if (isNumeric(leftChar) || val.substr(i - 2, 2) == originalLeftChars) {
                    return i;
                }
            }
            return 0;
        },
        // after a reformat we need to make sure there are still the same number of digits to the right of the cursor
        _getCursorFromDigitsOnRight: function(val, digitsOnRight) {
            for (var i = val.length - 1; i >= 0; i--) {
                if (isNumeric(val.charAt(i))) {
                    if (--digitsOnRight === 0) {
                        return i;
                    }
                }
            }
            return 0;
        },
        // get the number of numeric digits to the right of the cursor so we can reposition the cursor correctly after the reformat has happened
        _getDigitsOnRight: function(val, selectionEnd) {
            var digitsOnRight = 0;
            for (var i = selectionEnd; i < val.length; i++) {
                if (isNumeric(val.charAt(i))) {
                    digitsOnRight++;
                }
            }
            return digitsOnRight;
        },
        // listen for focus and blur
        _initFocusListeners: function() {
            var that = this;
            if (this.options.autoHideDialCode) {
                this._eventListeners.onElementMousedown = createHandler(this.element, function(e) {
                    // FIXME: tests still pass when this statement is commented out -_-
                    if (!hasFocus(that.element) && !that.element.value) {
                        preventDefault(e);
                        // but this also cancels the focus, so we must trigger that manually
                        that.element.focus();
                    }
                });
                // mousedown decides where the cursor goes, so if we're focusing we must preventDefault as we'll be inserting the dial code, and we want the cursor to be at the end no matter where they click
                addEventListener(this.element, "mousedown", this._eventListeners.onElementMousedown);
            }
            this._eventListeners.plusPressedListeners = [];
            this._eventListeners.onElementFocused = createHandler(this.element, function(e) {
                var value = that.element.value;
                // save this to compare on blur
                // FIXME: tests pass when this line is commented out -_-
                that.element.setAttribute("data-focus-val", value);
                // on focus: if empty, insert the dial code for the currently selected flag
                if (that.options.autoHideDialCode && !value && !that.element.readonly && that.selectedCountryData.dialCode) {
                    that._updateVal("+" + that.selectedCountryData.dialCode, null, true);
                    // after auto-inserting a dial code, if the first key they hit is '+' then assume they are entering a new number, so remove the dial code. use keypress instead of keydown because keydown gets triggered for the shift key (required to hit the + key), and instead of keyup because that shows the new '+' before removing the old one
                    var onElementPlusPressed = createHandler(that.element, function(e) {
                        var which = whichKey(e);
                        if (which == keys.PLUS) {
                            // if autoFormat is enabled, this key event will have already have been handled by another keypress listener (hence we need to add the "+"). if disabled, it will be handled after this by a keyup listener (hence no need to add the "+").
                            var newVal = that.options.autoFormat && window.intlTelInputUtils ? "+" : "";
                            // FIXME: tests still pass when this line is commented out -_-
                            that.element.value = newVal;
                        }
                        removeEventListener(that.element, "keypress", onElementPlusPressed);
                    });
                    addEventListener(that.element, "keypress", onElementPlusPressed);
                    that._eventListeners.plusPressedListeners.push(onElementPlusPressed);
                    // after tabbing in, make sure the cursor is at the end we must use setTimeout to get outside of the focus handler as it seems the selection happens after that
                    setTimeout(function() {
                        // FIXME: tests still pass when this statement is commented out -_-
                        if (that.isGoodBrowser) {
                            var len = that.element.value.length;
                            that.element.setSelectionRange(len, len);
                        }
                    });
                }
            });
            this._eventListeners.onElementBlurred = createHandler(this.element, function() {
                if (that.options.autoHideDialCode) {
                    // on blur: if just a dial code then remove it
                    var value = that.element.value, startsPlus = value.charAt(0) == "+";
                    if (startsPlus) {
                        var numeric = that._getNumeric(value);
                        // if just a plus, or if just a dial code
                        if (!numeric || that.selectedCountryData.dialCode == numeric) {
                            that.element.value = "";
                        }
                    }
                    // remove the keypress listener we added on focus
                    forEach(that._eventListeners.plusPressedListeners, function(listener) {
                        removeEventListener(that.element, "keypress", listener);
                    });
                    that._eventListeners.plusPressedListeners = [];
                }
                // if autoFormat, we must manually trigger change event if value has changed
                // FIXME: tests pass when this statement is commented out -_-
                if (that.options.autoFormat && window.intlTelInputUtils && that.element.value != that.element.getAttribute("data-focus-val")) {
                    dispatchEvent(that.element, "change", true, false);
                }
            });
            addEventListener(this.element, "focus", this._eventListeners.onElementFocused);
            addEventListener(this.element, "blur", this._eventListeners.onElementBlurred);
        },
        // extract the numeric digits from the given string
        _getNumeric: function(s) {
            return s.replace(/\D/g, "");
        },
        _getClean: function(s) {
            var prefix = s.charAt(0) == "+" ? "+" : "";
            return prefix + this._getNumeric(s);
        },
        // show the dropdown
        _showDropdown: function() {
            this._setDropdownPosition();
            // update highlighting and scroll to active list item
            var activeListItem = this.countryList.querySelector(".active");
            if (activeListItem) {
                this._highlightListItem(activeListItem);
            }
            // show it
            removeClass(this.countryList, "hide");
            if (activeListItem) {
                this._scrollTo(activeListItem);
            }
            // bind all the dropdown-related listeners: mouseover, click, click-off, keydown
            this._bindDropdownListeners();
            // update the arrow
            // FIXED: arrow is a child of selectedFlag not selectedFlagInner
            // FIXME: tests still pass when this line is commented -_-
            addClass(this.arrow, "up");
        },
        // decide where to position dropdown (depends on position within viewport, and scroll)
        _setDropdownPosition: function() {
            var inputTop = getOffset(this.element).top, windowTop = getWindowScrollTop(), // dropdownFitsBelow = (dropdownBottom < windowBottom)
            dropdownFitsBelow = inputTop + this.element.offsetHeight + this.dropdownHeight < windowTop + getWindowInnerHeight(), dropdownFitsAbove = inputTop - this.dropdownHeight > windowTop;
            // dropdownHeight - 1 for border
            // FIXME: cssTop sometimes has two leading negative signs (e.g: --1px)
            var cssTop = !dropdownFitsBelow && dropdownFitsAbove ? "-" + (this.dropdownHeight - 1) + "px" : "";
            this.countryList.style.top = cssTop;
        },
        // we only bind dropdown listeners when the dropdown is open
        _bindDropdownListeners: function() {
            var that = this;
            if (Element.prototype.addEventListener) {
                // when mouse over a list item, just highlight that one
                // we add the class "highlight", so if they hit "enter" we know which one to select
                this._eventListeners.onListItemMouseover = function(e) {
                    // FIXME: tests still pass when this element is commented out -_-
                    that._highlightListItem(this);
                };
                // listen for country selection
                this._eventListeners.onDesktopCountryItemClicked = function(e) {
                    that._selectListItem(this);
                };
            } else {
                // when mouse over a list item, just highlight that one
                // we add the class "highlight", so if they hit "enter" we know which one to select
                this._eventListeners.onListItemMouseover = function(e) {
                    // since IE8 doesn't bind `this` to the clicked element, we have to do some traversing, or add an event listener
                    // for each item -_-
                    var target = e.currentTarget || e.target || e.srcElement;
                    var listItem = getClosest(target, "li");
                    // FIXME: tests still pass when this element is commented out -_-
                    if (listItem) {
                        that._highlightListItem(listItem);
                    }
                };
                // listen for country selection
                this._eventListeners.onDesktopCountryItemClicked = function(e) {
                    // since IE8 doesn't bind `this` to the clicked element, we have to do some traversing, or add an event listener
                    // for each item -_-
                    var target = e.currentTarget || e.target || e.srcElement;
                    var listItem = getClosest(target, "li");
                    if (listItem) {
                        that._selectListItem(listItem);
                    }
                };
            }
            forEach(this.countryListItems, function(element) {
                addEventListener(element, "click", that._eventListeners.onDesktopCountryItemClicked);
                addEventListener(element, "mouseover", that._eventListeners.onListItemMouseover);
            });
            // click off to close
            // (except when this initial opening click is bubbling up)
            // we cannot just stopPropagation as it may be needed to close another instance
            var isOpening = true;
            this._eventListeners.onHtmlClicked = createHandler(document, function(e) {
                if (!isOpening) {
                    that._closeDropdown();
                }
                isOpening = false;
            });
            addEventListener(document, "click", this._eventListeners.onHtmlClicked);
            // listen for up/down scrolling, enter to select, or letters to jump to country name.
            // use keydown as keypress doesn't fire for non-char keys and we want to catch if they
            // just hit down and hold it to scroll down (no keyup event).
            // listen on the document because that's where key events are triggered if no input has focus
            // FIXME: maybe it's better to only preventDefault() if we know how to handle the key
            var query = "", queryTimer = null;
            this._eventListeners.onDocumentKeydown = createHandler(document, function(e) {
                // prevent down key from scrolling the whole page,
                // and enter key from submitting a form etc
                preventDefault(e);
                var which = whichKey(e);
                if (which == keys.UP || which == keys.DOWN) {
                    // up and down to navigate
                    that._handleUpDownKey(which);
                } else if (which == keys.ENTER) {
                    // enter to select
                    that._handleEnterKey();
                } else if (which == keys.ESC) {
                    // esc to close
                    that._closeDropdown();
                } else if (which >= keys.A && which <= keys.Z || which == keys.SPACE) {
                    // upper case letters (note: keyup/keydown only return upper case letters)
                    // jump to countries that start with the query string
                    if (queryTimer) {
                        clearTimeout(queryTimer);
                    }
                    query += String.fromCharCode(which);
                    that._searchForCountry(query);
                    // if the timer hits 1 second, reset the query
                    queryTimer = setTimeout(function() {
                        query = "";
                    }, 1e3);
                }
            });
            addEventListener(document, "keydown", this._eventListeners.onDocumentKeydown);
        },
        // highlight the next/prev item in the list (and ensure it is visible)
        _handleUpDownKey: function(key) {
            var current = this.countryList.querySelector(".highlight");
            var next = key == keys.UP ? current.previousSibling : current.nextSibling;
            if (next) {
                // skip the divider
                if (hasClass(next, "divider")) {
                    next = key == keys.UP ? next.previousSibling : next.nextSibling;
                }
                this._highlightListItem(next);
                this._scrollTo(next);
            }
        },
        // select the currently highlighted item
        _handleEnterKey: function() {
            var currentCountry = this.countryList.querySelector(".highlight");
            if (currentCountry) {
                this._selectListItem(currentCountry);
            }
        },
        // find the first list item whose name starts with the query string
        // NOTE: consider adding `data-country-name` atrribute and using [data-country-name^=<query>] css selector
        _searchForCountry: function(query) {
            for (var i = 0; i < this.countries.length; i++) {
                if (this._startsWith(this.countries[i].name, query)) {
                    var listItem = methods.getListItemByCode(this.countryList, this.countries[i].iso2);
                    // update highlighting and scroll
                    if (listItem) {
                        this._highlightListItem(listItem);
                        this._scrollTo(listItem, true);
                    }
                    break;
                }
            }
        },
        // check if (uppercase) string a starts with string b
        _startsWith: function(a, b) {
            return a.substr(0, b.length).toUpperCase() == b;
        },
        // update the input's value to the given val
        // if autoFormat=true, format it first according to the country-specific formatting rules
        // Note: preventConversion will be false (i.e. we allow conversion) on init and when dev calls public method setNumber
        _updateVal: function(val, format, addSuffix, preventConversion, isAllowedKey) {
            var formatted;
            if (this.options.autoFormat && window.intlTelInputUtils && this.selectedCountryData) {
                if (typeof format == "number" && intlTelInputUtils.isValidNumber(val, this.selectedCountryData.iso2)) {
                    // if user specified a format, and it's a valid number, then format it accordingly
                    formatted = intlTelInputUtils.formatNumberByType(val, this.selectedCountryData.iso2, format);
                } else if (!preventConversion && this.options.nationalMode && val.charAt(0) == "+" && intlTelInputUtils.isValidNumber(val, this.selectedCountryData.iso2)) {
                    // if nationalMode and we have a valid intl number, convert it to ntl
                    formatted = intlTelInputUtils.formatNumberByType(val, this.selectedCountryData.iso2, intlTelInputUtils.numberFormat.NATIONAL);
                } else {
                    // else do the regular AsYouType formatting
                    formatted = intlTelInputUtils.formatNumber(val, this.selectedCountryData.iso2, addSuffix, this.options.allowExtensions, isAllowedKey);
                }
                // ensure we dont go over maxlength. we must do this here to truncate any formatting suffix, and also handle paste events
                var max = this.element.getAttribute("maxlength");
                if (max && formatted.length > max) {
                    formatted = formatted.substr(0, max);
                }
            } else {
                // no autoFormat, so just insert the original value
                formatted = val;
            }
            this.element.value = formatted;
        },
        // check if need to select a new flag based on the given number
        _updateFlagFromNumber: function(number, updateDefault) {
            // if we're in nationalMode and we're on US/Canada, make sure the number starts with a +1 so _getDialCode will be able to extract the area code
            // update: if we dont yet have selectedCountryData, but we're here (trying to update the flag from the number), that means we're initialising the plugin with a number that already has a dial code, so fine to ignore this bit
            if (number && this.options.nationalMode && this.selectedCountryData && this.selectedCountryData.dialCode == "1" && number.charAt(0) != "+") {
                if (number.charAt(0) != "1") {
                    number = "1" + number;
                }
                number = "+" + number;
            }
            // try and extract valid dial code from input
            var dialCode = this._getDialCode(number), countryCode = null;
            if (dialCode) {
                // check if one of the matching countries is already selected
                var countryCodes = this.countryCodes[this._getNumeric(dialCode)], alreadySelected = this.selectedCountryData && inArray(this.selectedCountryData.iso2, countryCodes) != -1;
                // if a matching country is not already selected (or this is an unknown NANP area code): choose the first in the list
                if (!alreadySelected || this._isUnknownNanp(number, dialCode)) {
                    // if using onlyCountries option, countryCodes[0] may be empty, so we must find the first non-empty index
                    for (var j = 0; j < countryCodes.length; j++) {
                        if (countryCodes[j]) {
                            countryCode = countryCodes[j];
                            break;
                        }
                    }
                }
            } else if (number.charAt(0) == "+" && this._getNumeric(number).length) {
                // invalid dial code, so empty
                // Note: use getNumeric here because the number has not been formatted yet, so could contain bad shit
                countryCode = "";
            } else if (!number || number == "+") {
                // empty, or just a plus, so default
                countryCode = this.options.defaultCountry.iso2;
            }
            if (countryCode !== null) {
                this._selectFlag(countryCode, updateDefault);
            }
        },
        // check if the given number contains an unknown area code from the North American Numbering Plan i.e. the only dialCode that could be extracted was +1 but the actual number's length is >=4
        _isUnknownNanp: function(number, dialCode) {
            return dialCode == "+1" && this._getNumeric(number).length >= 4;
        },
        // remove highlighting from other list items and highlight the given item
        _highlightListItem: function(listItem) {
            forEach(this.countryList.querySelectorAll(".highlight"), function(element) {
                removeClass(element, "highlight");
            });
            addClass(listItem, "highlight");
        },
        // find the country data for the given country code
        // the ignoreOnlyCountriesOption is only used during init() while parsing the onlyCountries array
        _getCountryData: function(countryCode, ignoreOnlyCountriesOption, allowFail) {
            var countryList = ignoreOnlyCountriesOption ? allCountries : this.countries;
            for (var i = 0; i < countryList.length; i++) {
                if (countryList[i].iso2 == countryCode) {
                    return countryList[i];
                }
            }
            if (allowFail) {
                return null;
            } else {
                throw new Error("No country data for '" + countryCode + "'");
            }
        },
        // select the given flag, update the placeholder and the active list item
        _selectFlag: function(countryCode, updateDefault) {
            // do this first as it will throw an error and stop if countryCode is invalid
            this.selectedCountryData = countryCode ? this._getCountryData(countryCode, false, false) : {};
            // update the "defaultCountry" - we only need the iso2 from now on, so just store that
            if (updateDefault && this.selectedCountryData.iso2) {
                // can't just make this equal to selectedCountryData as would be a ref to that object
                this.options.defaultCountry = {
                    iso2: this.selectedCountryData.iso2
                };
            }
            this.selectedFlagInner.className = "iti-flag " + countryCode;
            // update the selected country's title attribute
            var title = countryCode ? this.selectedCountryData.name + ": +" + this.selectedCountryData.dialCode : "Unknown";
            this.selectedFlag.setAttribute("title", title);
            // and the input's placeholder
            this._updatePlaceholder();
            if (this.isMobile) {
                // FIXME: tests still pass when this line is commented out
                this.countryList.value = countryCode;
            } else {
                // update the active list item
                forEach(this.countryList.querySelectorAll(".active"), function(element) {
                    removeClass(element, "active");
                });
                if (countryCode) {
                    addClass(this.countryList.querySelector("[data-country-code=" + countryCode + "]"), "active");
                }
            }
        },
        // update the input placeholder to an example number from the currently selected country
        _updatePlaceholder: function() {
            if (window.intlTelInputUtils && !this.hadInitialPlaceholder && this.options.autoPlaceholder && this.selectedCountryData) {
                var iso2 = this.selectedCountryData.iso2, numberType = intlTelInputUtils.numberType[this.options.numberType || "FIXED_LINE"], placeholder = iso2 ? intlTelInputUtils.getExampleNumber(iso2, this.options.nationalMode, numberType) : "";
                if (typeof this.options.customPlaceholder === "function") {
                    placeholder = this.options.customPlaceholder(placeholder, this.selectedCountryData);
                }
                this.element.setAttribute("placeholder", placeholder);
            }
        },
        // called when the user selects a list item from the dropdown
        _selectListItem: function(listItem) {
            var countryCodeAttr = this.isMobile ? "value" : "data-country-code";
            // update selected flag and active list item
            this._selectFlag(listItem.getAttribute(countryCodeAttr), true);
            if (!this.isMobile) {
                this._closeDropdown();
            }
            this._updateDialCode(listItem.getAttribute("data-dial-code"), true);
            // always fire the change event as even if nationalMode=true (and we haven't updated the input val), the system as a whole has still changed - see country-sync example. think of it as making a selection from a select element.
            dispatchEvent(this.element, "change", true, false);
            // focus the input
            this.element.focus();
            // fix for FF and IE11 (with nationalMode=false i.e. auto inserting dial code), who try to put the cursor at the beginning the first time
            if (this.isGoodBrowser) {
                var len = this.element.value.length;
                this.element.setSelectionRange(len, len);
            }
        },
        // close the dropdown and unbind any listeners
        _closeDropdown: function() {
            addClass(this.countryList, "hide");
            // update the arrow
            // FIXED: arrow is a child of selectedFlag not selectedFlagInner
            // FIXME: tests still pass when this line is commented out -_-
            removeClass(this.arrow, "up");
            // unbind key events
            removeEventListener(document, "keydown", this._eventListeners.onDocumentKeydown);
            // unbind click-off-to-close
            removeEventListener(document, "click", this._eventListeners.onHtmlClicked);
            // unbind hover and click listeners
            var onDesktopCountryItemClicked = this._eventListeners.onDesktopCountryItemClicked;
            var onListItemMouseover = this._eventListeners.onListItemMouseover;
            forEach(this.countryListItems, function(element) {
                removeEventListener(element, "mouseover", onListItemMouseover);
                removeEventListener(element, "click", onDesktopCountryItemClicked);
            });
        },
        // check if an element is visible within it's container, else scroll until it is
        _scrollTo: function(element, middle) {
            var container = this.countryList, containerHeight = container.clientHeight, containerTop = getOffset(container).top, containerBottom = containerTop + containerHeight, elementHeight = element.offsetHeight, elementTop = getOffset(element).top, elementBottom = elementTop + elementHeight, newScrollTop = elementTop - containerTop + container.scrollTop, middleOffset = containerHeight / 2 - elementHeight / 2;
            if (elementTop < containerTop) {
                // scroll up
                if (middle) {
                    newScrollTop -= middleOffset;
                }
                container.scrollTop = newScrollTop;
            } else if (elementBottom > containerBottom) {
                // scroll down
                if (middle) {
                    newScrollTop += middleOffset;
                }
                var heightDifference = containerHeight - elementHeight;
                container.scrollTop = newScrollTop - heightDifference;
            }
        },
        // replace any existing dial code with the new one (if not in nationalMode)
        // also we need to know if we're focusing for a couple of reasons e.g. if so, we want to add any formatting suffix, also if the input is empty and we're not in nationalMode, then we want to insert the dial code
        _updateDialCode: function(newDialCode, focusing) {
            var inputVal = this.element.value, newNumber;
            // save having to pass this every time
            newDialCode = "+" + newDialCode;
            if (this.options.nationalMode && inputVal.charAt(0) != "+") {
                // if nationalMode, we just want to re-format
                newNumber = inputVal;
            } else if (inputVal) {
                // if the previous number contained a valid dial code, replace it
                // (if more than just a plus character)
                var prevDialCode = this._getDialCode(inputVal);
                if (prevDialCode.length > 1) {
                    newNumber = inputVal.replace(prevDialCode, newDialCode);
                } else {
                    // if the previous number didn't contain a dial code, we should persist it
                    var existingNumber = inputVal.charAt(0) != "+" ? trim(inputVal) : "";
                    newNumber = newDialCode + existingNumber;
                }
            } else {
                newNumber = !this.options.autoHideDialCode || focusing ? newDialCode : "";
            }
            this._updateVal(newNumber, null, focusing);
        },
        // try and extract a valid international dial code from a full telephone number
        // Note: returns the raw string inc plus character and any whitespace/dots etc
        _getDialCode: function(number) {
            var dialCode = "";
            // only interested in international numbers (starting with a plus)
            if (number.charAt(0) == "+") {
                var numericChars = "";
                // iterate over chars
                for (var i = 0; i < number.length; i++) {
                    var c = number.charAt(i);
                    // if char is number
                    if (isNumeric(c)) {
                        numericChars += c;
                        // if current numericChars make a valid dial code
                        if (this.countryCodes[numericChars]) {
                            // store the actual raw string (useful for matching later)
                            dialCode = number.substr(0, i + 1);
                        }
                        // longest dial code is 4 chars
                        if (numericChars.length == 4) {
                            break;
                        }
                    }
                }
            }
            return dialCode;
        },
        /********************
   *  PUBLIC METHODS
   ********************/
        // this is called when the geoip call returns
        autoCountryLoaded: function() {
            if (this.options.defaultCountry == "auto") {
                this.options.defaultCountry = IntlTelInput.autoCountry;
                this._setInitialState();
                if ($) {
                    this.autoCountryDeferred.resolve();
                }
            }
        },
        // remove plugin
        destroy: function() {
            allInstances[this.id] = null;
            if (!this.isMobile) {
                // make sure the dropdown is closed (and unbind listeners)
                this._closeDropdown();
            }
            removeEventListener(this.element, "paste", this._eventListeners.onElementCutOrPaste);
            removeEventListener(this.element, "cut", this._eventListeners.onElementCutOrPaste);
            removeEventListener(this.element, "keyup", this._eventListeners.onElementKeyup);
            // key events, and focus/blur events if autoHideDialCode=true
            if (this.options.autoHideDialCode || this.options.autoFormat) {
                var element = this.element;
                removeEventListener(element, "focus", this._eventListeners.onElementFocused);
                removeEventListener(element, "blur", this._eventListeners.onElementBlurred);
                forEach(this._eventListeners.plusPressedListeners, function(listener) {
                    removeEventListener(element, "keypress", listener);
                });
                this._eventListeners.plusPressedListeners = [];
            }
            if (this.options.autoHideDialCode) {
                removeEventListener(this.element, "mousedown", this._eventListeners.onElementMousedown);
            }
            if (this.options.autoFormat) {
                removeEventListener(this.element, "keypress", this._eventListeners.onElementKeypress);
            }
            if (this.isMobile) {
                // change event on select country
                removeEventListener(this.countryList, "change", this._eventListeners.onMobileCountryListChange);
            } else {
                // label click hack
                var label = getClosest(this.element, "label");
                // click event to open dropdown
                removeEventListener(this.flagsContainer, "keydown", this._eventListeners.onFlagKeydown);
                removeEventListener(this.selectedFlag, "click", this.onSelectedFlagClicked);
                if (label) {
                    removeEventListener(label, "click", this._eventListeners.onLabelClicked);
                }
            }
            // remove markup
            var container = this.element.parentNode;
            if (container.parentNode) {
                container.parentNode.insertBefore(this.element, container);
                container.parentNode.removeChild(container);
            } else {
                // Surprisingly, jQuery does something similar, but more complicated
                var fakeWrapper = document.createElement("div");
                fakeWrapper.appendChild(this.element);
            }
        },
        // extract the phone number extension if present
        getExtension: function() {
            return this.element.value.split(" ext. ")[1] || "";
        },
        // format the number to the given type
        getNumber: function(type) {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.formatNumberByType(this.element.value, this.selectedCountryData.iso2, type);
            }
            return "";
        },
        // get the type of the entered number e.g. landline/mobile
        getNumberType: function() {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.getNumberType(this.element.value, this.selectedCountryData.iso2);
            }
            return -99;
        },
        // get the country data for the currently selected flag
        getSelectedCountryData: function() {
            // if this is undefined, the plugin will return it's instance instead, so in that case an empty object makes more sense
            return this.selectedCountryData || {};
        },
        // get the validation error
        getValidationError: function() {
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.getValidationError(this.element.value, this.selectedCountryData.iso2);
            }
            return -99;
        },
        // validate the input val - assumes the global function isValidNumber (from utilsScript)
        isValidNumber: function() {
            var val = trim(this.element.value), countryCode = this.options.nationalMode ? this.selectedCountryData.iso2 : "";
            if (window.intlTelInputUtils) {
                return intlTelInputUtils.isValidNumber(val, countryCode);
            }
            return false;
        },
        // load the utils script
        loadUtils: function(path) {
            var that = this;
            var utilsScript = path || this.options.utilsScript;
            if (!IntlTelInput.loadedUtilsScript && utilsScript) {
                // don't do this twice! (dont just check if the global intlTelInputUtils exists as if init plugin multiple times in quick succession, it may not have finished loading yet)
                IntlTelInput.loadedUtilsScript = true;
                var req = new XMLHttpRequest();
                if ($) {
                    req.onreadystatechange = function() {
                        // DONE state
                        if (req.readyState == 4) {
                            that.utilsScriptDeferred.resolve();
                        }
                    };
                }
                req.onload = function() {
                    if (req.status >= 200 && req.status < 400) {
                        var script = document.createElement("script");
                        script.innerHTML = req.responseText;
                        document.body.appendChild(script);
                        // tell all instances the utils are ready
                        forEach(allInstances, function(instance) {
                            if (instance) {
                                instance.utilsLoaded();
                            }
                        });
                    }
                };
                req.open("GET", utilsScript, true);
                req.setRequestHeader("Accept", "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript, */*; q=0.01");
                req.send();
            } else if ($) {
                this.utilsScriptDeferred.resolve();
            }
        },
        // update the selected flag, and update the input val accordingly
        selectCountry: function(countryCode) {
            countryCode = countryCode.toLowerCase();
            // check if already selected
            if (!hasClass(this.selectedFlagInner, countryCode)) {
                this._selectFlag(countryCode, true);
                this._updateDialCode(this.selectedCountryData.dialCode, false);
            }
        },
        // set the input value and update the flag
        setNumber: function(number, format, addSuffix, preventConversion, isAllowedKey) {
            // ensure starts with plus
            if (!this.options.nationalMode && number.charAt(0) != "+") {
                number = "+" + number;
            }
            // we must update the flag first, which updates this.selectedCountryData, which is used later for formatting the number before displaying it
            this._updateFlagFromNumber(number);
            this._updateVal(number, format, addSuffix, preventConversion, isAllowedKey);
        },
        // this is called when the utils are ready
        utilsLoaded: function() {
            // if autoFormat is enabled and there's an initial value in the input, then format it
            if (this.options.autoFormat && this.element.value) {
                this._updateVal(this.element.value);
            }
            this._updatePlaceholder();
        }
    };
    if ($) {
        // adapted to allow public functions
        // using https://github.com/jquery-boilerplate/jquery-boilerplate/wiki/Extending-jQuery-Boilerplate
        $.fn[pluginName] = function(options) {
            var args = arguments;
            // Is the first parameter an object (options), or was omitted,
            // instantiate a new instance of the plugin.
            if (options === undefined || typeof options === "object") {
                var deferreds = [];
                this.each(function() {
                    if (!$.data(this, "plugin_" + pluginName)) {
                        var instance = new Plugin(this, options);
                        var instanceDeferreds = instance._init();
                        // we now have 2 deffereds: 1 for auto country, 1 for utils script
                        deferreds.push(instanceDeferreds[0]);
                        deferreds.push(instanceDeferreds[1]);
                        $.data(this, "plugin_" + pluginName, instance);
                    }
                });
                // return the promise from the "master" deferred object that tracks all the others
                return $.when.apply(null, deferreds);
            } else if (typeof options === "string" && options[0] !== "_") {
                // If the first parameter is a string and it doesn't start
                // with an underscore or "contains" the `init`-function,
                // treat this as a call to a public method.
                // Cache the method call to make it possible to return a value
                var returns;
                this.each(function() {
                    var instance = $.data(this, "plugin_" + pluginName);
                    // Tests that there's already a plugin-instance
                    // and checks that the requested public method exists
                    if (instance instanceof Plugin && typeof instance[options] === "function") {
                        // Call the method of our plugin instance,
                        // and pass it the supplied arguments.
                        returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                    }
                    // Allow instances to be destroyed via the 'destroy' method
                    if (options === "destroy") {
                        $.data(this, "plugin_" + pluginName, null);
                    }
                });
                // If the earlier cached method gives a value back return the value,
                // otherwise return this to preserve chainability.
                return returns !== undefined ? returns : this;
            }
        };
        /********************
   *  STATIC METHODS
   ********************/
        // get the country data object
        $.fn[pluginName].getCountryData = IntlTelInput.getCountryData;
        $.fn[pluginName].version = IntlTelInput.version;
    }
    // Tell JSHint to ignore this warning: "character may get silently deleted by one or more browsers"
    // jshint -W100
    // Array of country objects for the flag dropdown.
    // Each contains a name, country code (ISO 3166-1 alpha-2) and dial code.
    // Originally from https://github.com/mledoze/countries
    // then modified using the following JavaScript (NOW OUT OF DATE):
    /*
var result = [];
_.each(countries, function(c) {
  // ignore countries without a dial code
  if (c.callingCode[0].length) {
    result.push({
      // var locals contains country names with localised versions in brackets
      n: _.findWhere(locals, {
        countryCode: c.cca2
      }).name,
      i: c.cca2.toLowerCase(),
      d: c.callingCode[0]
    });
  }
});
JSON.stringify(result);
*/
    // then with a couple of manual re-arrangements to be alphabetical
    // then changed Kazakhstan from +76 to +7
    // and Vatican City from +379 to +39 (see issue 50)
    // and Caribean Netherlands from +5997 to +599
    // and Curacao from +5999 to +599
    // Removed: Åland Islands, Christmas Island, Cocos Islands, Guernsey, Isle of Man, Jersey, Kosovo, Mayotte, Pitcairn Islands, South Georgia, Svalbard, Western Sahara
    // Update: converted objects to arrays to save bytes!
    // Update: added "priority" for countries with the same dialCode as others
    // Update: added array of area codes for countries with the same dialCode as others
    // So each country array has the following information:
    // [
    //    Country name,
    //    iso2 code,
    //    International dial code,
    //    Order (if >1 country with same dial code),
    //    Area codes (if >1 country with same dial code)
    // ]
    var allCountries = [ [ "Afghanistan (‫افغانستان‬‎)", "af", "93" ], [ "Albania (Shqipëri)", "al", "355" ], [ "Algeria (‫الجزائر‬‎)", "dz", "213" ], [ "American Samoa", "as", "1684" ], [ "Andorra", "ad", "376" ], [ "Angola", "ao", "244" ], [ "Anguilla", "ai", "1264" ], [ "Antigua and Barbuda", "ag", "1268" ], [ "Argentina", "ar", "54" ], [ "Armenia (Հայաստան)", "am", "374" ], [ "Aruba", "aw", "297" ], [ "Australia", "au", "61" ], [ "Austria (Österreich)", "at", "43" ], [ "Azerbaijan (Azərbaycan)", "az", "994" ], [ "Bahamas", "bs", "1242" ], [ "Bahrain (‫البحرين‬‎)", "bh", "973" ], [ "Bangladesh (বাংলাদেশ)", "bd", "880" ], [ "Barbados", "bb", "1246" ], [ "Belarus (Беларусь)", "by", "375" ], [ "Belgium (België)", "be", "32" ], [ "Belize", "bz", "501" ], [ "Benin (Bénin)", "bj", "229" ], [ "Bermuda", "bm", "1441" ], [ "Bhutan (འབྲུག)", "bt", "975" ], [ "Bolivia", "bo", "591" ], [ "Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387" ], [ "Botswana", "bw", "267" ], [ "Brazil (Brasil)", "br", "55" ], [ "British Indian Ocean Territory", "io", "246" ], [ "British Virgin Islands", "vg", "1284" ], [ "Brunei", "bn", "673" ], [ "Bulgaria (България)", "bg", "359" ], [ "Burkina Faso", "bf", "226" ], [ "Burundi (Uburundi)", "bi", "257" ], [ "Cambodia (កម្ពុជា)", "kh", "855" ], [ "Cameroon (Cameroun)", "cm", "237" ], [ "Canada", "ca", "1", 1, [ "204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905" ] ], [ "Cape Verde (Kabu Verdi)", "cv", "238" ], [ "Caribbean Netherlands", "bq", "599", 1 ], [ "Cayman Islands", "ky", "1345" ], [ "Central African Republic (République centrafricaine)", "cf", "236" ], [ "Chad (Tchad)", "td", "235" ], [ "Chile", "cl", "56" ], [ "China (中国)", "cn", "86" ], [ "Colombia", "co", "57" ], [ "Comoros (‫جزر القمر‬‎)", "km", "269" ], [ "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243" ], [ "Congo (Republic) (Congo-Brazzaville)", "cg", "242" ], [ "Cook Islands", "ck", "682" ], [ "Costa Rica", "cr", "506" ], [ "Côte d’Ivoire", "ci", "225" ], [ "Croatia (Hrvatska)", "hr", "385" ], [ "Cuba", "cu", "53" ], [ "Curaçao", "cw", "599", 0 ], [ "Cyprus (Κύπρος)", "cy", "357" ], [ "Czech Republic (Česká republika)", "cz", "420" ], [ "Denmark (Danmark)", "dk", "45" ], [ "Djibouti", "dj", "253" ], [ "Dominica", "dm", "1767" ], [ "Dominican Republic (República Dominicana)", "do", "1", 2, [ "809", "829", "849" ] ], [ "Ecuador", "ec", "593" ], [ "Egypt (‫مصر‬‎)", "eg", "20" ], [ "El Salvador", "sv", "503" ], [ "Equatorial Guinea (Guinea Ecuatorial)", "gq", "240" ], [ "Eritrea", "er", "291" ], [ "Estonia (Eesti)", "ee", "372" ], [ "Ethiopia", "et", "251" ], [ "Falkland Islands (Islas Malvinas)", "fk", "500" ], [ "Faroe Islands (Føroyar)", "fo", "298" ], [ "Fiji", "fj", "679" ], [ "Finland (Suomi)", "fi", "358" ], [ "France", "fr", "33" ], [ "French Guiana (Guyane française)", "gf", "594" ], [ "French Polynesia (Polynésie française)", "pf", "689" ], [ "Gabon", "ga", "241" ], [ "Gambia", "gm", "220" ], [ "Georgia (საქართველო)", "ge", "995" ], [ "Germany (Deutschland)", "de", "49" ], [ "Ghana (Gaana)", "gh", "233" ], [ "Gibraltar", "gi", "350" ], [ "Greece (Ελλάδα)", "gr", "30" ], [ "Greenland (Kalaallit Nunaat)", "gl", "299" ], [ "Grenada", "gd", "1473" ], [ "Guadeloupe", "gp", "590", 0 ], [ "Guam", "gu", "1671" ], [ "Guatemala", "gt", "502" ], [ "Guinea (Guinée)", "gn", "224" ], [ "Guinea-Bissau (Guiné Bissau)", "gw", "245" ], [ "Guyana", "gy", "592" ], [ "Haiti", "ht", "509" ], [ "Honduras", "hn", "504" ], [ "Hong Kong (香港)", "hk", "852" ], [ "Hungary (Magyarország)", "hu", "36" ], [ "Iceland (Ísland)", "is", "354" ], [ "India (भारत)", "in", "91" ], [ "Indonesia", "id", "62" ], [ "Iran (‫ایران‬‎)", "ir", "98" ], [ "Iraq (‫العراق‬‎)", "iq", "964" ], [ "Ireland", "ie", "353" ], [ "Israel (‫ישראל‬‎)", "il", "972" ], [ "Italy (Italia)", "it", "39", 0 ], [ "Jamaica", "jm", "1876" ], [ "Japan (日本)", "jp", "81" ], [ "Jordan (‫الأردن‬‎)", "jo", "962" ], [ "Kazakhstan (Казахстан)", "kz", "7", 1 ], [ "Kenya", "ke", "254" ], [ "Kiribati", "ki", "686" ], [ "Kuwait (‫الكويت‬‎)", "kw", "965" ], [ "Kyrgyzstan (Кыргызстан)", "kg", "996" ], [ "Laos (ລາວ)", "la", "856" ], [ "Latvia (Latvija)", "lv", "371" ], [ "Lebanon (‫لبنان‬‎)", "lb", "961" ], [ "Lesotho", "ls", "266" ], [ "Liberia", "lr", "231" ], [ "Libya (‫ليبيا‬‎)", "ly", "218" ], [ "Liechtenstein", "li", "423" ], [ "Lithuania (Lietuva)", "lt", "370" ], [ "Luxembourg", "lu", "352" ], [ "Macau (澳門)", "mo", "853" ], [ "Macedonia (FYROM) (Македонија)", "mk", "389" ], [ "Madagascar (Madagasikara)", "mg", "261" ], [ "Malawi", "mw", "265" ], [ "Malaysia", "my", "60" ], [ "Maldives", "mv", "960" ], [ "Mali", "ml", "223" ], [ "Malta", "mt", "356" ], [ "Marshall Islands", "mh", "692" ], [ "Martinique", "mq", "596" ], [ "Mauritania (‫موريتانيا‬‎)", "mr", "222" ], [ "Mauritius (Moris)", "mu", "230" ], [ "Mexico (México)", "mx", "52" ], [ "Micronesia", "fm", "691" ], [ "Moldova (Republica Moldova)", "md", "373" ], [ "Monaco", "mc", "377" ], [ "Mongolia (Монгол)", "mn", "976" ], [ "Montenegro (Crna Gora)", "me", "382" ], [ "Montserrat", "ms", "1664" ], [ "Morocco (‫المغرب‬‎)", "ma", "212" ], [ "Mozambique (Moçambique)", "mz", "258" ], [ "Myanmar (Burma) (မြန်မာ)", "mm", "95" ], [ "Namibia (Namibië)", "na", "264" ], [ "Nauru", "nr", "674" ], [ "Nepal (नेपाल)", "np", "977" ], [ "Netherlands (Nederland)", "nl", "31" ], [ "New Caledonia (Nouvelle-Calédonie)", "nc", "687" ], [ "New Zealand", "nz", "64" ], [ "Nicaragua", "ni", "505" ], [ "Niger (Nijar)", "ne", "227" ], [ "Nigeria", "ng", "234" ], [ "Niue", "nu", "683" ], [ "Norfolk Island", "nf", "672" ], [ "North Korea (조선 민주주의 인민 공화국)", "kp", "850" ], [ "Northern Mariana Islands", "mp", "1670" ], [ "Norway (Norge)", "no", "47" ], [ "Oman (‫عُمان‬‎)", "om", "968" ], [ "Pakistan (‫پاکستان‬‎)", "pk", "92" ], [ "Palau", "pw", "680" ], [ "Palestine (‫فلسطين‬‎)", "ps", "970" ], [ "Panama (Panamá)", "pa", "507" ], [ "Papua New Guinea", "pg", "675" ], [ "Paraguay", "py", "595" ], [ "Peru (Perú)", "pe", "51" ], [ "Philippines", "ph", "63" ], [ "Poland (Polska)", "pl", "48" ], [ "Portugal", "pt", "351" ], [ "Puerto Rico", "pr", "1", 3, [ "787", "939" ] ], [ "Qatar (‫قطر‬‎)", "qa", "974" ], [ "Réunion (La Réunion)", "re", "262" ], [ "Romania (România)", "ro", "40" ], [ "Russia (Россия)", "ru", "7", 0 ], [ "Rwanda", "rw", "250" ], [ "Saint Barthélemy (Saint-Barthélemy)", "bl", "590", 1 ], [ "Saint Helena", "sh", "290" ], [ "Saint Kitts and Nevis", "kn", "1869" ], [ "Saint Lucia", "lc", "1758" ], [ "Saint Martin (Saint-Martin (partie française))", "mf", "590", 2 ], [ "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508" ], [ "Saint Vincent and the Grenadines", "vc", "1784" ], [ "Samoa", "ws", "685" ], [ "San Marino", "sm", "378" ], [ "São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239" ], [ "Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966" ], [ "Senegal (Sénégal)", "sn", "221" ], [ "Serbia (Србија)", "rs", "381" ], [ "Seychelles", "sc", "248" ], [ "Sierra Leone", "sl", "232" ], [ "Singapore", "sg", "65" ], [ "Sint Maarten", "sx", "1721" ], [ "Slovakia (Slovensko)", "sk", "421" ], [ "Slovenia (Slovenija)", "si", "386" ], [ "Solomon Islands", "sb", "677" ], [ "Somalia (Soomaaliya)", "so", "252" ], [ "South Africa", "za", "27" ], [ "South Korea (대한민국)", "kr", "82" ], [ "South Sudan (‫جنوب السودان‬‎)", "ss", "211" ], [ "Spain (España)", "es", "34" ], [ "Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94" ], [ "Sudan (‫السودان‬‎)", "sd", "249" ], [ "Suriname", "sr", "597" ], [ "Swaziland", "sz", "268" ], [ "Sweden (Sverige)", "se", "46" ], [ "Switzerland (Schweiz)", "ch", "41" ], [ "Syria (‫سوريا‬‎)", "sy", "963" ], [ "Taiwan (台灣)", "tw", "886" ], [ "Tajikistan", "tj", "992" ], [ "Tanzania", "tz", "255" ], [ "Thailand (ไทย)", "th", "66" ], [ "Timor-Leste", "tl", "670" ], [ "Togo", "tg", "228" ], [ "Tokelau", "tk", "690" ], [ "Tonga", "to", "676" ], [ "Trinidad and Tobago", "tt", "1868" ], [ "Tunisia (‫تونس‬‎)", "tn", "216" ], [ "Turkey (Türkiye)", "tr", "90" ], [ "Turkmenistan", "tm", "993" ], [ "Turks and Caicos Islands", "tc", "1649" ], [ "Tuvalu", "tv", "688" ], [ "U.S. Virgin Islands", "vi", "1340" ], [ "Uganda", "ug", "256" ], [ "Ukraine (Україна)", "ua", "380" ], [ "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971" ], [ "United Kingdom", "gb", "44" ], [ "United States", "us", "1", 0 ], [ "Uruguay", "uy", "598" ], [ "Uzbekistan (Oʻzbekiston)", "uz", "998" ], [ "Vanuatu", "vu", "678" ], [ "Vatican City (Città del Vaticano)", "va", "39", 1 ], [ "Venezuela", "ve", "58" ], [ "Vietnam (Việt Nam)", "vn", "84" ], [ "Wallis and Futuna", "wf", "681" ], [ "Yemen (‫اليمن‬‎)", "ye", "967" ], [ "Zambia", "zm", "260" ], [ "Zimbabwe", "zw", "263" ] ];
    // loop over all of the countries above
    for (var i = 0; i < allCountries.length; i++) {
        var c = allCountries[i];
        allCountries[i] = {
            name: c[0],
            iso2: c[1],
            dialCode: c[2],
            priority: c[3] || 0,
            areaCodes: c[4] || null
        };
    }
    return IntlTelInput;
});


/***/ }),

/***/ 635:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 656:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-quill-editor/src/editor.vue


__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(660);
if (!window.Quill) {
  window.Quill = __webpack_require__(161);
}
/* harmony default export */ var editor = ({
  name: 'quill-editor',
  data: function data() {
    return {
      _content: '',
      defaultModules: {
        toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }], ['clean'], ['link', 'image', 'video']]
      }
    };
  },
  props: {
    content: String,
    value: String,
    disabled: Boolean,
    options: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    this.initialize();
  },
  beforeDestroy: function beforeDestroy() {
    this.quill = null;
  },
  methods: {
    initialize: function initialize() {
      if (this.$el) {
        var self = this;
        self.options.theme = self.options.theme || 'snow';
        self.options.boundary = self.options.boundary || document.body;
        self.options.modules = self.options.modules || self.defaultModules;
        self.options.modules.toolbar = self.options.modules.toolbar !== undefined ? self.options.modules.toolbar : self.defaultModules.toolbar;
        self.options.placeholder = self.options.placeholder || 'Insert text here ...';
        self.options.readOnly = self.options.readOnly !== undefined ? self.options.readOnly : false;
        self.quill = new Quill(self.$refs.editor, self.options);

        if (self.value || self.content) {
          self.quill.pasteHTML(self.value || self.content);
        }

        self.quill.on('selection-change', function (range) {
          if (!range) {
            self.$emit('blur', self.quill);
          } else {
            self.$emit('focus', self.quill);
          }
        });

        self.quill.on('text-change', function (delta, oldDelta, source) {
          var html = self.$refs.editor.children[0].innerHTML;
          var text = self.quill.getText();
          if (html === '<p><br></p>') html = '';
          self._content = html;
          self.$emit('input', self._content);
          self.$emit('change', {
            editor: self.quill,
            html: html,
            text: text
          });
        });

        if (this.disabled) {
          this.quill.enable(false);
        }

        self.$emit('ready', self.quill);
      }
    }
  },
  watch: {
    content: function content(newVal, oldVal) {
      if (this.quill) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quill.pasteHTML(newVal);
        } else if (!newVal) {
          this.quill.setText('');
        }
      }
    },
    value: function value(newVal, oldVal) {
      if (this.quill) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quill.pasteHTML(newVal);
        } else if (!newVal) {
          this.quill.setText('');
        }
      }
    },
    disabled: function disabled(newVal, oldVal) {
      if (this.quill) {
        this.quill.enable(!newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e60acc9c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-quill-editor/src/editor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quill-editor"},[_vm._t("toolbar"),_vm._v(" "),_c('div',{ref:"editor"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_editor = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-quill-editor/src/editor.vue
function injectStyle (ssrContext) {
  __webpack_require__(657)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  editor,
  src_editor,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_quill_editor_src_editor = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 657:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 658:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 223,
	"./af.js": 223,
	"./ar": 224,
	"./ar-dz": 225,
	"./ar-dz.js": 225,
	"./ar-kw": 226,
	"./ar-kw.js": 226,
	"./ar-ly": 227,
	"./ar-ly.js": 227,
	"./ar-ma": 228,
	"./ar-ma.js": 228,
	"./ar-sa": 229,
	"./ar-sa.js": 229,
	"./ar-tn": 230,
	"./ar-tn.js": 230,
	"./ar.js": 224,
	"./az": 231,
	"./az.js": 231,
	"./be": 232,
	"./be.js": 232,
	"./bg": 233,
	"./bg.js": 233,
	"./bn": 234,
	"./bn.js": 234,
	"./bo": 235,
	"./bo.js": 235,
	"./br": 236,
	"./br.js": 236,
	"./bs": 237,
	"./bs.js": 237,
	"./ca": 238,
	"./ca.js": 238,
	"./cs": 239,
	"./cs.js": 239,
	"./cv": 240,
	"./cv.js": 240,
	"./cy": 241,
	"./cy.js": 241,
	"./da": 242,
	"./da.js": 242,
	"./de": 243,
	"./de-at": 244,
	"./de-at.js": 244,
	"./de-ch": 245,
	"./de-ch.js": 245,
	"./de.js": 243,
	"./dv": 246,
	"./dv.js": 246,
	"./el": 247,
	"./el.js": 247,
	"./en-au": 248,
	"./en-au.js": 248,
	"./en-ca": 249,
	"./en-ca.js": 249,
	"./en-gb": 250,
	"./en-gb.js": 250,
	"./en-ie": 251,
	"./en-ie.js": 251,
	"./en-nz": 252,
	"./en-nz.js": 252,
	"./eo": 253,
	"./eo.js": 253,
	"./es": 254,
	"./es-do": 255,
	"./es-do.js": 255,
	"./es.js": 254,
	"./et": 256,
	"./et.js": 256,
	"./eu": 257,
	"./eu.js": 257,
	"./fa": 258,
	"./fa.js": 258,
	"./fi": 259,
	"./fi.js": 259,
	"./fo": 260,
	"./fo.js": 260,
	"./fr": 261,
	"./fr-ca": 262,
	"./fr-ca.js": 262,
	"./fr-ch": 263,
	"./fr-ch.js": 263,
	"./fr.js": 261,
	"./fy": 264,
	"./fy.js": 264,
	"./gd": 265,
	"./gd.js": 265,
	"./gl": 266,
	"./gl.js": 266,
	"./gom-latn": 267,
	"./gom-latn.js": 267,
	"./he": 268,
	"./he.js": 268,
	"./hi": 269,
	"./hi.js": 269,
	"./hr": 270,
	"./hr.js": 270,
	"./hu": 271,
	"./hu.js": 271,
	"./hy-am": 272,
	"./hy-am.js": 272,
	"./id": 273,
	"./id.js": 273,
	"./is": 274,
	"./is.js": 274,
	"./it": 275,
	"./it.js": 275,
	"./ja": 276,
	"./ja.js": 276,
	"./jv": 277,
	"./jv.js": 277,
	"./ka": 278,
	"./ka.js": 278,
	"./kk": 279,
	"./kk.js": 279,
	"./km": 280,
	"./km.js": 280,
	"./kn": 281,
	"./kn.js": 281,
	"./ko": 282,
	"./ko.js": 282,
	"./ky": 283,
	"./ky.js": 283,
	"./lb": 284,
	"./lb.js": 284,
	"./lo": 285,
	"./lo.js": 285,
	"./lt": 286,
	"./lt.js": 286,
	"./lv": 287,
	"./lv.js": 287,
	"./me": 288,
	"./me.js": 288,
	"./mi": 289,
	"./mi.js": 289,
	"./mk": 290,
	"./mk.js": 290,
	"./ml": 291,
	"./ml.js": 291,
	"./mr": 292,
	"./mr.js": 292,
	"./ms": 293,
	"./ms-my": 294,
	"./ms-my.js": 294,
	"./ms.js": 293,
	"./my": 295,
	"./my.js": 295,
	"./nb": 296,
	"./nb.js": 296,
	"./ne": 297,
	"./ne.js": 297,
	"./nl": 298,
	"./nl-be": 299,
	"./nl-be.js": 299,
	"./nl.js": 298,
	"./nn": 300,
	"./nn.js": 300,
	"./pa-in": 301,
	"./pa-in.js": 301,
	"./pl": 302,
	"./pl.js": 302,
	"./pt": 303,
	"./pt-br": 304,
	"./pt-br.js": 304,
	"./pt.js": 303,
	"./ro": 305,
	"./ro.js": 305,
	"./ru": 306,
	"./ru.js": 306,
	"./sd": 307,
	"./sd.js": 307,
	"./se": 308,
	"./se.js": 308,
	"./si": 309,
	"./si.js": 309,
	"./sk": 310,
	"./sk.js": 310,
	"./sl": 311,
	"./sl.js": 311,
	"./sq": 312,
	"./sq.js": 312,
	"./sr": 313,
	"./sr-cyrl": 314,
	"./sr-cyrl.js": 314,
	"./sr.js": 313,
	"./ss": 315,
	"./ss.js": 315,
	"./sv": 316,
	"./sv.js": 316,
	"./sw": 317,
	"./sw.js": 317,
	"./ta": 318,
	"./ta.js": 318,
	"./te": 319,
	"./te.js": 319,
	"./tet": 320,
	"./tet.js": 320,
	"./th": 321,
	"./th.js": 321,
	"./tl-ph": 322,
	"./tl-ph.js": 322,
	"./tlh": 323,
	"./tlh.js": 323,
	"./tr": 324,
	"./tr.js": 324,
	"./tzl": 325,
	"./tzl.js": 325,
	"./tzm": 326,
	"./tzm-latn": 327,
	"./tzm-latn.js": 327,
	"./tzm.js": 326,
	"./uk": 328,
	"./uk.js": 328,
	"./ur": 329,
	"./ur.js": 329,
	"./uz": 330,
	"./uz-latn": 331,
	"./uz-latn.js": 331,
	"./uz.js": 330,
	"./vi": 332,
	"./vi.js": 332,
	"./x-pseudo": 333,
	"./x-pseudo.js": 333,
	"./yo": 334,
	"./yo.js": 334,
	"./zh-cn": 335,
	"./zh-cn.js": 335,
	"./zh-hk": 336,
	"./zh-hk.js": 336,
	"./zh-tw": 337,
	"./zh-tw.js": 337
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

module.exports = {
	"accounts": {
		"bank": {
			"save": "Sauvegarder",
			"details": "Détail du possesseur du compte",
			"bank": "Informations bancaire",
			"kyc": "Vérification d'identité",
			"labels": {
				"first_name": "Prénom",
				"last_name": "Nom",
				"AddressLine1": "Rue",
				"PostalCode": "Code postal",
				"City": "Ville",
				"Region": "Région",
				"Country": "Pays",
				"iban": "IBAN",
				"bic": "BIC",
				"kyc": "Pièce d'identité ou passeport"
			},
			"kycStatus": {
				"CREATED": "En cours de validation",
				"REFUSED": "Refusé: {refused_reason_message}",
				"VALIDATED": "Validé",
				"VALIDATION_ASKED": "En cours de validation"
			}
		},
		"informations": {
			"save": "Sauvegarder",
			"address": "Mon adresse",
			"addressText": "Ces informations sont nécessaires pour la vérification de votre compte et pour la facturation",
			"additional": "Informations complémentaires",
			"additionalText": "Ces informations sont nécessaires pour valider votre compte",
			"labels": {
				"email": "Email",
				"first_name": "Prénom",
				"last_name": "Nom",
				"birthday": "Date de naissance",
				"phone": "Numéro de téléphone",
				"AddressLine1": "Rue",
				"PostalCode": "Code postal",
				"City": "Ville",
				"Region": "Région",
				"Country": "Pays",
				"nationality": "Nationalité",
				"country_of_residence": "Pays de résidence",
				"occupation": "Profession",
				"income_range": "Revenus",
				"password": "Nouveau mot de passe"
			}
		},
		"profile": {
			"save": "Sauvegarder",
			"valid": "Valider",
			"offer": "Offre en avant",
			"private": "[Privé]",
			"labels": {
				"cover": "Photo de couverture",
				"avatar": "Photo de profile",
				"jobTitle": "Métier",
				"nickname": "Nom affiché pour vos clients",
				"description": "Description",
				"keywords": "Mots-clefs relatifs à votre activité séparés par une virgule",
				"video": "Ajoutez une vidéo",
				"languages": "Mes langues parlées",
				"resume": "Résumé de votre profile",
				"offerId": "Offre en avant",
				"offerTitle": "Titre du bouton d'action",
				"offerSwitch": "Offre interne",
				"offerLink": "Lien de l'offre"
			}
		},
		"schedule": {
			"title": "Mes horaires de disponibilité téléphonique",
			"addTitle": "Ajouter un créneau",
			"add": "Ajouter un nouveau créneau",
			"addThis": "Ajouter ce créneau",
			"save": "Sauvegarder",
			"header": {
				"day": "Jour",
				"from": "De",
				"to": "À"
			},
			"labels": {
				"timezone": "Fuseau horaire"
			}
		}
	},
	"availabilities": {
		"exepertsperday": {
			"header": {
				"expert": "Expert"
			}
		},
		"expertsperweek": {
			"notAvailable": "Indisponible",
			"available": "Disponibilité maximum ({maxHour}h/24)",
			"header": {
				"expert": "Expert",
				"day": [
					"Dimanche",
					"Lundi",
					"Mardi",
					"Mercredi",
					"Jeudi",
					"Vendredi",
					"Samedi"
				],
				"total": "Total"
			}
		}
	},
	"charts": {
		"averageTime": {
			"label": "Moyenne de temps passé"
		},
		"gains": {
			"label": "Gains"
		},
		"newvsreturning": {
			"title": "Répartition des types d'offres",
			"returning": "Visiteurs récurrents",
			"new": "Nouveaux visiteurs"
		},
		"offerrevenue": {
			"label": "Revenus par offres",
			"mail": "Mail",
			"service": "Service",
			"prepaid_minute": "Forfait",
			"product": "Produit"
		},
		"offertyperevenue": {
			"title": "Répartition des types d'offres",
			"mail": "Mail",
			"service": "Service",
			"prepaid_minute": "Forfait",
			"product": "Produit",
			"availability": "Chat"
		},
		"purchases": {
			"label": "Revenus"
		},
		"sessions": {
			"label": "Nombre de visites"
		}
	},
	"dashboard": {
		"averagetimespent": {
			"title": "Temps moyen passé",
			"notActivated": "Vos statistiques ne sont pas encore activées"
		},
		"gains": {
			"title": "Sur le dernier mois"
		},
		"gainssum": {
			"title": "Total"
		},
		"newvsreturning": {
			"title": "Répartition",
			"notActivated": "Vos statistiques ne sont pas encore activées"
		},
		"offerrepartition": {
			"title": "Par offres"
		},
		"offertyperepartition": {
			"title": "Par type d'offre"
		},
		"purchases": {
			"title": "Sur le dernier mois"
		},
		"purchasessum": {
			"title": "Total"
		},
		"sessions": {
			"title": "Visites sur le dernier mois",
			"notActivated": "Vos statistiques ne sont pas encore activées"
		}
	},
	"expert": {
		"header": {
			"more": "Actions",
			"delete": "Supprimer cet expert",
			"connect": "Se connecter sur son compte",
			"confirmation": "Êtes vous sûr de vouloir supprimer cet expert ?",
			"profile": "Voir le profile"
		},
		"profile": {
			"none": "-",
			"subtitles": {
				"personal": "Informations personnelles",
				"contact": "Information de contact"
			},
			"item": {
				"nickname": "Pseudo",
				"firstName": "Prénom",
				"lastName": "Nom",
				"email": "Email",
				"phone": "Téléphone",
				"createdAt": "Rejoins le"
			}
		},
		"purchases": {
			"title": "Prestations terminées"
		},
		"schedule": {
			"title": "Horaires",
			"timezone": "Fuseau horaire",
			"header": {
				"day": "Jour",
				"from": "de",
				"to": "à"
			},
			"days": [
				"Dimanche",
				"Lundi",
				"Mardi",
				"Mercredi",
				"Jeudi",
				"Vendredi",
				"Samedi"
			]
		}
	},
	"formatters": {
		"errorcode": {
			"code": {
				"101001": "L'utilisateur ne termine pas la transaction",
				"101002": "La transaction a été annulée par l'utilisateur",
				"101101": "Transaction refusée par la banque (Ne pas honorer)",
				"101102": "Transaction refusée par la banque (Montant limite)",
				"101103": "Transaction refusée par le terminal",
				"101104": "Transaction refusée par la banque (limite de carte atteinte)",
				"101105": "La carte a expiré",
				"101106": "La carte est inactive",
				"101111": "Nombre maximum de tentatives atteintes",
				"101112": "Montant maximal dépassé",
				"101113": "Utilisations maximales dépassées",
				"101115": "Dépassement de la limite de débit",
				"101116": "Limite de quantité",
				"101199": "Transaction refusée",
				"101301": "Mode sécurisé: l'authentification 3DSecure a échoué",
				"101302": "Mode sécurisé: la carte n'est pas associée à 3DSecure",
				"101303": "Mode sécurisé: la carte n'est pas compatible avec 3DSecure",
				"101304": "Mode sécurisé: la session d'authentification 3DSecure a expiré",
				"101399": "Mode sécurisé: l'authentification 3DSecure n'est pas disponible",
				"101410": "La carte n'est pas active",
				"105101": "numéro de carte invalide",
				"105102": "Nom du titulaire de carte non valide",
				"105103": "Code PIN non valide",
				"105104": "Format de NIP incorrect",
				"105202": "Numéro de carte: format non valide",
				"105203": "Date d'expiration: format manquant ou non valide",
				"105204": "CVV: format manquant ou non valide",
				"105205": "URL de rappel: format non valide",
				"105206": "Données d'enregistrement: format non valide",
				"105299": "Erreur d'entrée de jeton",
				"001001": "Solde de portefeuille insuffisant",
				"001002": "L'auteur n'est pas le propriétaire du portefeuille",
				"001011": "Le montant de la transaction est supérieur au montant maximal autorisé",
				"001012": "Le montant de la transaction est inférieur au montant minimum autorisé",
				"001013": "Montant de transaction non valide",
				"001014": "CréditedFunds doit être plus de 0 (DebitedFunds ne peut pas égaler les frais)",
				"001030": "L'utilisateur n'a pas été redirigé",
				"001031": "L'utilisateur a annulé le paiement",
				"001032": "L'utilisateur remplit les détails de la carte de paiement",
				"001033": "L'utilisateur n'a pas été redirigé puis la session de paiement a expiré",
				"001034": "L'utilisateur a laissé la session de paiement expirer sans payer",
				"001401": "La transaction a déjà été remboursée avec succès",
				"001599": "Erreur de traitement de jeton",
				"01902": "Cette carte n'est pas active",
				"001999": "Erreur de fonctionnement générique",
				"02101": "Erreur interne",
				"02624": "Carte expirée",
				"02625": "numéro de carte invalide",
				"02626": "Date invalide. Utiliser le format mmdd",
				"02627": "Numéro CCV non valide",
				"02628": "Transaction refusée",
				"02631": "Délai dépassé",
				"02632": "Méthode GET n'est pas autorisée",
				"002998": "Bloqué en raison des limitations de KYC du titulaire du compte bancaire (montant maximum débité ou crédité atteint)",
				"002999": "Bloqué en raison des limitations de KYC d'un Débiteur (montant maximum débité ou crédité atteint)",
				"005403": "Le remboursement ne peut excéder le montant initial de la transaction",
				"005404": "Les frais remboursés ne peuvent dépasser le montant initial des frais",
				"005405": "Solde du portefeuille de frais du client insuffisant",
				"005407": "Duplicated operation: vous ne pouvez pas rembourser le même montant plus d'une fois pour une transaction le même jour",
				"008001": "Carte de contrefaçon",
				"008002": "Carte perdue",
				"008003": "Carte volée",
				"008004": "Bac à cartes non autorisé",
				"008005": "Violation de la sécurité",
				"008006": "Fraude soupçonnée par la banque",
				"008007": "Opposition sur compte bancaire (Temporaire)",
				"008500": "Transaction bloquée par la politique de fraude",
				"008600": "Wallet bloqué par la politique de fraude",
				"008700": "Utilisateur bloqué par la politique de fraude",
				"008999": "Erreur politique de fraude",
				"09101": "Nom d'utilisateur / mot de passe incorrect",
				"009101": "PSP timeout s'il vous plaît essayer tardr",
				"09102": "Le compte est verrouillé ou inactif",
				"009103": "Erreur de configuration PSP",
				"09104": "Le certificat client est désactivé",
				"009199": "Erreur technique de PSP",
				"09201": "Vous ne disposez pas des autorisations pour effectuer cette appel API",
				"009499": "Erreur technique de la banque",
				"009999": "Erreur technique"
			}
		},
		"minute": {
			"units": {
				"hour": "h",
				"minute": "min",
				"second": "sec"
			}
		}
	},
	"inputs": {
		"availabilitytype": {
			"types": {
				"chat": "Chat"
			}
		},
		"category": {
			"categories": {
				"accounting": "Comptabilité & Gestion",
				"achitecture": "Architecture & Design",
				"art": "Arts, Musique, Culture",
				"body_care": "Soin du corps & Remise en forme",
				"business": "Business & Finances",
				"coaching": "Coaching & Compétences",
				"consumer_goods": "Biens de consommation",
				"digital_economy": "Economie digitale",
				"divination": "Voyance",
				"economy": "Economie",
				"education": "Education & Emploi",
				"energy": "Energie & Environnement",
				"estate": "Immobilier",
				"fashion": "Modes & Tendances",
				"gardening": "Maison & Jardinage",
				"graphism": "Graphisme & Design",
				"handworker": "Artisanat",
				"hobbies": "Hobbies & Loisirs",
				"industry": "Industrie",
				"innovation": "Innovation, R&D",
				"insurance": "Assurance",
				"internet": "Internet",
				"low": "Droit",
				"managment": "Management",
				"marketing": "Marketing & Ventes",
				"media": "Media",
				"medical": "Médical",
				"personal_development": "Développement personnel",
				"resource_managment": "Organisation & RH",
				"restoration": "Restauration",
				"sciences": "Sciences & Technologies",
				"sport": "Sports",
				"strategy": "Stratégie & Transformation",
				"sustainability": "Développement durable",
				"tourism": "Voyage & Tourisme",
				"training": "Formation",
				"web_development": "Web Développement",
				"web_marketing": "Web Marketing",
				"wellness": "Bien-Etre & Santé"
			}
		},
		"date": {
			"cancel": "Annuler",
			"clear": "Supprimer"
		},
		"delay": {
			"ranges": {
				"hours": "Heure(s)",
				"days": "Jour(s)",
				"weeks": "Semaine(s)"
			}
		},
		"income": {
			"income": {
				"1": "inférieur à 18K€",
				"2": "supérieur 18K€ et inférieur 30K€",
				"3": "supérieur 30K€ et inférieur 50K€",
				"4": "supérieur 50K€ et inférieur 80K€",
				"5": "supérieur 80K€ et inférieur 120K€",
				"6": "supérieur à 120K€"
			}
		},
		"minute": {
			"minutes": "minute(s)"
		},
		"occupation": {
			"farmer": "Agriculteurs exploitants",
			"merchant": "Artisans, commerçants et chefs d’entreprise",
			"upper_manager": "Cadres et professions intellectuelles supérieures",
			"intermediate_profession": "Professions intermédiaires",
			"employees": "Employés",
			"worker": "Ouvriers",
			"retirees": "Retraités",
			"no_occupation": "Autres personnes sans activité professionnelle"
		},
		"offertype": {
			"types": {
				"promotion": "Offre promotionnelle",
				"private": "Offre privée",
				"public": "Offre publique"
			}
		},
		"phone": {
			"error": "Ce numéro n'est pas valide"
		},
		"portfolio": {
			"labels": {
				"picture": "Photo",
				"video": "Vidéo"
			},
			"video": {
				"text": "Vous pouvez ajouter une vidéo de Youtube ou Vimeo",
				"url": "Vidéo url",
				"button": "Ajouter"
			}
		},
		"services": {
			"services": {
				"tourism": "Téléconsultation",
				"remote": "Service à distance",
				"audit": "Audit, Conseil et Études",
				"course": "Cours, Formation, Orientation",
				"design": "Graphisme et Design",
				"development": "Développement Web",
				"documents": "Réalisation de documents",
				"other_service": "Consultation en cabinet",
				"receipe": "Recettes et régimes",
				"marketing": "Webmarketing",
				"advertising": "Publicité en ligne ",
				"other": "Autre"
			}
		},
		"servicetype": {
			"services": {
				"prepaid_minute": "Consultation par téléphone",
				"availability": "Consultation par chat",
				"mail": "Consultation par écrit",
				"service": "Services divers",
				"product": "Produit digital"
			}
		},
		"timezone": {
			"timezones": {
				"American Samoa": "(GMT-11:00) American Samoa",
				"International Date Line West": "(GMT-11:00) International Date Line West",
				"Midway Island": "(GMT-11:00) Midway Island",
				"Hawaii": "(GMT-10:00) Hawaii",
				"Alaska": "(GMT-09:00) Alaska",
				"Pacific Time (US & Canada)": "(GMT-08:00) Pacific Time (US & Canada)",
				"Tijuana": "(GMT-08:00) Tijuana",
				"Arizona": "(GMT-07:00) Arizona",
				"Chihuahua": "(GMT-07:00) Chihuahua",
				"Mazatlan": "(GMT-07:00) Mazatlan",
				"Mountain Time (US & Canada)": "(GMT-07:00) Mountain Time (US & Canada)",
				"Central America": "(GMT-06:00) Central America",
				"Central Time (US & Canada)": "(GMT-06:00) Central Time (US & Canada)",
				"Guadalajara": "(GMT-06:00) Guadalajara",
				"Mexico City": "(GMT-06:00) Mexico City",
				"Monterrey": "(GMT-06:00) Monterrey",
				"Saskatchewan": "(GMT-06:00) Saskatchewan",
				"Bogota": "(GMT-05:00) Bogota",
				"Eastern Time (US & Canada)": "(GMT-05:00) Eastern Time (US & Canada)",
				"Indiana (East)": "(GMT-05:00) Indiana (East)",
				"Lima": "(GMT-05:00) Lima",
				"Quito": "(GMT-05:00) Quito",
				"Atlantic Time (Canada)": "(GMT-04:00) Atlantic Time (Canada)",
				"Caracas": "(GMT-04:00) Caracas",
				"Georgetown": "(GMT-04:00) Georgetown",
				"La Paz": "(GMT-04:00) La Paz",
				"Santiago": "(GMT-04:00) Santiago",
				"Newfoundland": "(GMT-03:0-30) Newfoundland",
				"Brasilia": "(GMT-03:00) Brasilia",
				"Buenos Aires": "(GMT-03:00) Buenos Aires",
				"Greenland": "(GMT-03:00) Greenland",
				"Montevideo": "(GMT-03:00) Montevideo",
				"Mid-Atlantic": "(GMT-02:00) Mid-Atlantic",
				"Azores": "(GMT-01:00) Azores",
				"Cape Verde Is.": "(GMT-01:00) Cape Verde Is.",
				"Casablanca": "(GMT+00:00) Casablanca",
				"Dublin": "(GMT+00:00) Dublin",
				"Edinburgh": "(GMT+00:00) Edinburgh",
				"Lisbon": "(GMT+00:00) Lisbon",
				"London": "(GMT+00:00) London",
				"Monrovia": "(GMT+00:00) Monrovia",
				"UTC": "(GMT+00:00) UTC",
				"Amsterdam": "(GMT+01:00) Amsterdam",
				"Belgrade": "(GMT+01:00) Belgrade",
				"Berlin": "(GMT+01:00) Berlin",
				"Bern": "(GMT+01:00) Bern",
				"Bratislava": "(GMT+01:00) Bratislava",
				"Brussels": "(GMT+01:00) Brussels",
				"Budapest": "(GMT+01:00) Budapest",
				"Copenhagen": "(GMT+01:00) Copenhagen",
				"Ljubljana": "(GMT+01:00) Ljubljana",
				"Madrid": "(GMT+01:00) Madrid",
				"Paris": "(GMT+01:00) Paris",
				"Prague": "(GMT+01:00) Prague",
				"Rome": "(GMT+01:00) Rome",
				"Sarajevo": "(GMT+01:00) Sarajevo",
				"Skopje": "(GMT+01:00) Skopje",
				"Stockholm": "(GMT+01:00) Stockholm",
				"Vienna": "(GMT+01:00) Vienna",
				"Warsaw": "(GMT+01:00) Warsaw",
				"West Central Africa": "(GMT+01:00) West Central Africa",
				"Zagreb": "(GMT+01:00) Zagreb",
				"Athens": "(GMT+02:00) Athens",
				"Bucharest": "(GMT+02:00) Bucharest",
				"Cairo": "(GMT+02:00) Cairo",
				"Harare": "(GMT+02:00) Harare",
				"Helsinki": "(GMT+02:00) Helsinki",
				"Istanbul": "(GMT+02:00) Istanbul",
				"Jerusalem": "(GMT+02:00) Jerusalem",
				"Kyiv": "(GMT+02:00) Kyiv",
				"Pretoria": "(GMT+02:00) Pretoria",
				"Riga": "(GMT+02:00) Riga",
				"Sofia": "(GMT+02:00) Sofia",
				"Tallinn": "(GMT+02:00) Tallinn",
				"Vilnius": "(GMT+02:00) Vilnius",
				"Baghdad": "(GMT+03:00) Baghdad",
				"Kuwait": "(GMT+03:00) Kuwait",
				"Minsk": "(GMT+03:00) Minsk",
				"Moscow": "(GMT+03:00) Moscow",
				"Nairobi": "(GMT+03:00) Nairobi",
				"Riyadh": "(GMT+03:00) Riyadh",
				"St. Petersburg": "(GMT+03:00) St. Petersburg",
				"Volgograd": "(GMT+03:00) Volgograd",
				"Tehran": "(GMT+03:30) Tehran",
				"Abu Dhabi": "(GMT+04:00) Abu Dhabi",
				"Baku": "(GMT+04:00) Baku",
				"Muscat": "(GMT+04:00) Muscat",
				"Tbilisi": "(GMT+04:00) Tbilisi",
				"Yerevan": "(GMT+04:00) Yerevan",
				"Kabul": "(GMT+04:30) Kabul",
				"Ekaterinburg": "(GMT+05:00) Ekaterinburg",
				"Islamabad": "(GMT+05:00) Islamabad",
				"Karachi": "(GMT+05:00) Karachi",
				"Tashkent": "(GMT+05:00) Tashkent",
				"Chennai": "(GMT+05:30) Chennai",
				"Kolkata": "(GMT+05:30) Kolkata",
				"Mumbai": "(GMT+05:30) Mumbai",
				"New Delhi": "(GMT+05:30) New Delhi",
				"Sri Jayawardenepura": "(GMT+05:30) Sri Jayawardenepura",
				"Kathmandu": "(GMT+05:45) Kathmandu",
				"Almaty": "(GMT+06:00) Almaty",
				"Astana": "(GMT+06:00) Astana",
				"Dhaka": "(GMT+06:00) Dhaka",
				"Urumqi": "(GMT+06:00) Urumqi",
				"Rangoon": "(GMT+06:30) Rangoon",
				"Bangkok": "(GMT+07:00) Bangkok",
				"Hanoi": "(GMT+07:00) Hanoi",
				"Jakarta": "(GMT+07:00) Jakarta",
				"Krasnoyarsk": "(GMT+07:00) Krasnoyarsk",
				"Novosibirsk": "(GMT+07:00) Novosibirsk",
				"Beijing": "(GMT+08:00) Beijing",
				"Chongqing": "(GMT+08:00) Chongqing",
				"Hong Kong": "(GMT+08:00) Hong Kong",
				"Irkutsk": "(GMT+08:00) Irkutsk",
				"Kuala Lumpur": "(GMT+08:00) Kuala Lumpur",
				"Perth": "(GMT+08:00) Perth",
				"Singapore": "(GMT+08:00) Singapore",
				"Taipei": "(GMT+08:00) Taipei",
				"Ulaanbaatar": "(GMT+08:00) Ulaanbaatar",
				"Osaka": "(GMT+09:00) Osaka",
				"Sapporo": "(GMT+09:00) Sapporo",
				"Seoul": "(GMT+09:00) Seoul",
				"Tokyo": "(GMT+09:00) Tokyo",
				"Yakutsk": "(GMT+09:00) Yakutsk",
				"Adelaide": "(GMT+09:30) Adelaide",
				"Darwin": "(GMT+09:30) Darwin",
				"Brisbane": "(GMT+10:00) Brisbane",
				"Canberra": "(GMT+10:00) Canberra",
				"Guam": "(GMT+10:00) Guam",
				"Hobart": "(GMT+10:00) Hobart",
				"Melbourne": "(GMT+10:00) Melbourne",
				"Port Moresby": "(GMT+10:00) Port Moresby",
				"Sydney": "(GMT+10:00) Sydney",
				"Vladivostok": "(GMT+10:00) Vladivostok",
				"Magadan": "(GMT+11:00) Magadan",
				"New Caledonia": "(GMT+11:00) New Caledonia",
				"Solomon Is.": "(GMT+11:00) Solomon Is.",
				"Auckland": "(GMT+12:00) Auckland",
				"Fiji": "(GMT+12:00) Fiji",
				"Kamchatka": "(GMT+12:00) Kamchatka",
				"Marshall Is.": "(GMT+12:00) Marshall Is.",
				"Wellington": "(GMT+12:00) Wellington",
				"Chatham Is.": "(GMT+12:45) Chatham Is.",
				"Nuku'alofa": "(GMT+13:00) Nuku'alofa",
				"Samoa": "(GMT+13:00) Samoa",
				"Tokelau Is.": "(GMT+13:00) Tokelau Is."
			}
		},
		"weekday": {
			"wday": [
				"Dimanche",
				"Lundi",
				"Mardi",
				"Mercredi",
				"Jeudi",
				"Vendredi",
				"Samedi"
			]
		}
	},
	"messenger": {
		"more": "Charger plus",
		"actions": {
			"createappointment": {
				"next": "Suivant",
				"select": "Partager",
				"submit": "Partager",
				"title": {
					"default": "Proposer un rendez-vous",
					"day": "Jour",
					"hour": "Heure",
					"message": "Message"
				},
				"labels": {
					"day": "Jour du rendez-vous",
					"hour": "Heure du rendez-vous",
					"message": "Message"
				},
				"message": "Cliquez sur le lien ci-dessous pour accepter un rendez-vous avec {nickname}"
			},
			"fileupload": {
				"submit": "Envoyer",
				"title": "Envoyer un fichier",
				"labels": {
					"file": "Choisir mon fichier"
				}
			},
			"shareoffer": {
				"next": "Suivant",
				"select": "Partager",
				"submit": "Partager",
				"title": {
					"default": "Partage d'offre",
					"kind": "Type d'offre",
					"offer": "Offre",
					"message": "Message"
				},
				"labels": {
					"scope": "Type d'offre",
					"message": "Message"
				},
				"scopes": {
					"public": "Publiques",
					"promotion": "Promotions",
					"private": "Privées"
				}
			},
			"sharepage": {
				"next": "Suivant",
				"select": "Partager",
				"submit": "Partager",
				"title": {
					"default": "Partage d'une page",
					"kind": "Catégorie",
					"page": "Page",
					"message": "Message"
				},
				"labels": {
					"scope": "Catégorie",
					"message": "Message"
				}
			}
		},
		"previews": {
			"offer": {
				"action": "Voir"
			}
		},
		"conversations": {
			"title": "Envoyer un Message"
		},
		"menu": {
			"actions": {
				"upload": "Envoyer un fichier",
				"share": "Partager une offre",
				"page": "Partager une page",
				"appointment": "Envoyer un rendez-vous"
			}
		}
	},
	"purchase": {
		"availability": {
			"start": "Démarrer le chat",
			"stop": "Stop"
		},
		"appointment": {
			"accept": "Accepter le rendez-vous",
			"refund": "Annuler le rendez-vous"
		},
		"call": {
			"informations": "Informations sur l'appel",
			"none": "-",
			"starts": "Date d'appel",
			"pricePerMin": "Prix estimé par minute",
			"timeLimit": "Durée maximum d'appel",
			"duration": "Durée d'appel",
			"error": "Erreur survenue",
			"statusLabel": "Status de l'appel",
			"hangup": "Raccrocher",
			"hangupText": "Pour utiliser ce bouton assurez-vous que votre téléphone soit bien raccroché et que votre statut sur la plateforme soit toujours \"En consultation\"",
			"debug": "Détails",
			"callee": "Utilisateur",
			"caller": "Expert",
			"download": "Télécharger l'appel",
			"downloadStart": "Votre téléchargement va commencer, cela peut prendre quelques secondes avant que le téléchargement commence",
			"status": {
				"queued": "En cours d'appel",
				"ringing": "En cours d'appel",
				"no-answer": "Aucune réponse",
				"busy": "Occupé",
				"in-progress": "En cours",
				"completed": "Terminé",
				"failed": "Erreur",
				"canceled": "Annulé"
			}
		},
		"callplayer": {
			"title": "Écouter l'appel",
			"error": "Aucuns fichiers audio associés"
		},
		"mail": {
			"request": "Question :",
			"response": "Réponse :",
			"responseForm": "Votre réponse",
			"accept": "Accepter"
		},
		"messageform": {
			"save": "Répondre et terminer",
			"labels": {
				"title": "Titre",
				"content": "Réponse"
			}
		},
		"refund": {
			"refund": "Annuler et rembourser",
			"refundText": "En annulant cette prestation le client sera remboursé de son achat",
			"reason": "Describe a reason"
		},
		"service": {
			"request": "Demande :",
			"response": "Réponse :",
			"responseForm": "Votre réponse",
			"accept": "Accepter"
		},
		"table": {
			"noDataText": {
				"default": "Pas encore d'achats",
				"mail": "Pas encore d'emails",
				"service": "Pas encore de services",
				"phone": "Pas encore d'appels",
				"prepaid_minute": "Pas encore de forfaits",
				"availability": "Pas encore de chats",
				"product": "Pas encore de produit"
			},
			"noResultsText": {
				"default": "Aucuns achats",
				"mail": "Aucuns emails",
				"service": "Aucuns services",
				"phone": "Aucuns appels",
				"prepaid_minute": "Aucuns forfaits",
				"availability": "Aucuns chats",
				"product": "Auncuns produits"
			},
			"rowsPerPageText": {
				"default": "Achats par page",
				"mail": "Emails par page",
				"service": "Services par page",
				"phone": "Appels par page",
				"prepaid_minute": "Forfaits par page",
				"availability": "Chats par page",
				"product": "Produits par page"
			},
			"scopes": {
				"all": "",
				"payed": "payés",
				"refunded": "remboursés",
				"pending": "en attente",
				"current": "en cours",
				"finished": "terminés",
				"with_cash_received": "payés",
				"finished_with_cash_received_or_failed": "payés ou échoués"
			},
			"header": {
				"id": "Id",
				"offer": "Offre",
				"user": "Client",
				"expert": "Expert",
				"payedAt": "Date de paiement",
				"price": "Prix",
				"fees": "Frais",
				"total": "Total"
			}
		},
		"title": {
			"appointment": "Rendez-vous",
			"call": "Appel de",
			"perMin": "/min",
			"callStatus": {
				"in-progress": "Appel en cours",
				"no-answer": "Appel non répondu",
				"busy": "Appel avec correspondant occupé",
				"error": "Appel avec erreur : {error}",
				"failed": "Appel avec erreur : {error}",
				"canceled": "Appel annulé"
			}
		}
	},
	"service": {
		"actions": {
			"copy": "Lien copié",
			"edit": "Mettre à jour"
		},
		"form": {
			"save": "Sauvegarder",
			"delete": "Supprimer",
			"confirmDeletion": "Êtes-vous sûr ?",
			"errors": {
				"minutes": "Le tarif d'une minute doit être d'au moins {price} centimes par minutes"
			},
			"labels": {
				"experts": "Experts béneficiant de cette offre",
				"offerType": "Type d'offre",
				"serviceType": "Type d'offre",
				"title": "Titre de votre offre",
				"price": "Prix de l'offre",
				"service--serviceType": "Type de service",
				"service--responseDelay": "Délais de réponse",
				"prepaidMinute--minutes": "Nombre de minutes",
				"product--message": "Message après l'achat de votre produit",
				"mail--responseDelay": "Délais de réponse",
				"mail--wordCount": "Nombre de mots minimum",
				"availability--duration": "Durée",
				"availability--availabilityType": "Type de disponibilité",
				"description": "Description de l'offre",
				"portfolio": "Portfolio",
				"subtitle": "Sous titre de l'offre (utile pour le partage)",
				"picture": "Image de partage",
				"shortDescription": "Courte description de l'offre",
				"keywords": "Mot clés (séparés par une virgule)",
				"expire": "Date d'expiration",
				"maxUserPurchase": "Nombre d'achats maximum par utilisateur (0 = illimité)"
			}
		},
		"meta": {
			"prepaid_minute": "Forfait",
			"mail": "Mail",
			"service": "Service",
			"phone": "Appel",
			"product": "Produit",
			"availability": "Chat",
			"services": {
				"advertising": "Publicité en ligne ",
				"audit": "Audit, Conseil et Études",
				"course": "Cours, Formation, Orientation",
				"design": "Graphisme et Design",
				"development": "Développement Web",
				"documents": "Réalisation de documents",
				"marketing": "Webmarketing",
				"other": "Autre",
				"other_service": "Consultation en cabinet",
				"receipe": "Recettes et régimes",
				"remote": "Service à distance",
				"tourism": "Téléconsultation"
			},
			"options": {
				"word_count": "{value} mot(s)",
				"hours": "{value} heure(s)",
				"minutes": "{value} minute(s)",
				"days": "{value} jour(s)",
				"service_type": "{value}",
				"duration": "{value} minute(s)",
				"availability_type": "{value}"
			}
		}
	},
	"user": {
		"import": {
			"labels": {
				"sendEmail": "Notifier l'utilisateur"
			},
			"save": "Importer"
		},
		"form": {
			"save": "Créer",
			"labels": {
				"email": "Email",
				"password": "Mot de passe",
				"passwordConfirmation": "Confirmation de mot de passe",
				"sendEmail": "Notifier l'utilisateur"
			}
		},
		"header": {
			"messenger": "Envoyer un message",
			"more": "Plus",
			"lock": "Bloquer",
			"unlock": "Débloquer",
			"risk": "Activer surveillance",
			"unrisk": "Désactiver surveillance",
			"minute_gift": "Offrir des minutes",
			"lockreason": "Raison du blockage",
			"unlockreason": "Raison du déblockage",
			"riskreason": "Raison de ce changement",
			"unriskreason": "Raison de ce changement"
		},
		"profile": {
			"save": "Sauvegarder mes notes",
			"none": "-",
			"note": "Notes sur l'utilisateur",
			"subtitles": {
				"personal": "Informations personnelles",
				"contact": "Information de contact",
				"other": "Autres informations",
				"activity": "Activité"
			},
			"item": {
				"nickname": "Pseudo",
				"firstName": "Prénom",
				"lastName": "Nom",
				"email": "Email",
				"phone": "Téléphone",
				"createdAt": "Compte créé",
				"lastConnection": "Dernière connection",
				"lockedAt": "Compte bloqué",
				"minutes": "Minutes restantes",
				"riskyAt": "Surveillance activée"
			}
		},
		"purchases": {
			"title": "Prestations terminées"
		},
		"search": {
			"submit": "Rechercher",
			"clear": "Supprimer",
			"labels": {
				"first_name_cont": "Prénom",
				"last_name_cont": "Nom",
				"nickname_cont": "Pseudo",
				"email_cont": "Email",
				"phone_cont": "Numéro de téléphone",
				"locked": "Uniquement utilisateurs bloqués",
				"risky_at": "Uniquement utilisateurs risqués"
			}
		},
		"statistics": {
			"rates": "Avis donnés",
			"ratesPending": "Avis en attente",
			"ratesAverage": "Moyenne d'avis",
			"purchasesTotal": "Achats",
			"purchasesAmount": "Total dépensé",
			"purchasesAverage": "Prix d'achat moyen",
			"purchaseHistory": "Historique d'achat"
		},
		"table": {
			"title": "Utilisateurs",
			"noDataText": "Pas encore d'utilisateurs",
			"noResultsText": "Aucuns utilisateurs",
			"rowsPerPageText": "Utilisateurs par page",
			"sendToAll": "Message pour tous",
			"send": "Envoyer un message",
			"selected": "utilisateur séléctionné | utilisateurs séléctionnés",
			"header": {
				"nickname": "Pseudo",
				"last_name": "Nom",
				"first_name": "Prénom",
				"email": "Email",
				"payed_purchases_sum": "Dépensé",
				"phone_seconds_available": "Minutes",
				"created_at": "Inscrit le",
				"current_sign_in_at": "Dernière connection"
			}
		}
	},
	"activities": {
		"type": {
			"LOCK": "{nickname} bloqué",
			"UNLOCK": "{nickname} débloqué",
			"RISKY": "{nickname} surveillé",
			"UNRISKY": "{nickname} non surveillé",
			"ALERT": "Alerte pour {nickname}",
			"MINUTES": "{nickname} a reçu {minutes} minutes",
			"REFUND": "Refund pour {nickname}"
		},
		"reason": {
			"ALERT": "{amount}{currency} en moins de {timeframe} jours"
		}
	},
	"applicationmenu": {
		"menu": {
			"dashboard": {
				"default": "Tableaux de bord",
				"todo": "Mes tâches",
				"revenues": "Revenus de la plateforme",
				"traffic": "Trafic de la plateforme",
				"availabilities": "Disponibilités",
				"gains": "Mes gains",
				"statistics": "Statistiques",
				"accounts": "Comptes"
			},
			"customers": "Clients",
			"messenger": "Envoyer un message",
			"purchases": "Ventes",
			"services": {
				"create": "Nouvelle offre",
				"default": "Offres",
				"public": "Publiques",
				"promotions": "Promotions",
				"private": "Privées"
			},
			"pages": {
				"default": "Contenus"
			},
			"feedbacks": {
				"default": "Avis",
				"pending": "En attente",
				"accepted": "Acceptés",
				"rejected": "Rejetés"
			},
			"settings": {
				"default": "Paramètres",
				"platform": "Profil",
				"account": "Informations",
				"schedule": "Horaires",
				"transfers": "Virements",
				"bank": "Bank",
				"subscription": "Abonnement",
				"team": "Équipe",
				"customization": "Personnalisation",
				"links": "Smart links"
			}
		}
	},
	"applicationtoolbar": {
		"edit": "Mon profil",
		"logout": "Se déconnecter",
		"pause": "Me mettre en pause",
		"finishPause": "Terminer ma pause",
		"resolveSubscription": "Régler mon abonnement"
	},
	"calltimeline": {
		"state": {
			"queued": "En attente",
			"ringing": "Sonnerie",
			"no-answer": "Pas de réponse",
			"busy": "Occupé",
			"completed": "Terminé",
			"failed": "Échoué",
			"in-progress": "Appel en cours"
		}
	},
	"cardform": {
		"title": "Ajouter une carte",
		"save": "Ajouter ma carte",
		"labels": {
			"number": "Numéro de carte",
			"month": "Mois",
			"year": "Année",
			"cvx": "Code de sécurité"
		}
	},
	"dateintervalpicker": {
		"dates": [
			"Du",
			"au"
		]
	},
	"feedbackactions": {
		"update": "Modifier",
		"comment": "Commenter",
		"accept": "Publier",
		"reject": "Rejeter",
		"cancel": "Annuler",
		"save": "Sauvegarder",
		"saveAndPublish": "Sauvegarder et publier"
	},
	"feedbackcontent": {
		"by": "Par :",
		"date": "Le :"
	},
	"feedbackform": {
		"labels": {
			"note": "Note",
			"content": "Contenu",
			"response": "Réponse"
		}
	},
	"headerform": {
		"title": "Ajouter un header",
		"or": "ou",
		"save": "Ajouter",
		"labels": {
			"picture": "Image de fond",
			"video": "Video de fond",
			"pictureForVideo": "Image pour la video",
			"title": "Titre",
			"subtitle": "Sous titre",
			"actionTitle": "Titre du bouton",
			"actionHref": "Lien du bouton"
		}
	},
	"headersform": {
		"title": "Headers de mon site",
		"addHeader": "Ajouter un header"
	},
	"invitationform": {
		"title": "Inviter un nouvel expert",
		"text": "Entrez ici l'adresse email de votre nouvel expert et celui-ci sera prévenu par email par lequel il pourra se connecter et rejoindre votre équipe",
		"submit": "Inviter",
		"labels": {
			"email": "Email",
			"password": "Mot de passe"
		},
		"hints": {
			"password": "Laisser vide pour envoyer une invitation"
		}
	},
	"linkcreation": {
		"title": "Titre",
		"url": "Url",
		"save": "Sauvegarder"
	},
	"minutegiftform": {
		"title": "Offrir des minutes d'appel",
		"card": "Prélever ma carte",
		"submit": "Offrir {minutes} minute(s) pour {price} EUR",
		"offer": "Offrir",
		"text": "Vous êtes sur le point d'offrir {minutes} minute(s) à {price} EUR/min",
		"labels": {
			"minutes": "Nombre de minutes",
			"reason": "Raison"
		}
	},
	"outcometable": {
		"header": {
			"id": "Id",
			"date": "Date de paiement",
			"status": "Status",
			"amount": "Prix"
		}
	},
	"refundedtag": {
		"refunded": "Annulé"
	},
	"sharecard": {
		"networks": {
			"facebook": "Facebook",
			"twitter": "Twitter",
			"googleplus": "Google +",
			"linkedin": "LinkedIn"
		}
	},
	"smartlink": {
		"title": "Titre",
		"url": "URL",
		"icon": "Icone",
		"add": "Ajouter",
		"save": "Sauvegarder"
	},
	"transfer": {
		"title": "Virement",
		"submit": "Virer cet argent",
		"missingText": "Vous n'avez pas encore renseigner vos informations bancaires",
		"addBank": "Mettre à jour",
		"text": "Virer mon argent sur mon compte {iban}",
		"hints": {
			"amount": "Maximum 2500€ par virement"
		},
		"labels": {
			"amount": "Montant du virement",
			"reference": "Référence"
		}
	},
	"transfertable": {
		"noDataText": "Pas encore de virements",
		"noResultsText": "Aucuns virements",
		"rowsPerPageText": "Virements par page",
		"header": {
			"date": "Date",
			"status": "État",
			"amount": "Prix"
		},
		"status": {
			"CREATED": "En attente",
			"FAILED": "Échoué",
			"SUCCEEDED": "Terminé"
		}
	},
	"usermenu": {
		"actions": "Actions",
		"sendToAll": "Message pour tous",
		"send": "Envoyer un message",
		"addUser": "Ajouter un utilisateur",
		"export": "Exporter les utilisateurs",
		"exportStarted": "Votre export est en cours, vous recevrez un email dès que l'export sera terminé",
		"import": "Importer des utilisateurs"
	},
	"wallet": {
		"title": "Argent disponible",
		"transfer": "Transférer"
	},
	"pages": {
		"accounting": {
			"title": "Comptes"
		},
		"account": {
			"tabs": {
				"profile": "Profil",
				"informations": "Numéro de Téléphone",
				"schedule": "Agenda",
				"bank": "Banque"
			}
		},
		"customization": {
			"style": "Configurer le style",
			"links": "Liens footer",
			"save": "Sauvegarder",
			"addLink": "Ajouter un lien",
			"labels": {
				"removePic": "Supprimer",
				"logo": "Logo de votre site",
				"favicon": "Favicon de votre site",
				"color": {
					"primary": "Couleur principale",
					"secondary": "Couleur secondaire"
				},
				"feedbacks": "Afficher les avis clients"
			}
		},
		"dashboard": {
			"title": {
				"default": "Mes tâches",
				"phone": "Appels",
				"mail": "Mails",
				"service": "Services",
				"availability": "Chat",
				"pending": "En attente",
				"current": "En cours"
			}
		},
		"expert": {
			"tabs": {
				"profile": "Profil",
				"schedule": "Horaires",
				"purchases": "Prestations",
				"connection": "Connexion"
			}
		},
		"expertgains": {
			"title": "Gains"
		},
		"feedbacks": {
			"empty": "Aucuns avis",
			"pending": "en attente",
			"accepted": "acceptés",
			"rejected": "rejetés"
		},
		"forgotpassword": {
			"title": "Mot de passe oublié",
			"reset": "Envoyer les instructions",
			"login": "Se connecter",
			"success": "Un mail vous a été envoyé",
			"labels": {
				"email": "Email",
				"platformName": "Url de votre plateforme"
			}
		},
		"invitation": {
			"title": "Accepter votre invitation",
			"submit": "Accepter",
			"terms": "Conditions d'utilisation",
			"privacy": "Politique de confidentialité",
			"labels": {
				"password": "Mot de passe",
				"confirmation": "Confirmation de mot de passe",
				"terms": "Accepter les CGU et la Politique de confidentialité"
			}
		},
		"login": {
			"title": "Se connecter",
			"login": "Se connecter",
			"forgotPassword": "Mot de passe oublié",
			"labels": {
				"email": "Email",
				"password": "Mot de passe",
				"platformName": "Url"
			}
		},
		"messengerwelcome": {
			"select": "Veuillez sélectionner une conversation"
		},
		"notfound": {
			"title": "404",
			"text": "Page inexistante"
		},
		"platformrevenues": {
			"title": "Chiffre d'affaire"
		},
		"platformtraffic": {
			"title": "Informations du site"
		},
		"purchases": {
			"title": "Achats"
		},
		"resetpassword": {
			"title": "Changer mon mot de passer",
			"submit": "Changer mon mot de passe",
			"login": "Se connecter",
			"passwordTokenError": "Votre code n'est pas bon, veuillez renvoyer un nouvel email",
			"forgot": "Renvoyer l'email",
			"labels": {
				"password": "Nouveau mot de passe",
				"confirmation": "Confirmation du mot de passe"
			}
		},
		"servicecreation": {
			"title": "Création d'une offre"
		},
		"serviceedition": {
			"title": "Edition - {title}"
		},
		"setup": {
			"title": "Mes informations",
			"submit": "Sauvegarde",
			"labels": {
				"category": "Catégorie",
				"firstName": "Prénom",
				"lastName": "Nom",
				"birthday": "Date de naissance",
				"phone": "Numéro de téléphone"
			}
		},
		"statistics": {
			"title": "Statistiques",
			"expert": "Expert",
			"sum": "Total de minutes",
			"total": "Total d'appels",
			"average": "Temps moyen",
			"minMax": "Temps min / max",
			"price_minute": "Prix par minute",
			"price_average": "Prix d'achat moyen",
			"collector": "Argent du collector",
			"call": "Appels",
			"email": "Emails",
			"chat": "Chats",
			"service": "Services",
			"product": "Produits",
			"gains": "Gains"
		},
		"subscription": {
			"title": "Mon abonnement",
			"current": "Plan actuel",
			"next": "Prochain paiement",
			"card": "Ma carte de prélèvement",
			"noCard": "Vous n'avez pas de cartes pour votre prélèvement",
			"cardDetails": "Vous utilisez la carte {alias} qui expire le {month}/{year}",
			"updateCard": "Mettre à jour ma carte"
		},
		"subscriptionpayment": {
			"pay": "Payer mon abonnement",
			"inProgress": "Paiement en cours"
		},
		"team": {
			"title": "Mon équipe",
			"noDataText": "Pas encore d'experts",
			"noResultsText": "Aucuns experts trouvé",
			"header": {
				"nickname": "Pseudo",
				"email": "Email",
				"role": "Status",
				"actions": "Classement"
			},
			"roles": {
				"active": "Actif",
				"inactive": "Inactif",
				"restricted": "Restreint"
			}
		},
		"teamavailabilities": {
			"title": "Disponibilité de l'équipe",
			"today": "Total aujourd'hui",
			"average": "Moyenne par expert",
			"max": "Maximum par expert",
			"perWeek": "Semaine",
			"perDay": "Jour",
			"days": [
				"Dimanche",
				"Lundi",
				"Mardi",
				"Mercredi",
				"Jeudi",
				"Vendredi",
				"Samedi"
			]
		},
		"transfers": {
			"title": "Mes transferts"
		},
		"user": {
			"tabs": {
				"profile": "Profil",
				"statistics": "Statistiques",
				"purchases": "Prestations"
			}
		},
		"users": {
			"title": "Utilisateurs",
			"selected": "utilisateur séléctionné | utilisateurs séléctionnés",
			"search": "Rechercher"
		}
	}
};

/***/ }),

/***/ 745:
/***/ (function(module, exports) {

module.exports = {
	"accounts": {
		"bank": {
			"bank": "banking information",
			"details": "Detail of the account holder",
			"kyc": "Identity verification",
			"kycStatus": {
				"CREATED": "Ongoing validation",
				"REFUSED": "Denied: {refused_reason_message}",
				"VALIDATED": "Valid",
				"VALIDATION_ASKED": "Ongoing validation"
			},
			"labels": {
				"AddressLine1": "Street",
				"City": "City",
				"Country": "Country",
				"PostalCode": "Postal code",
				"Region": "Region",
				"bic": "BIC",
				"first_name": "First name",
				"iban": "IBAN",
				"kyc": "ID or passport",
				"last_name": "Last name"
			},
			"save": "Save"
		},
		"informations": {
			"additional": "Further information",
			"additionalText": "This information is required to validate your account",
			"address": "My address",
			"addressText": "This information is needed to verify your account and billing",
			"labels": {
				"AddressLine1": "Street",
				"City": "City",
				"Country": "Country",
				"PostalCode": "Postal code",
				"Region": "Region",
				"birthday": "Date of Birth",
				"country_of_residence": "country of residence",
				"email": "E-mail",
				"first_name": "First name",
				"income_range": "earnings",
				"last_name": "Last name",
				"nationality": "Nationality",
				"occupation": "Profession",
				"phone": "Phone number",
				"password": "New password"
			},
			"save": "Save"
		},
		"profile": {
			"labels": {
				"avatar": "Profile Photo",
				"cover": "Cover picture",
				"description": "Description",
				"jobTitle": "Job",
				"keywords": "Keywords related to your activity separated by commas",
				"languages": "My languages",
				"nickname": "Display name for clients",
				"offerId": "Front Offer",
				"offerTitle": "Title of the action button",
				"offerSwitch": "Internal offer",
				"offerLink": "Link of the offer",
				"resume": "Summary of Your Profile",
				"video": "Add a video"
			},
			"offer": "Front Offer",
			"private": "[Private]",
			"save": "Save",
			"valid": "Validate"
		},
		"schedule": {
			"add": "Add a new niche",
			"addThis": "Add this niche",
			"addTitle": "Add a niche",
			"header": {
				"day": "Day",
				"from": "Of",
				"to": "AT"
			},
			"labels": {
				"timezone": "Time zone"
			},
			"save": "Save",
			"title": "My schedules telephone availability"
		}
	},
	"activities": {
		"reason": {
			"ALERT": "{amount} {currency} within {timeframe} days"
		},
		"type": {
			"ALERT": "Alert for {nickname}",
			"LOCK": "{nickname} blocked",
			"MINUTES": "{nickname} received {minutes} minutes",
			"REFUND": "Refund for {nickname}",
			"RISKY": "{nickname} monitored",
			"UNLOCK": "{nickname} unlocked",
			"UNRISKY": "{nickname} unguarded"
		}
	},
	"applicationmenu": {
		"menu": {
			"customers": "Clients",
			"dashboard": {
				"accounts": "Accounts",
				"availabilities": "availability",
				"default": "Dashboards",
				"gains": "my earnings",
				"revenues": "Income Platform",
				"statistics": "Statistics",
				"todo": "My tasks",
				"traffic": "Traffic Platform"
			},
			"feedbacks": {
				"accepted": "accepted",
				"default": "view",
				"pending": "Waiting",
				"rejected": "rejected"
			},
			"messenger": "Send a message",
			"pages": {
				"default": "contents"
			},
			"purchases": "Sales",
			"services": {
				"create": "new offer",
				"default": "Offers",
				"private": "private",
				"promotions": "Specials",
				"public": "public"
			},
			"settings": {
				"account": "information",
				"bank": "Bank",
				"customization": "personalization",
				"default": "Settings",
				"links": "Smart links",
				"platform": "Profile",
				"schedule": "Hours",
				"subscription": "Subscription",
				"team": "Team",
				"transfers": "transfers"
			}
		}
	},
	"applicationtoolbar": {
		"edit": "My profile",
		"finishPause": "Finish my break",
		"logout": "Sign out",
		"pause": "I pause",
		"resolveSubscription": "Set my subscription"
	},
	"availabilities": {
		"exepertsperday": {
			"header": {
				"expert": "Expert"
			}
		},
		"expertsperweek": {
			"available": "Maximum Availability ({maxHour} h / 24)",
			"header": {
				"day": [
					"Sunday",
					"On Monday",
					"Tuesday",
					"Wednesday",
					"Thursday",
					"Friday",
					"Saturday"
				],
				"expert": "Expert",
				"total": "Total"
			},
			"notAvailable": "Unavailable"
		}
	},
	"calltimeline": {
		"state": {
			"busy": "Busy",
			"completed": "Finished",
			"failed": "Failed",
			"in-progress": "Call in progress",
			"no-answer": "No answer",
			"queued": "Waiting",
			"ringing": "Alarm"
		}
	},
	"cardform": {
		"labels": {
			"cvx": "security code",
			"month": "Month",
			"number": "Card number",
			"year": "Year"
		},
		"save": "Add my card",
		"title": "Add a map"
	},
	"charts": {
		"averageTime": {
			"label": "Average time spent"
		},
		"gains": {
			"label": "Earnings"
		},
		"newvsreturning": {
			"new": "new visitors",
			"returning": "repeat visitors",
			"title": "Distribution of types of offers"
		},
		"offerrevenue": {
			"label": "Revenue deals",
			"mail": "Mail",
			"prepaid_minute": "Flat rate",
			"product": "Product",
			"service": "Service"
		},
		"offertyperevenue": {
			"availability": "Cat",
			"mail": "Mail",
			"prepaid_minute": "Flat rate",
			"product": "Product",
			"service": "Service",
			"title": "Distribution of types of offers"
		},
		"purchases": {
			"label": "earnings"
		},
		"sessions": {
			"label": "Number of visits"
		}
	},
	"dashboard": {
		"averagetimespent": {
			"notActivated": "Your statistics are not yet activated",
			"title": "Average time spent"
		},
		"gains": {
			"title": "In the last month"
		},
		"gainssum": {
			"title": "Total"
		},
		"newvsreturning": {
			"notActivated": "Your statistics are not yet activated",
			"title": "Division"
		},
		"offerrepartition": {
			"title": "For deals"
		},
		"offertyperepartition": {
			"title": "By type of offer"
		},
		"purchases": {
			"title": "In the last month"
		},
		"purchasessum": {
			"title": "Total"
		},
		"sessions": {
			"notActivated": "Your statistics are not yet activated",
			"title": "Visits last month"
		}
	},
	"dateintervalpicker": {
		"dates": [
			"Of",
			"at"
		]
	},
	"expert": {
		"header": {
			"confirmation": "Are you sure you want to delete this expert?",
			"connect": "Log into account",
			"delete": "Remove This expert",
			"more": "stock",
			"profile": "View profile"
		},
		"profile": {
			"item": {
				"createdAt": "Join the",
				"email": "E-mail",
				"firstName": "First name",
				"lastName": "Last name",
				"nickname": "Pseudo",
				"phone": "Phone"
			},
			"none": "-",
			"subtitles": {
				"contact": "Contact information",
				"personal": "Personal informations"
			}
		},
		"purchases": {
			"title": "completed services"
		},
		"schedule": {
			"days": [
				"Sunday",
				"On Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			],
			"header": {
				"day": "Day",
				"from": "of",
				"to": "at"
			},
			"timezone": "Time zone",
			"title": "Hours"
		}
	},
	"feedbackactions": {
		"accept": "Publish",
		"cancel": "To cancel",
		"comment": "Comment",
		"reject": "To reject",
		"save": "Save",
		"saveAndPublish": "Save and publish",
		"update": "Edit"
	},
	"feedbackcontent": {
		"by": "Through :",
		"date": "The :"
	},
	"feedbackform": {
		"labels": {
			"content": "contents",
			"note": "Note",
			"response": "Reply"
		}
	},
	"formatters": {
		"errorcode": {
			"code": {
				"101001": "The user does not complete the transaction",
				"101002": "The transaction was canceled by the user",
				"101101": "Transaction refused by the bank (not honor)",
				"101102": "Transaction refused by the bank (Amount limit)",
				"101103": "Transaction refused by the terminal",
				"101104": "Transaction refused by the bank (card limit reached)",
				"101105": "the card expired",
				"101106": "The card is inactive",
				"101111": "Maximum number of attempts reached",
				"101112": "Maximum amount exceeded",
				"101113": "exceeded maximum use",
				"101115": "Exceeding the speed limit",
				"101116": "Quantity limits",
				"101199": "transaction refused",
				"101301": "Secure mode: authentication failed 3DSecure",
				"101302": "Secure mode: the map is not associated with 3DSecure",
				"101303": "Secure mode: the card is not compatible with 3DSecure",
				"101304": "Secure mode: the authentication session expired 3DSecure",
				"101399": "Secure mode: authentication 3DSecure unavailable",
				"101410": "The card is not active",
				"105101": "Invalid card number",
				"105102": "Name of cardholder not valid",
				"105103": "Invalid PIN",
				"105104": "PIN format incorrect",
				"105202": "Card Number: invalid format",
				"105203": "Expiry date: missing or invalid format",
				"105204": "CVV: missing or invalid format",
				"105205": "callback URL: invalid format",
				"105206": "Recording information: invalid format",
				"105299": "token input error",
				"001001": "Insufficient Wallet Balance",
				"001002": "The author is not the owner of the wallet",
				"001011": "The transaction amount is greater than the maximum allowed",
				"001012": "The transaction amount is below the minimum amount allowed",
				"001013": "Invalid transaction amount",
				"001014": "CréditedFunds must be more than 0 (DebitedFunds can not match the costs)",
				"001030": "The user was not redirected",
				"001031": "User canceled payment",
				"001032": "The user fills in the details of the payment card",
				"001033": "The user has not been redirected then the payment session has expired",
				"001034": "The user has left the payment session expire without pay",
				"001401": "The transaction has already been paid successfully",
				"001599": "Token Processing Error",
				"001999": "Generic operation error",
				"002998": "Blocked due to limitations of the KYC bank account holder (maximum amount debited or credited reached)",
				"002999": "Blocked due to limitations of KYC of a Debtor (maximum amount debited or credited reached)",
				"005403": "The refund can not exceed the original amount of the transaction",
				"005404": "The reimbursed costs may not exceed the original amount of costs",
				"005405": "Insufficient customer expense of portfolio balance",
				"005407": "Duplicated operation: you can not repay the amount mê ... more than once for a transaction on the same day",
				"008001": "counterfeit card",
				"008002": "lost card",
				"008003": "stolen card",
				"008004": "unauthorized subrack",
				"008005": "Security breach",
				"008006": "Fraud suspected by the bank",
				"008007": "Opposition on bank account (Temporary)",
				"008500": "Transaction blocked by fraud policy",
				"008600": "Wallet blocked fraud policy",
				"008700": "Blocked by fraud policy",
				"008999": "fraud policy error",
				"009101": "PSP timeout please try tardr",
				"009103": "PSP configuration error",
				"009199": "Technical error PSP",
				"009499": "technical bank error",
				"009999": "technical error",
				"01902": "This card is not active",
				"02101": "internal error",
				"02624": "expired card",
				"02625": "Invalid card number",
				"02626": "Date invalid. Use mmdd size",
				"02627": "Invalid CCV number",
				"02628": "transaction refused",
				"02631": "Timeout",
				"02632": "GET method is not allowed",
				"09101": "Username / password incorrect",
				"09102": "The account is locked or inactive",
				"09104": "The client certificate is disabled",
				"09201": "You do not have permissions to make this API call"
			}
		},
		"minute": {
			"units": {
				"hour": "h",
				"minute": "min",
				"second": "dry"
			}
		}
	},
	"headerform": {
		"labels": {
			"actionHref": "Link button",
			"actionTitle": "Button title",
			"picture": "Background picture",
			"pictureForVideo": "Image to video",
			"subtitle": "Subtitle",
			"title": "title",
			"video": "Background Video"
		},
		"or": "or",
		"save": "Add",
		"title": "Add header"
	},
	"headersform": {
		"addHeader": "Add header",
		"title": "Headers of my site"
	},
	"inputs": {
		"availabilitytype": {
			"types": {
				"chat": "Cat"
			}
		},
		"category": {
			"categories": {
				"accounting": "Management Accounting",
				"achitecture": "Architecture & Design",
				"art": "Arts, Music, Culture",
				"body_care": "Body Care & Fitness",
				"business": "Business & Finance",
				"coaching": "Coaching & Skills",
				"consumer_goods": "Consumer goods",
				"digital_economy": "digital Economy",
				"divination": "Fortune telling",
				"economy": "Economy",
				"education": "Education & Employment",
				"energy": "Energy & Environment",
				"estate": "Immovable",
				"fashion": "Methods & Trends",
				"gardening": "Home & Gardening",
				"graphism": "Graphics & Design",
				"handworker": "Arts and crafts",
				"hobbies": "Hobbies and Interests",
				"industry": "Industry",
				"innovation": "Innovation, R & D",
				"insurance": "Insurance",
				"internet": "Internet",
				"low": "Law",
				"managment": "Management",
				"marketing": "Marketing & Sales",
				"media": "Media",
				"medical": "Medical",
				"personal_development": "Personal development",
				"resource_managment": "HR & Organization",
				"restoration": "Restoration",
				"sciences": "Science & Technology",
				"sport": "Sports",
				"strategy": "Strategy & Transformation",
				"sustainability": "Sustainable development",
				"tourism": "Travel & Tourism",
				"training": "Training",
				"web_development": "Web Development",
				"web_marketing": "Web marketing",
				"wellness": "Wellness & Health"
			}
		},
		"date": {
			"cancel": "To cancel",
			"clear": "Remove"
		},
		"delay": {
			"ranges": {
				"days": "Days)",
				"hours": "Hour (s)",
				"weeks": "Week (s)"
			}
		},
		"income": {
			"income": {
				"1": "less than 18K €",
				"2": "upper and lower 18K € 30K €",
				"3": "upper and lower 30K € 50K €",
				"4": "upper and lower 50K € 80K €",
				"5": "top € 80K and € 120K less",
				"6": "greater than 120K €"
			}
		},
		"minute": {
			"minutes": "minutes)"
		},
		"occupation": {
			"employees": "employees",
			"farmer": "operators farmers",
			"intermediate_profession": "Intermediate professions",
			"merchant": "Craftsmen, traders and business leaders",
			"no_occupation": "Other people without occupation",
			"retirees": "retirees",
			"upper_manager": "Executives and higher intellectual professions",
			"worker": "Workers"
		},
		"offertype": {
			"types": {
				"private": "private offer",
				"promotion": "Promotional offer",
				"public": "public offer"
			}
		},
		"phone": {
			"error": "This number is invalid"
		},
		"portfolio": {
			"labels": {
				"picture": "Photo",
				"video": "Video"
			},
			"video": {
				"button": "Add",
				"text": "You can add a video from YouTube or Vimeo",
				"url": "video uRL"
			}
		},
		"services": {
			"services": {
				"advertising": "Online Advertising",
				"audit": "Audit, Consulting and Education",
				"course": "Courses, Training, Orientation",
				"design": "Graphics and Design",
				"development": "Web development",
				"documents": "Production of Documents",
				"marketing": "Web marketing",
				"other": "Other",
				"other_service": "office visit",
				"receipe": "Recipes and Diet",
				"remote": "Remote service",
				"tourism": "teleconsultation"
			}
		},
		"servicetype": {
			"services": {
				"availability": "Consultation by chat",
				"mail": "Written consultation",
				"prepaid_minute": "Consultation by telephone",
				"product": "digital product",
				"service": "miscellaneous services"
			}
		},
		"timezone": {
			"timezones": {
				"Abu Dhabi": "(GMT + 04: 00) Abu Dhabi",
				"Adelaide": "(GMT + 09: 30) Adelaide",
				"Alaska": "(GMT-09: 00) Alaska",
				"Almaty": "(GMT + 06: 00) Almaty",
				"American Samoa": "(GMT-11: 00) American Samoa",
				"Amsterdam": "(GMT + 01: 00) Amsterdam",
				"Arizona": "(GMT-07: 00) Arizona",
				"Astana": "(GMT + 06: 00) Astana",
				"Athens": "(GMT + 02: 00) Athens",
				"Atlantic Time (Canada)": "(GMT-04: 00) Atlantic Time (Canada)",
				"Auckland": "(GMT + 12: 00) Auckland",
				"Azores": "(GMT-01: 00) Azores",
				"Baghdad": "(GMT + 03: 00) Baghdad",
				"Baku": "(GMT + 04: 00) Baku",
				"Bangkok": "(GMT + 07: 00) Bangkok",
				"Beijing": "(GMT + 08: 00) Beijing",
				"Belgrade": "(UTC + 01: 00) Belgrade",
				"Berlin": "(GMT + 01: 00) Berlin",
				"Bern": "(UTC + 01: 00) Bern",
				"Bogota": "(GMT-05: 00) Bogota",
				"Brasilia": "(GMT-03: 00) Brasilia",
				"Bratislava": "(UTC + 01: 00) Bratislava",
				"Brisbane": "(GMT + 10: 00) Brisbane",
				"Brussels": "(UTC + 01: 00) Brussels",
				"Bucharest": "(GMT + 02: 00) Bucharest",
				"Budapest": "(UTC + 01: 00) Budapest",
				"Buenos Aires": "(GMT-03: 00) Buenos Aires",
				"Cairo": "(GMT + 02: 00) Cairo",
				"Canberra": "(GMT + 10: 00) Canberra",
				"Cape Verde Is": [
					"(GMT-01: 00) Cape Verde Is."
				],
				"Caracas": "(GMT-04: 00) Caracas",
				"Casablanca": "(GMT + 00: 00) Casablanca",
				"Central America": "(GMT-06: 00) Central America",
				"Central Time (US & Canada)": "(GMT-06: 00) Central Time (US & Canada)",
				"Chatham Is": [
					"(GMT + 12: 45) Chatham Is."
				],
				"Chennai": "(GMT + 05: 30) Chennai",
				"Chihuahua": "(GMT-07: 00) Chihuahua",
				"Chongqing": "(GMT + 08: 00) Chongqing",
				"Copenhagen": "(UTC + 01: 00) Copenhagen",
				"Darwin": "(GMT + 09: 30) Darwin",
				"Dhaka": "(GMT + 06: 00) Dhaka",
				"Dublin": "(GMT + 00: 00) Dublin",
				"Eastern Time (US & Canada)": "(GMT-05: 00) Eastern Time (US & Canada)",
				"Edinburgh": "(GMT + 00: 00) Edinburgh",
				"Ekaterinburg": "(GMT + 05: 00) Ekaterinburg",
				"Fiji": "(GMT + 12: 00) Fiji",
				"Georgetown": "(GMT-04: 00) Georgetown",
				"Greenland": "(GMT-03: 00) Greenland",
				"Guadalajara": "(GMT-06: 00) Guadalajara",
				"Guam": "(GMT + 10: 00) Guam",
				"Hanoi": "(GMT + 07: 00) Hanoi",
				"Harare": "(GMT + 02: 00) Harare",
				"Hawaii": "(GMT-10: 00) Hawaii",
				"Helsinki": "(GMT + 02: 00) Helsinki",
				"Hobart": "(GMT + 10: 00) Hobart",
				"Hong Kong": "(GMT + 08: 00) Hong Kong",
				"Indiana (East)": "(GMT-05: 00) Indiana (East)",
				"International Date Line West": "(GMT-11: 00) International Date Line West",
				"Irkutsk": "(GMT + 08: 00) Irkutsk",
				"Islamabad": "(GMT + 05: 00) Islamabad",
				"Istanbul": "(GMT + 02: 00) Istanbul",
				"Jakarta": "(GMT + 07: 00) Jakarta",
				"Jerusalem": "(GMT + 02: 00) Jerusalem",
				"Kabul": "(GMT + 04: 30) Kabul",
				"Kamchatka": "(GMT + 12: 00) Kamchatka",
				"Karachi": "(GMT + 05: 00) Karachi",
				"Kathmandu": "(GMT + 05: 45) Kathmandu",
				"Kolkata": "(GMT + 05: 30) Kolkata",
				"Krasnoyarsk": "(GMT + 07: 00) Krasnoyarsk",
				"Kuala Lumpur": "(GMT + 08: 00) Kuala Lumpur",
				"Kuwait": "(GMT + 03: 00) Kuwait",
				"Kyiv": "(GMT + 02: 00) Kyiv",
				"La Paz": "(GMT-04: 00) La Paz",
				"Lima": "(GMT-05: 00) Lima",
				"Lisbon": "(GMT + 00: 00) Lisbon",
				"Ljubljana": "(UTC + 01: 00) Ljubljana",
				"London": "(GMT + 00: 00) London",
				"Madrid": "(UTC + 01: 00) Madrid",
				"Magadan": "(GMT + 11: 00) Magadan",
				"Marshall Is": [
					"(GMT + 12: 00) Marshall Is."
				],
				"Mazatlan": "(GMT-07: 00) Mazatlan",
				"Melbourne": "(GMT + 10: 00) Melbourne",
				"Mexico City": "(GMT-06: 00) Mexico City",
				"Mid-Atlantic": "(GMT-02: 00) Mid-Atlantic",
				"Midway Island": "(GMT-11: 00) Midway Island",
				"Minsk": "(GMT + 03: 00) Minsk",
				"Monrovia": "(GMT + 00: 00) Monrovia",
				"Monterrey": "(GMT-06: 00) Monterrey",
				"Montevideo": "(GMT-03: 00) Montevideo",
				"Moscow": "(GMT + 03: 00) Moscow",
				"Mountain Time (US & Canada)": "(GMT-07: 00) Mountain Time (US & Canada)",
				"Mumbai": "(GMT + 05: 30) Mumbai",
				"Muscat": "(GMT + 04: 00) Muscat",
				"Nairobi": "(GMT + 03: 00) Nairobi",
				"New Caledonia": "(GMT + 11: 00) New Caledonia",
				"New Delhi": "(GMT + 05: 30) New Delhi",
				"Newfoundland": "(GMT-03: 0-30) Newfoundland",
				"Novosibirsk": "(GMT + 07: 00) Novosibirsk",
				"Nuku'alofa": "(GMT +13: 00) Nuku'alofa",
				"Osaka": "(GMT + 09: 00) Osaka",
				"Pacific Time (US & Canada)": "(GMT-08: 00) Pacific Time (US & Canada)",
				"Paris": "(GMT + 01: 00) Paris",
				"Perth": "(GMT + 08: 00) Perth",
				"Port Moresby": "(GMT + 10: 00) Port Moresby",
				"Prague": "(GMT + 01: 00) Prague",
				"Pretoria": "(GMT + 02: 00) Pretoria",
				"Quito": "(GMT-05: 00) Quito",
				"Rangoon": "(GMT + 06: 30) Rangoon",
				"Riga": "(GMT + 02: 00) Riga",
				"Riyadh": "(GMT + 03: 00) Riyadh",
				"Rome": "(GMT + 01: 00) Rome",
				"Samoa": "(GMT + 13: 00) Samoa",
				"Santiago": "(GMT-04: 00) Santiago",
				"Sapporo": "(GMT + 09: 00) Sapporo",
				"Sarajevo": "(UTC + 01: 00) Sarajevo",
				"Saskatchewan": "(GMT-06: 00) Saskatchewan",
				"Seoul": "(GMT + 09: 00) Seoul",
				"Singapore": "(GMT + 08: 00) Singapore",
				"Skopje": "(UTC + 01: 00) Skopje",
				"Sofia": "(GMT + 02: 00) Sofia",
				"Solomon Is": [
					"(GMT + 11: 00) Solomon Is."
				],
				"Sri Jayawardenepura": "(GMT + 05: 30) Sri Jayawardenepura",
				"St": {
					" Petersburg": "(GMT + 03: 00) St. Petersburg"
				},
				"Stockholm": "(GMT + 01: 00) Stockholm",
				"Sydney": "(GMT + 10: 00) Sydney",
				"Taipei": "(GMT + 08: 00) Taipei",
				"Tallinn": "(GMT + 02: 00) Tallinn",
				"Tashkent": "(GMT + 05: 00) Tashkent",
				"Tbilisi": "(GMT + 04: 00) Tbilisi",
				"Tehran": "(GMT + 03: 30) Tehran",
				"Tijuana": "(GMT-08: 00) Tijuana",
				"Tokelau Is": [
					"(GMT + 13: 00) Tokelau Is."
				],
				"Tokyo": "(GMT + 09: 00) Tokyo",
				"UTC": "(GMT + 00: 00) UTC",
				"Ulaanbaatar": "(GMT + 08: 00) Ulaanbaatar",
				"Urumqi": "(GMT + 06: 00) Urumqi",
				"Vienna": "(UTC + 01: 00) Vienna",
				"Vilnius": "(GMT + 02: 00) Vilnius",
				"Vladivostok": "(GMT + 10: 00) Vladivostok",
				"Volgograd": "(GMT + 03: 00) Volgograd",
				"Warsaw": "(UTC + 01: 00) Warsaw",
				"Wellington": "(GMT + 12: 00) Wellington",
				"West Central Africa": "(GMT + 01: 00) West Central Africa",
				"Yakutsk": "(GMT + 09: 00) Yakutsk",
				"Yerevan": "(GMT + 04: 00) Yerevan",
				"Zagreb": "(UTC + 01: 00) Zagreb"
			}
		},
		"weekday": {
			"wday": [
				"Sunday",
				"On Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		}
	},
	"invitationform": {
		"labels": {
			"email": "E-mail",
			"password": "Password"
		},
		"hints": {
			"password": "Keep empty to automatically send an invite"
		},
		"submit": "Invite",
		"text": "Enter the email address of your new expert and celu ... r which he can connect and join your team",
		"title": "Invite a new expert"
	},
	"linkcreation": {
		"save": "Save",
		"title": "title",
		"url": "url"
	},
	"messenger": {
		"actions": {
			"createappointment": {
				"labels": {
					"day": "Day of appointment",
					"hour": "Appointment Time",
					"message": "Message"
				},
				"message": "Click the link below to accept an appointment with {nickname}",
				"next": "following",
				"select": "Share",
				"submit": "Share",
				"title": {
					"day": "Day",
					"default": "Suggest a meeting",
					"hour": "Hour",
					"message": "Message"
				}
			},
			"fileupload": {
				"labels": {
					"file": "Select my file"
				},
				"submit": "To send",
				"title": "Send a file"
			},
			"shareoffer": {
				"labels": {
					"message": "Message",
					"scope": "Type of offer"
				},
				"next": "following",
				"scopes": {
					"private": "private",
					"promotion": "Specials",
					"public": "public"
				},
				"select": "Share",
				"submit": "Share",
				"title": {
					"default": "Offering Sharing",
					"kind": "Type of offer",
					"message": "Message",
					"offer": "Offer"
				}
			},
			"sharepage": {
				"labels": {
					"message": "Message",
					"scope": "Category"
				},
				"next": "following",
				"select": "Share",
				"submit": "Share",
				"title": {
					"default": "Share a page",
					"kind": "Category",
					"message": "Message",
					"page": "Page"
				}
			}
		},
		"conversations": {
			"title": "Send a message"
		},
		"menu": {
			"actions": {
				"appointment": "Send appointments",
				"page": "Share a page",
				"share": "Share Offer",
				"upload": "Send a file"
			}
		},
		"more": "load more",
		"previews": {
			"offer": {
				"action": "See"
			}
		}
	},
	"minutegiftform": {
		"card": "Take my card",
		"labels": {
			"minutes": "Number of minutes",
			"reason": "Reason"
		},
		"offer": "To offer",
		"submit": "Give {minutes} minute (s) for {price} EUR",
		"text": "You are about to offer {minutes} minute (s) {price} EUR / min",
		"title": "Provide call minutes"
	},
	"outcometable": {
		"header": {
			"amount": "Price",
			"date": "Payment date",
			"id": "id",
			"status": "Status"
		}
	},
	"pages": {
		"account": {
			"tabs": {
				"bank": "Bank",
				"informations": "information",
				"profile": "Profile",
				"schedule": "Hours"
			}
		},
		"accounting": {
			"title": "Accounts"
		},
		"customization": {
			"addLink": "Add a link",
			"labels": {
				"color": {
					"primary": "main color",
					"secondary": "secondary color"
				},
				"favicon": "Favicon for your site",
				"feedbacks": "View Guest Reviews",
				"logo": "Your logo",
				"removePic": "Remove"
			},
			"links": "links footer",
			"save": "Save",
			"style": "Configure style"
		},
		"dashboard": {
			"title": {
				"availability": "Cat",
				"current": "In progress",
				"default": "My tasks",
				"mail": "mails",
				"pending": "Waiting",
				"phone": "call",
				"service": "Services"
			}
		},
		"expert": {
			"tabs": {
				"profile": "Profile",
				"purchases": "Features",
				"schedule": "Hours",
				"connection": "Connection"
			}
		},
		"expertgains": {
			"title": "Earnings"
		},
		"feedbacks": {
			"accepted": "accepted",
			"empty": "no opinion",
			"pending": "waiting",
			"rejected": "rejected"
		},
		"forgotpassword": {
			"labels": {
				"email": "E-mail",
				"platformName": "Url of your platform"
			},
			"login": "To log in",
			"reset": "Email instructions",
			"success": "An email was sent to you",
			"title": "Forgot your password"
		},
		"invitation": {
			"labels": {
				"confirmation": "Password Confirmation",
				"password": "Password",
				"terms": "Accept the Terms and the Privacy Policy"
			},
			"privacy": "Privacy Policy",
			"submit": "Accept",
			"terms": "Terms of use",
			"title": "Accept your invitation"
		},
		"login": {
			"forgotPassword": "Forgot your password",
			"labels": {
				"email": "E-mail",
				"password": "Password",
				"platformName": "url"
			},
			"login": "To log in",
			"title": "To log in"
		},
		"messengerwelcome": {
			"select": "Please select a conversation"
		},
		"notfound": {
			"text": "page nonexistent",
			"title": "404"
		},
		"platformrevenues": {
			"title": "Turnover"
		},
		"platformtraffic": {
			"title": "Site Information"
		},
		"purchases": {
			"title": "Shopping"
		},
		"resetpassword": {
			"forgot": "Resend the email",
			"labels": {
				"confirmation": "Password Confirmation",
				"password": "New Password"
			},
			"login": "To log in",
			"passwordTokenError": "Your code is not good, please send a new email",
			"submit": "change my password",
			"title": "Change my password pass"
		},
		"servicecreation": {
			"title": "Creating a Quotation"
		},
		"serviceedition": {
			"title": "Edition - {title}"
		},
		"setup": {
			"labels": {
				"birthday": "Date of Birth",
				"category": "Category",
				"firstName": "First name",
				"lastName": "Last name",
				"phone": "Phone number"
			},
			"submit": "safeguard",
			"title": "My information"
		},
		"statistics": {
			"average": "Average time",
			"call": "call",
			"chat": "cats",
			"collector": "Money collector",
			"email": "emails",
			"expert": "Expert",
			"gains": "Earnings",
			"minMax": "Min / max",
			"price_average": "average purchase price",
			"price_minute": "Price per minute",
			"product": "products",
			"service": "Services",
			"sum": "Total minutes",
			"title": "Statistics",
			"total": "Total calls"
		},
		"subscription": {
			"card": "My debit card",
			"cardDetails": "You use the card {alias} expires {month} / {year}",
			"current": "current plan",
			"next": "next payment",
			"noCard": "You do not have cards for your collection",
			"title": "My subscription",
			"updateCard": "Update my card"
		},
		"subscriptionpayment": {
			"inProgress": "Payment in progress",
			"pay": "Pay my subscription"
		},
		"team": {
			"header": {
				"actions": "Ranking",
				"email": "E-mail",
				"nickname": "Pseudo",
				"role": "Status"
			},
			"noDataText": "No expert",
			"noResultsText": "Some experts found",
			"roles": {
				"active": "Active",
				"inactive": "Inactive",
				"restricted": "narrow"
			},
			"title": "My team"
		},
		"teamavailabilities": {
			"average": "Average expert",
			"days": [
				"Sunday",
				"On Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			],
			"max": "Maximum per expert",
			"perDay": "Day",
			"perWeek": "Week",
			"title": "Availability of the team",
			"today": "total today"
		},
		"transfers": {
			"title": "my transfers"
		},
		"user": {
			"tabs": {
				"profile": "Profile",
				"purchases": "Features",
				"statistics": "Statistics"
			}
		},
		"users": {
			"search": "Search",
			"selected": "selectednext user | selected users",
			"title": "users"
		}
	},
	"purchase": {
		"appointment": {
			"accept": "Accepting the appointment",
			"refund": "Cancel appointment"
		},
		"availability": {
			"start": "Start Chat",
			"stop": "Stop"
		},
		"call": {
			"callee": "User",
			"caller": "Expert",
			"debug": "Details",
			"download": "Download the call",
			"downloadStart": "Your download will begin, this can take a few seconds before the download begins",
			"duration": "Call time",
			"error": "error occurred",
			"hangup": "To hang up",
			"hangupText": "To use this button make sure your phone ... tatus on the platform is always \"In consultation \"",
			"informations": "Information on Call",
			"none": "-",
			"pricePerMin": "Estimated price per minute",
			"starts": "Call date",
			"status": {
				"busy": "Busy",
				"canceled": "Canceled",
				"completed": "Finished",
				"failed": "Mistake",
				"in-progress": "In progress",
				"no-answer": "No answer",
				"queued": "During a call",
				"ringing": "During a call"
			},
			"statusLabel": "Status of the call",
			"timeLimit": "Maximum duration of call"
		},
		"callplayer": {
			"error": "No audio files associated",
			"title": "Heeding the Call"
		},
		"mail": {
			"accept": "Accept",
			"request": "Question:",
			"response": "Reply :",
			"responseForm": "Your answer"
		},
		"messageform": {
			"labels": {
				"content": "Reply",
				"title": "title"
			},
			"save": "Answer and end"
		},
		"refund": {
			"reason": "Describe a reason",
			"refund": "Cancel and refund",
			"refundText": "By canceling this service the customer will be refunded the purchase"
		},
		"service": {
			"accept": "Accept",
			"request": "Request :",
			"response": "Reply :",
			"responseForm": "Your answer"
		},
		"table": {
			"header": {
				"expert": "Expert",
				"fees": "Fresh",
				"id": "id",
				"offer": "Offer",
				"payedAt": "Payment date",
				"price": "Price",
				"total": "Total",
				"user": "Customer"
			},
			"noDataText": {
				"availability": "No cats",
				"default": "No shopping",
				"mail": "No emails",
				"phone": "No appeals",
				"prepaid_minute": "No packages",
				"product": "No product",
				"service": "No services"
			},
			"noResultsText": {
				"availability": "no cats",
				"default": "no purchases",
				"mail": "no emails",
				"phone": "no calls",
				"prepaid_minute": "no packages",
				"product": "Auncuns products",
				"service": "no services"
			},
			"rowsPerPageText": {
				"availability": "Cats per page",
				"default": "Purchases by page",
				"mail": "Emails per page",
				"phone": "Calls per page",
				"prepaid_minute": "Packages per page",
				"product": "Products by page",
				"service": "Services per page"
			},
			"scopes": {
				"all": "#VALUE!",
				"current": "In progress",
				"finished": "completed",
				"finished_with_cash_received_or_failed": "paid or stranded",
				"payed": "paid",
				"pending": "waiting",
				"refunded": "refunded",
				"with_cash_received": "paid"
			}
		},
		"title": {
			"appointment": "Appointment",
			"call": "call",
			"callStatus": {
				"busy": "Call busy with corresponding",
				"canceled": "call canceled",
				"error": "Call with error: {error}",
				"failed": "Call with error: {error}",
				"in-progress": "Call in progress",
				"no-answer": "Call not answered"
			},
			"perMin": "/ min"
		}
	},
	"refundedtag": {
		"refunded": "Canceled"
	},
	"service": {
		"actions": {
			"copy": "link copied",
			"edit": "Update"
		},
		"form": {
			"confirmDeletion": "Are you sure ?",
			"delete": "Remove",
			"errors": {
				"minutes": "The price of one minute must be at least {price} cents per minute"
			},
			"labels": {
				"availability--availabilityType": "Room Type",
				"availability--duration": "duration",
				"description": "Job description",
				"experts": "Experts béneficiant this offer",
				"expire": "Expiration date",
				"keywords": "Key word (separated by commas)",
				"mail--responseDelay": "Reply duration",
				"mail--wordCount": "Minimum number of words",
				"maxUserPurchase": "Maximum number of purchases per user (0 = unlimited)",
				"offerType": "Type of offer",
				"picture": "Image sharing",
				"portfolio": "portfolio",
				"prepaidMinute--minutes": "Number of minutes",
				"price": "Offer price",
				"product--message": "Message after purchasing your product",
				"service--responseDelay": "Reply duration",
				"service--serviceType": "Type of service",
				"serviceType": "Type of offer",
				"shortDescription": "Short description of the offer",
				"subtitle": "Subtitle supply (useful for sharing)",
				"title": "Title of your offer"
			},
			"save": "Save"
		},
		"meta": {
			"availability": "Cat",
			"mail": "Mail",
			"options": {
				"availability_type": "{value}",
				"days": "{value} day (s)",
				"duration": "{value} minute (s)",
				"hours": "{value} hour (s)",
				"minutes": "{value} minute (s)",
				"service_type": "{value}",
				"word_count": "{value} password (s)"
			},
			"phone": "Call",
			"prepaid_minute": "Flat rate",
			"product": "Product",
			"service": "Service",
			"services": {
				"advertising": "Online Advertising",
				"audit": "Audit, Consulting and Education",
				"course": "Courses, Training, Orientation",
				"design": "Graphics and Design",
				"development": "Web development",
				"documents": "Production of Documents",
				"marketing": "Web marketing",
				"other": "Other",
				"other_service": "office visit",
				"receipe": "Recipes and Diet",
				"remote": "Remote service",
				"tourism": "teleconsultation"
			}
		}
	},
	"sharecard": {
		"networks": {
			"facebook": "Facebook",
			"googleplus": "Google+",
			"linkedin": "LinkedIn",
			"twitter": "Twitter"
		}
	},
	"smartlink": {
		"add": "Add",
		"icon": "Icon",
		"save": "Save",
		"title": "title",
		"url": "URLs"
	},
	"transfer": {
		"addBank": "Update",
		"hints": {
			"amount": "Maximum € 2500 per transfer"
		},
		"labels": {
			"amount": "Transfer amount",
			"reference": "Reference"
		},
		"missingText": "You do not have information your bank information",
		"submit": "Transfer money",
		"text": "Transfer my money on my account {iban}",
		"title": "Transfer"
	},
	"transfertable": {
		"header": {
			"amount": "Price",
			"date": "Dated",
			"status": "state"
		},
		"noDataText": "No transfers",
		"noResultsText": "no transfers",
		"rowsPerPageText": "Transfers per page",
		"status": {
			"CREATED": "Waiting",
			"FAILED": "Failed",
			"SUCCEEDED": "Finished"
		}
	},
	"user": {
		"form": {
			"labels": {
				"email": "E-mail",
				"password": "Password",
				"passwordConfirmation": "Password Confirmation",
				"sendEmail": "Notify user"
			},
			"save": "Create"
		},
		"header": {
			"lock": "Block",
			"lockreason": "Due to the blockage",
			"messenger": "Send a message",
			"minute_gift": "Provide minutes",
			"more": "More",
			"risk": "enable monitoring",
			"riskreason": "Due to this change",
			"unlock": "unblock",
			"unlockreason": "Reason déblockage",
			"unrisk": "disable monitoring",
			"unriskreason": "Due to this change"
		},
		"import": {
			"labels": {
				"sendEmail": "Notify user"
			},
			"save": "Import"
		},
		"profile": {
			"item": {
				"createdAt": "account created",
				"email": "E-mail",
				"firstName": "First name",
				"lastConnection": "last connection",
				"lastName": "Last name",
				"lockedAt": "Blocked account",
				"minutes": "minutes remaining",
				"nickname": "Pseudo",
				"phone": "Phone",
				"riskyAt": "Monitor enabled"
			},
			"none": "-",
			"note": "Notes on the user",
			"save": "Save my notes",
			"subtitles": {
				"activity": "Activity",
				"contact": "Contact information",
				"other": "Other information",
				"personal": "Personal informations"
			}
		},
		"purchases": {
			"title": "completed services"
		},
		"search": {
			"clear": "Remove",
			"labels": {
				"email_cont": "E-mail",
				"first_name_cont": "First name",
				"last_name_cont": "Last name",
				"locked": "Only blocked users",
				"nickname_cont": "Pseudo",
				"phone_cont": "Phone number",
				"risky_at": "Only users risky"
			},
			"submit": "Search"
		},
		"statistics": {
			"purchaseHistory": "Purchase history",
			"purchasesAmount": "total spent",
			"purchasesAverage": "average purchase price",
			"purchasesTotal": "Shopping",
			"rates": "Notices given",
			"ratesAverage": "Average opinion",
			"ratesPending": "Waiting Notification"
		},
		"table": {
			"header": {
				"created_at": "Joined",
				"current_sign_in_at": "last connection",
				"email": "E-mail",
				"first_name": "First name",
				"last_name": "Last name",
				"nickname": "Pseudo",
				"payed_purchases_sum": "Spent",
				"phone_seconds_available": "Minutes"
			},
			"noDataText": "No users",
			"noResultsText": "some users",
			"rowsPerPageText": "Users per page",
			"selected": "selectednext user | selected users",
			"send": "Send a message",
			"sendToAll": "Message to all",
			"title": "users"
		}
	},
	"usermenu": {
		"actions": "stock",
		"addUser": "Add User",
		"export": "Export Users",
		"exportStarted": "Your export is in progress, you will receive an email once the export is complete",
		"import": "Upload users",
		"send": "Send a message",
		"sendToAll": "Message to all"
	},
	"wallet": {
		"title": "money available",
		"transfer": "To transfer"
	}
};

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(11);


var AVAILABLE_SCOPES = ['public', 'promotion', 'private'];

var OFFER_TYPES = ['prepaid_minute', 'mail', 'service', 'product', 'availability'];

var isOfferScope = function isOfferScope(scope) {
  return AVAILABLE_SCOPES.indexOf(scope) >= 0;
};

var isContentScope = function isContentScope(scope) {
  return !isOfferScope(scope);
};

var isOfferType = function isOfferType(type) {
  return OFFER_TYPES.indexOf(type) >= 0;
};

var fetchAll = function fetchAll(_ref) {
  var scope = _ref.scope;

  if (isOfferScope(scope)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().get('/' + scope + '_offers');
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().get('/custom_offers/' + scope);
  }
};

var get = function get(_ref2) {
  var id = _ref2.id;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().get('/offers/' + id);
};

var update = function update(_ref3) {
  var id = _ref3.id,
      data = _ref3.data;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().put('/offers/' + id, data);
};

var create = function create(_ref4) {
  var data = _ref4.data;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().post('/offers', data);
};

var remove = function remove(_ref5) {
  var id = _ref5.id;
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* default */])().delete('/offers/' + id);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  AVAILABLE_SCOPES: AVAILABLE_SCOPES,
  OFFER_TYPES: OFFER_TYPES,
  isOfferScope: isOfferScope,
  isContentScope: isContentScope,
  isOfferType: isOfferType,
  fetchAll: fetchAll,
  get: get,
  update: update,
  create: create,
  remove: remove
});

/***/ })

},[370]);


// WEBPACK FOOTER //
// static/js/app.c463260c3d3e6bcd53a9.js